export default {
  translation: {

    // App
    'apartment_system': 'Wohnungsverwaltungssystem',
    'apartment_management': 'Wohnungsverwaltung',
    'building_management': 'Gebäudeverwaltung',

    // Navigation - updated
    'dashboard': 'Dashboard',
    'user_management': 'Benutzerverwaltung',
    'building_management': 'Gebäudeverwaltung',
    'apartment_management': 'Wohnungsverwaltung',
    'owner_management': 'Eigentümerverwaltung',
    'tenant_management': 'Mieterverwaltung',
    'payment_management': 'Zahlungsverwaltung',
    'service_management': 'Dienstleistungsverwaltung',
    'report_management': 'Berichte & Analysen',
    'log_management': 'Aktivitätsprotokolle',

    // Buildings
    'buildings': 'Gebäude',
    'building_list': 'Gebäudeliste',
    'switch_building': 'Gebäude wechseln',
    'add_building': 'Gebäude hinzufügen',
    'edit_building': 'Gebäude bearbeiten',
    'building_details': 'Gebäudedetails',
    'building_name': 'Gebäudename',
    'building_address': 'Adresse',
    'total_floors': 'Gesamtanzahl Etagen',
    'total_apartments': 'Gesamtanzahl Wohnungen',

    // Apartments (renamed from Properties)
    'apartments': 'Wohnungen',
    'apartment_list': 'Wohnungsliste',
    'add_apartment': 'Wohnung hinzufügen',
    'add_your_first_apartment': 'Fügen Sie Ihre erste Wohnung hinzu',
    'edit_apartment': 'Wohnung bearbeiten',
    'apartment_details': 'Wohnungsdetails',
    'apartment_number': 'Wohnungsnummer',
    'apartment_display': 'Zimmer {{number}}',
    'apt': 'Whg',
    'floor_number': 'Etagen-Nummer',
    'floor_display': 'Etage {{number}}',
    'monthly_rent': 'Monatliche Miete',
    'apartment_status': 'Status',
    'vacant': 'Leerstehend',
    'occupied': 'Vermietet',
    'under_maintenance': 'In Wartung',
    'key_status': 'Schlüsselstatus',
    'at_office': 'Im Büro',
    'with_tenant': 'Beim Mieter',
    'with_maintenance': 'In Wartung',
    'lost': 'Verloren',
    'key_handover': 'Schlüsselübergabe',
    'give_out_keys': 'Schlüssel ausgeben',
    'return_keys': 'Schlüssel zurückgeben',
    'keys': 'Schlüssel',
    'remotes': 'Fernbedienungen',
    'fobs': 'Chips / Fobs',
    'possession_date': 'Besitztumsdatum',
    'key_details': 'Schlüsseldetails',
    'key_history': 'Schlüsselverlauf',
    'record_handover': 'Übergabe aufzeichnen',
    'confirm_and_record': 'Übergabe bestätigen',
    'add_notes': 'Zusätzliche Notizen hier hinzufügen...',
    'no_key_history': 'Keine Schlüsselübergabe-Historie gefunden.',
    'loading_history': 'Historie wird geladen...',
    'by': 'von',
    'warning_handover_no_tenant': 'Übergabe wird ohne zugeordneten Mieter aufgezeichnet.',
    'key_handover_success': 'Schlüsselübergabe erfolgreich aufgezeichnet',
    'failed_to_record_handover': 'Fehler beim Aufzeichnen der Schlüsselübergabe',
    'failed_to_load_history': 'Fehler beim Laden der Schlüssel-Historie',
    'key_management': 'Schlüsselverwaltung',
    'manage_keys': 'Schlüssel verwalten',
    'total_handovers': 'Gesamt Ereignisse',
    'given_out': 'Ausgegeben',
    'returned': 'Zurückgegeben',
    'currently_out': 'Aktuell Draußen',

    // Services
    'services': 'Dienstleistungen',
    'service_payments': 'Servicezahlungen',
    'generate_services': 'Servicezahlungen generieren',
    'service_statistics': 'Servicestatistiken',
    'service_type': 'Serviceart',
    'service_amount': 'Betrag',
    'service_date': 'Servicedatum',
    'service_status': 'Zahlungsstatus',
    'service_paid': 'Bezahlt',
    'service_unpaid': 'Unbezahlt',
    'total_service_fees': 'Gesamte Servicegebühren',

    // Reports - updated
    'revenue_report': 'Umsatzbericht',
    'payment_logs': 'Zahlungsprotokolle',
    'occupancy_report': 'Belegungsbericht',
    'monthly_payments_report': 'Monatlicher Zahlungsbericht',
    'monthly_payments_subtitle': 'Konsolidierte Ansicht der Mieter- und Servicezahlungen',
    'all_paid': 'Alles bezahlt',
    'try_adjusting_filters': 'Versuchen Sie, den Monat, das Jahr oder die Filter anzupassen',
    'pending': 'Ausstehend',
    'total': 'Gesamt',
    'print_receipt': 'Quittung drucken',
    'monthly_revenue': 'Monatlicher Umsatz',
    'building_revenue': 'Gebäudeumsatz',
    'owner_revenue': 'Eigentümerumsatz',
    'paid_until': 'Bezahlt bis',
    'tenant_payments': 'Zahlungsstatus der Mieter',
    'next_billing_date': 'Nächstes Rechnungsdatum',
    'current_tenant': 'Aktueller Mieter',
    'future_tenant_upcoming': 'Zukünftiger Mieter',

    // Logs
    'activity_logs': 'Aktivitätsprotokolle',
    'all_user_activities': 'Alle Benutzeraktivitäten',
    'all_user_activities_desc': 'Alle Benutzeraktivitäten und Änderungen anzeigen',
    'tenant_logs': 'Mieterverlauf',
    'tenant_activity_desc': 'Alle mieterbezogenen Aktivitäten anzeigen',
    'revenue_by_user': 'Umsatz nach Benutzer',
    'monthly_revenue_by_user': 'Monatlicher Umsatz nach Benutzer',
    'revenue_breakdown_desc': 'Umsatzaufschlüsselung nach Benutzer für einen bestimmten Monat anzeigen',
    'time': 'Zeit',
    'entity': 'Entität',
    'details': 'Details',
    'amount': 'Betrag',
    'search_logs': 'Logs durchsuchen...',
    'filter_activities': 'Aktivitäten filtern',
    'action_type': 'Aktionstyp',
    'entity_type': 'Entitätstyp',
    'apply_filter': 'Filter anwenden',
    'entries': 'Einträge',
    'no_logs_matching_search': 'Keine Logs gefunden, die Ihren Suchkriterien entsprechen',
    'no_logs_available': 'Keine Aktivitätsprotokolle verfügbar',
    'showing_range': 'Anzeige {{start}} bis {{end}} von {{total}} Einträgen',
    'select_month': 'Monat auswählen',
    'payment_count': 'Anzahl der Zahlungen',
    'total_amount': 'Gesamtbetrag',
    'percentage': 'Prozentsatz',
    'no_revenue_data': 'Keine Umsatzdaten für diesen Monat verfügbar',
    'january': 'Januar',
    'february': 'Februar',
    'march': 'März',
    'april': 'April',
    'may': 'Mai',
    'june': 'Juni',
    'july': 'Juli',
    'august': 'August',
    'september': 'September',
    'october': 'Oktober',
    'november': 'November',
    'december': 'Dezember',
    'notification_log': 'Benachrichtigungsprotokoll',
    'all_notifications': 'Alle Benachrichtigungen',
    'all_channels': 'Alle Kanäle',
    'all_statuses': 'Alle Status',
    'all_recipients': 'Alle Empfänger',
    'sent_at': 'Gesendet am',
    'template_subject': 'Vorlage / Betreff',
    'email_templates': 'E-Mail-Vorlagen',
    'active_templates_count_one': 'Eine aktive Vorlage',
    'active_templates_count_other': '{{count}} aktive Vorlagen',
    'new_template': 'Neue Vorlage',
    'test_email_placeholder': 'Test-E-Mail-Adresse (wird für alle Test-Senden-Buttons verwendet)',
    'no_email_templates': 'Noch keine E-Mail-Vorlagen vorhanden',
    'create_first_template': 'Erste Vorlage erstellen',
    'rent_due': 'Miete fällig',
    'late_payment': 'Zahlungsverzug',
    'lease_renewal': 'Mietvertragsverlängerung',
    'lease_expiry': 'Mietvertragsablauf',
    'move_in': 'Einzug',
    'move_out': 'Auszug',
    'violation': 'Verstoß',
    'maintenance': 'Wartung',
    'inspection': 'Inspektion',
    'owner_payout': 'Eigentümerauszahlung',
    'email_template_form_desc': 'Entwerfen Sie automatisierte E-Mails für Ihre Mieter und Eigentümer',
    'update_template': 'Vorlage aktualisieren',
    'create_template': 'Vorlage erstellen',
    'visual': 'Visuell',
    'html': 'HTML',
    'live_preview': 'Live-Vorschau',
    'subject_line': 'Betreffzeile',
    'email_content': 'E-Mail-Inhalt',
    'event_trigger': 'Ereignisauslöser',
    'internal_name': 'Interner Name',
    'dynamic_tags': 'Dynamische Tags',
    'starter_templates': 'Starter-Vorlagen',
    'starter_templates_desc': 'Wählen Sie eine Basis, um schneller mit dem Design zu beginnen',
    'apply_design': 'Design anwenden',
    'payment_settings': 'Zahlungseinstellungen',
    'accept_online_payments': 'Online-Zahlungen akzeptieren',
    'stripe_connect_desc': 'Verbinden Sie Ihr Stripe-Konto, damit Mieter die Miete direkt über das Portal bezahlen können. Die Gelder werden direkt auf Ihr Bankkonto eingezahlt, und unser System verfolgt alles automatisch.',
    'why_stripe_connect': 'Warum Stripe Connect verwenden?',
    'stripe_benefit_1': 'Automatisierte Mieteinziehung & Verfolgung',
    'stripe_benefit_2': 'Direkte Einzahlungen auf Ihr Bankkonto',
    'stripe_benefit_3': 'Sichere PCI-konforme Verarbeitung',
    'stripe_benefit_4': 'Unterstützung für Plattformgebühren-Splitting',
    'start_stripe_onboarding': 'Stripe-Onboarding starten',
    'stripe_account_status': 'Stripe-Kontostatus',
    'active_verified': 'Aktiv & Verifiziert',
    'pending_onboarding': 'Aktion erforderlich: Ausstehendes Onboarding',
    'complete_setup': 'Setup abschließen',
    'payments_enabled': 'Zahlungen aktiviert',
    'payouts_enabled': 'Auszahlungen aktiviert',
    'account_id': 'Konto-ID',
    'payment_configuration': 'Zahlungskonfiguration',
    'platform_fee_type': 'Plattformgebührentyp',
    'no_fee_direct': 'Keine Gebühr (Direktzahlung)',
    'percentage_soon': 'Prozentsatz (Demnächst verfügbar)',
    'fixed_soon': 'Festbetrag (Demnächst verfügbar)',
    'platform_fee_disabled': 'Die QuadCores-Plattformgebühr ist derzeit für Ihre Organisation deaktiviert.',
    'yes': 'Ja',
    'no': 'Nein',
    'previous': 'Zurück',
    'next': 'Weiter',

    // Common
    'loading': 'Wird geladen...',
    'save': 'Speichern',
    'cancel': 'Abbrechen',
    'edit': 'Bearbeiten',
    'delete': 'Löschen',
    'add': 'Hinzufügen',
    'view': 'Ansehen',
    'search': 'Suchen',
    'filter': 'Filtern',
    'actions': 'Aktionen',
    'status': 'Status',
    'refresh': 'Aktualisieren',
    'active': 'Aktiv',
    'inactive': 'Inaktiv',
    'yes': 'Ja',
    'no': 'Nein',
    'confirm': 'Bestätigen',
    'success': 'Erfolg',
    'error': 'Fehler',
    'warning': 'Warnung',
    'info': 'Information',

    // App
    'apartment_system': 'Wohnungssystem',
    'apartment_management': 'Wohnungsverwaltung',

    // Authentication
    'login': 'Anmelden',
    'logout': 'Abmelden',
    'login_to_continue': 'Melden Sie sich an, um fortzufahren',
    'dont_have_account': "Noch kein Konto?",
    'register': 'Registrieren',
    'username': 'Benutzername',
    'password': 'Passwort',
    'email': 'E-Mail',
    'remember_me': 'Angemeldet bleiben',
    'forgot_password': 'Passwort vergessen?',
    'forgot_password_instructions': 'Geben Sie Ihren Benutzernamen oder Ihre E-Mail-Adresse ein, um einen Bestätigungscode zu erhalten',
    'send_code': 'Bestätigungscode senden',
    'reset_password': 'Passwort zurücksetzen',
    'password_reset_success': 'Ihr Passwort wurde erfolgreich zurückgesetzt',
    'password_min_length': 'Das Passwort muss mindestens 8 Zeichen lang sein',
    'login_failed': 'Anmeldung fehlgeschlagen',
    'invalid_credentials': 'Ungültige Anmeldedaten',
    'security_verification': 'Sicherheitsüberprüfung',
    'verification_code_sent': 'Bestätigungscode wurde an Ihr registriertes Gerät gesendet.',
    'enter_valid_otp': 'Bitte geben Sie einen gültigen Bestätigungscode ein',
    'verification_failed': 'Überprüfung fehlgeschlagen',
    'code_resent_success': 'Bestätigungscode erfolgreich erneut gesendet.',
    'too_many_attempts': 'Zu viele Versuche. Bitte versuchen Sie es später erneut.',
    'check_device_for_code': 'Überprüfen Sie Ihr Gerät auf den Code',
    'verifying': 'Überprüfung...',

    // Navigation
    'dashboard': 'Dashboard',
    'core': 'Kernfunktionen',
    "accounting": "Buchhaltung",
    'user_management': 'Benutzerverwaltung',
    'property_management': 'Immobilienverwaltung',
    'maintenance_operations': 'Wartung & Betrieb',
    'financial_management': 'Finanzverwaltung',
    'financial_payments': 'Zahlungen',
    'financial_accounting': 'Buchhaltung',
    'financial_portfolio': 'Portfolio & KPIs',
    'portfolio_kpis': 'Portfolio & KPIs',
    'reports_analytics': 'Berichte & Analysen',
    'system': 'System',

    // Users
    'system_users': 'Systembenutzer',
    'user_list': 'Benutzerliste',
    'add_user': 'Benutzer hinzufügen',
    'edit_user': 'Benutzer bearbeiten',
    'user_profile': 'Benutzerprofil',
    'first_name': 'Vorname',
    'last_name': 'Nachname',
    'phone_number': 'Telefonnummer',
    'role': 'Rolle',
    'administrator': 'Administrator',
    'front_desk': 'Rezeption',
    'created_at': 'Erstellt am',
    'last_login': 'Letzter Login',
    'never': 'Niemals',

    // Properties
    'properties': 'Immobilien',
    'property_list': 'Immobilienliste',
    'add_property': 'Immobilie hinzufügen',
    'property_owners': 'Immobilieneigentümer',
    'owner_list': 'Eigentümerliste',
    'add_owner': 'Eigentümer hinzufügen',
    'owners': 'Eigentümer',
    'owner_contracts': 'Eigentümerverträge',
    'management_agreements': 'Verwaltungsverträge',
    'add_contract': 'Vertrag hinzufügen',
    'contract_details': 'Vertragsdetails',
    'no_contracts_message': 'Keine Verwaltungsverträge für diesen Eigentümer gefunden.',
    'contract_type': 'Vertragsart',
    'total_contract_value': 'Gesamter Vertragswert',
    'contract_progress': 'Vertragsfortschritt',
    'installment_schedule': 'Ratenzahlungsplan',

    // Tenants
    'tenants': 'Mieter',
    'tenant_list': 'Mieterliste',
    'add_tenant': 'Mieter hinzufügen',
    'owner_living': 'Eigentümer (selbstnutzend)',
    'future_tenant': 'Zukünftiger Mieter',

    // Payments
    'payments': 'Zahlungen',
    'all_payments': 'Alle Zahlungen',
    'record_payment': 'Zahlung erfassen',
    'manage_services': 'Dienstleistungen verwalten',
    'generate_payments': 'Zahlungen generieren',
    'overdue_payments': 'Überfällige Zahlungen',
    'receipts': 'Quittungen',

    // Reports
    'reports': 'Berichte',
    'all_reports': 'Alle Berichte',
    'reports_dashboard': 'Berichts-Dashboard',
    'financial_reports': 'Finanzberichte',
    'payment_reports': 'Zahlungsberichte',
    'property_reports': 'Immobilienberichte',
    'reports_1099_desc': 'IRS 1099-MISC-Bericht für Immobilienverteilungen an Eigentümer',
    'vendor_1099_nec': 'Verkäufer 1099-NEC',
    'vendor_1099_desc': 'Jährliche IRS-Berichterstattung – Lieferanten erhielten ≥ 600 USD Vergütung für Nicht-Mitarbeiter',
    'rent_roll_desc': 'Schnappschuss aller Einheiten, Belegungsstatus, Miete und Mietvertragsdetails',
    'ar_aging_desc': 'Ausstehende Mietersalden nach Alter gruppiert (0, 1-30, 31-60, 61-90, 90+)',
    'total_vendors': 'Verkäufer insgesamt',
    'require_1099': '1099 erforderlich',
    'total_reportable': 'Berichtspflichtig insgesamt',
    '1099_required': '1099 erforderlich',
    'below_threshold': 'Unter Schwellenwert',
    'occupancy_rate': 'Belegungsrate',
    'scheduled_rent': 'Geplante Miete',
    'aging_breakdown': 'Altersstruktur-Aufschlüsselung',

    // Settings
    'settings': 'Einstellungen',
    'profile_settings': 'Profileinstellungen',
    'system_settings': 'Systemeinstellungen',
    'profile': 'Profil',
    'personal_details': 'Persönliche Daten',
    'security_settings': 'Sicherheitseinstellungen',
    'change_password': 'Passwort ändern',
    'current_password': 'Aktuelles Passwort',
    'new_password': 'Neues Passwort',
    'confirm_new_password': 'Neues Passwort bestätigen',
    'organization_settings': 'Organisationseinstellungen',
    'organization_name': 'Organisationsname',
    'timezone': 'Zeitzone',
    'subscription_plan': 'Abonnement',
    'trial_period': 'Testphase',
    'days_left': 'Noch {{days}} Tage',
    'subscription_required': 'Abonnement erforderlich',
    'subscription_expired_message': 'Der Zugriff auf Ihren Arbeitsbereich ist derzeit gesperrt. Bitte erneuern Sie Ihr Abonnement, um Ihre Immobilien weiter zu verwalten.',
    'premium_experience_notice': 'Premium-Arbeitsbereich erforderlich',
    'feature_locked_message': 'Diese Funktion ist in Ihrem aktuellen Plan nicht verfügbar. Bitte führen Sie ein Upgrade durch, um darauf zuzugreifen.',
    'renew_subscription': 'Abonnement erneuern',
    'update_profile_success': 'Profil erfolgreich aktualisiert',
    'update_password_success': 'Passwort erfolgreich geändert',
    'update_system_success': 'Systemeinstellungen erfolgreich aktualisiert',
    'settings_subtitle': 'Verwalten Sie Ihr Konto und Ihre Systemeinstellungen',
    'manage_your_account_and_system_preferences': 'Verwalten Sie Ihr Konto und Ihre Systemeinstellungen',
    'standard_plan': 'Standard-Plan',
    'enterprise_plan': 'Enterprise-Plan',

    // Notifications
    'notifications': 'Benachrichtigungen',
    'view_all_notifications': 'Alle Benachrichtigungen ansehen',

    // WhatsApp Settings
    'whatsapp_settings': 'WhatsApp-Einstellungen',
    'whatsapp_settings_description': 'Automatisierte WhatsApp-Benachrichtigungen für Mieter und Eigentümer',
    'send_reminders_now': 'Erinnerungen jetzt senden',
    'general_settings': 'Allgemeine Einstellungen',
    'whatsapp_enable': 'WhatsApp-Benachrichtigungen aktivieren',
    'whatsapp_enable_sub': 'Schalten Sie alle automatisierten WhatsApp-Nachrichten ein oder aus',
    'default_country_code': 'Standard-Ländercode',
    'default_messaging_language': 'Standard-Nachrichtensprache',
    'default_language_help': 'Wird verwendet, wenn der Mieter keine bevorzugte Sprache festgelegt hat.',
    'tenant_rent_reminder': 'Miet-Erinnerung für Mieter',
    'enable_tenant_rent_reminders': 'Erinnerungen aktivieren',
    'tenant_rent_reminder_sub': 'Senden Sie Erinnerungen an Mieter vor oder nach dem Fälligkeitsdatum der Zahlung',
    'days_before_due': 'Tage vor Fälligkeit',
    'service_fee_reminder': 'Erinnerung an Servicegebühren',
    'enable_service_fee_reminder': 'Servicegebühren-Erinnerung aktivieren',
    'service_fee_reminder_sub': 'Benachrichtigen Sie Mieter über anstehende Zahlungen von Servicegebühren',
    'owner_reminder': 'Eigentümer-Erinnerung',
    'enable_owner_reminders': 'Eigentümer-Erinnerungen aktivieren',
    'owner_reminder_sub': 'Benachrichtigen Sie Eigentümer, wenn ihre Mieter überfällige Zahlungen haben',
    'payment_confirmation': 'Zahlungsbestätigung',
    'send_on_payment': 'Senden bei Zahlungseingang',
    'payment_confirmation_sub': 'Wird automatisch an den Mieter gesendet, wenn eine Zahlung erfasst wird',
    'preview_reminders': 'Vorschau der automatisierten Erinnerungen',
    'notification_log_desc': 'Audit-Trail aller ausgehenden Benachrichtigungen',
    'total_sent': 'Gesamt gesendet',
    'failed_bounced': 'Fehlgeschlagen / Zurückgewiesen',
    'email_templates_desc': 'Entwerfen Sie automatisierte E-Mails für Ihre Mieter und Eigentümer',
    'test_email_address': 'Test-E-Mail-Adresse',
    'payment_settings': 'Zahlungseinstellungen',
    'accept_online_payments': 'Online-Zahlungen akzeptieren',
    'connect_stripe_desc': 'Verbinden Sie Ihr Stripe-Konto, damit Mieter die Miete direkt über das Portal bezahlen können.',
    'start_stripe_onboarding': 'Stripe-Onboarding starten',
    'active_verified': 'Aktiv & Verifiziert',
    'action_required_onboarding': 'Aktion erforderlich: Onboarding ausstehend',
    'webhooks_desc': 'Senden Sie Ereignisse an Ihre Systeme, wenn in APS etwas passiert',
    'recent_deliveries': 'Letzte Zustellungen',
    'failed_to_load_settings': 'Einstellungen konnten nicht geladen werden',
    'settings_saved': 'Einstellungen erfolgreich gespeichert',
    'failed_to_save': 'Speichern fehlgeschlagen',
    'server_error': 'Serverfehler',

    // Forms
    'personal_information': 'Persönliche Informationen',
    'account_information': 'Kontoinformationen',
    'security': 'Sicherheit',
    'enter_first_name': 'Vorname eingeben',
    'enter_last_name': 'Nachname eingeben',
    'enter_email': 'E-Mail eingeben',
    'enter_username': 'Benutzername eingeben',
    'enter_password': 'Passwort eingeben',
    'enter_phone_number': 'Telefonnummer eingeben',
    'confirm_password': 'Passwort bestätigen',
    'leave_blank_to_keep_current': 'Leer lassen, um das aktuelle Passwort zu behalten',

    // Validation
    'first_name_required': 'Vorname ist erforderlich',
    'last_name_required': 'Nachname ist erforderlich',
    'email_required': 'E-Mail ist erforderlich',
    'invalid_email': 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    'username_required': 'Benutzername ist erforderlich',
    'username_too_short': 'Der Benutzername muss mindestens 3 Zeichen lang sein',
    'password_required': 'Passwort ist erforderlich',
    'password_too_short': 'Das Passwort muss mindestens 6 Zeichen lang sein',
    'passwords_do_not_match': 'Passwörter stimmen nicht überein',
    'phone_invalid_format': 'Bitte geben Sie eine gültige Telefonnummer ein',

    // Actions
    'saving': 'Speichern...',
    'deleting': 'Löschen...',
    'loading_users': 'Benutzer werden geladen...',
    'loading_user_data': 'Benutzerdaten werden geladen...',
    'update': 'Aktualisieren',
    'activate': 'Aktivieren',
    'deactivate': 'Deaktivieren',
    'show_all': 'Alle anzeigen',
    'hide_inactive': 'Inaktive ausblenden',
    'all_roles': 'Alle Rollen',
    'retry': 'Wiederholen',

    // Messages
    'no_users_found': 'Keine Benutzer gefunden',
    'user_created_successfully': 'Benutzer erfolgreich erstellt',
    'user_updated_successfully': 'Benutzer erfolgreich aktualisiert',
    'user_deleted_successfully': 'Benutzer erfolgreich gelöscht',
    'confirm_deletion': 'Löschen bestätigen',
    'delete_user_confirmation': 'Sind Sie sicher, dass Sie {{name}} löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',

    // Dashboard
    'welcome_back': 'Willkommen zurück',
    'dashboard_subtitle': 'Hier sehen Sie, was heute mit Ihren Immobilien passiert.',
    'total_properties': 'Gesamtanzahl Immobilien',
    'active_tenants': 'Aktive Mieter',
    'monthly_revenue': 'Monatlicher Umsatz',
    'pending_payments': 'Ausstehende Zahlungen',
    'recent_activity': 'Letzte Aktivität',
    'recent_transactions': 'Letzte Transaktionen',
    'quick_actions': 'Schnellaktionen',
    'alerts_notifications': 'Warnungen & Benachrichtigungen',
    'showing': 'Zeige',
    'of': 'von',
    'users': 'Benutzern',
    'contact': 'Kontakt',
    'user': 'Benutzer',
    'active_properties': 'Aktive Immobilien',
    'occupancy_rate_desc': '{{rate}}% Belegungsquote',
    'vs_last_month': 'vs. letzter Monat',
    'overdue_amount': '{{amount}} überfällig',
    'payment_desc': '{{type}} Zahlung - Whg {{number}}',
    'overdue_payments': 'Überfällige Zahlungen',
    'overdue_payments_msg': '{{count}} Mieter haben ausstehende Zahlungen in Höhe von insgesamt {{amount}}',
    'view_details': 'Details ansehen',
    'lease_expiring_soon': 'Mietvertrag läuft bald ab',
    'lease_expiring_msg': '{{count}} Mietverträge laufen innerhalb von 30 Tagen ab',
    'review_leases': 'Mietverträge überprüfen',
    'trial_ending_soon': 'Testphase endet bald',
    'trial_ending_msg': 'Ihre Testphase endet in {{days}} Tagen. Bitte abonnieren Sie, um eine Unterbrechung des Dienstes zu vermeiden.',
    'upgrade_plan': 'Plan upgraden',
    'last_7_days': 'Letzte 7 Tage',
    'last_30_days': 'Letzte 30 Tage',
    'last_3_months': 'Letzte 3 Monate',
    'last_year': 'Letztes Jahr',
    'error_loading_dashboard': 'Fehler beim Laden des Dashboards',
    'reports_dashboard': 'Berichts-Dashboard',
    'overview_of_financial_performance': 'Überblick über finanzielle Leistung und Immobilienstatistiken',
    'view_all_reports': 'Alle Berichte ansehen',
    'total_revenue': 'Gesamter Umsatz',
    'total_payments_count': '{{count}} Zahlungen',
    'total_tenants': 'Gesamtanzahl Mieter',
    'new_tenants_this_year': '{{count}} neu dieses Jahr',
    'total_buildings_count': '{{count}} Gebäude',
    'total_owners': 'Gesamteigentümer (selbstnutzend)',
    'ended_contracts_count': '{{count}} beendete Verträge',
    'urgent_action': 'Dringender Handlungsbedarf',
    'monthly_revenue_year': 'Monatlicher Umsatz - {{year}}',
    'occupancy_rate': 'Belegungsquote',
    'quick_reports': 'Schnellberichte',
    'annual_revenue': 'Jahresumsatz',
    'yearly_breakdown': 'Jährliche Aufschlüsselung aller Einnahmen',
    'building_revenue': 'Gebäudeumsatz',
    'revenue_by_building': 'Umsatzaufschlüsselung nach Gebäude',
    'owner_revenue': 'Eigentümerumsatz',
    'revenue_by_owner': 'Umsatzaufschlüsselung nach Immobilieneigentümer',
    'detailed_payment_history': 'Detaillierter Zahlungsverlauf und Protokolle',
    'occupied': 'Vermietet',
    'vacant': 'Leerstehend',
    'maintenance': 'Wartung',
    'excellent': 'Ausgezeichnet',
    'good': 'Gut',
    'needs_improvement': 'Verbesserungswürdig',
    'rent': 'Miete',
    'service': 'Service',
    'deposit': 'Kaution',
    'commission': 'Provision',
    'insurance': 'Versicherung',
    'total': 'Gesamt',
    'no_recent_payments': 'Keine aktuellen Zahlungen gefunden',
    'no_overdue_payments': 'Keine überfälligen Zahlungen gefunden',
    'overdue': 'Überfällig',
    'partial': 'Teilweise',
    'expired': 'Abgelaufen',
    'pending': 'Ausstehend',
    'paid': 'Bezahlt',
    'apt': 'Whg',
    'days_overdue': 'Tage überfällig',
    'more_overdue_tenants': 'weitere überfällige Mieter',
    'error_fetching_occupancy': 'Fehler beim Abrufen der Belegungsdaten',
    'failed_load_occupancy': 'Fehler beim Laden der Belegungsstatistiken',
    'error_fetching_payments': 'Fehler beim Abrufen der letzten Zahlungen',
    'failed_load_payments': 'Fehler beim Laden der letzten Zahlungen',
    'error_fetching_tenant_status': 'Fehler beim Abrufen des Zahlungsstatus der Mieter',
    'failed_load_tenant_status': 'Fehler beim Laden des Zahlungsstatus der Mieter',
    'failed_to_load_report_data': 'Fehler beim Laden der Berichtsdaten',
    'mgmt_fee_collected': 'Verwaltungsgebühr (YTD)',
    'mgmt_fee_outstanding': 'Ausstehende Verwaltungsgebühr',
    'active_tenant_arrears': 'Rückstände aktiver Mieter',
    'all_accounts_settled': 'Alle Konten ausgeglichen',
    'owner_payments': 'Eigentümerzahlungen',
    'all_months': 'Alle Monate',

    "floor_number": "Etage {{number}}",
    "apartment_number": "Zimmer {{number}}",

    // Sidebar specific translations
    'core': 'Kernfunktionen',
    'user_management': 'Benutzerverwaltung',
    'property_management': 'Immobilienverwaltung',
    'maintenance_operations': 'Wartung & Betrieb',
    'financial_management': 'Finanzverwaltung',
    'financial_payments': 'Zahlungen',
    'financial_accounting': 'Buchhaltung',
    'financial_portfolio': 'Portfolio & KPIs',
    'reports_analytics': 'Berichte & Analysen',
    'logs_audit': 'Protokolle & Audit',
    'all_activities': 'Alle Aktivitäten',
    'tenant_activities': 'Mieteraktivitäten',
    'system': 'System',
    'bookings': 'Buchungen',
    'booking_list': 'Buchungsliste',
    'new_booking': 'Neue Buchung',
    'booking_calendar': 'Buchungskalender',
    'waitlist': 'Warteliste',
    'analytics': 'Analysen',

    'system_users': 'Systembenutzer',
    'user_list': 'Benutzerliste',
    'add_user': 'Benutzer hinzufügen',

    'buildings': 'Gebäude',
    'building_list': 'Gebäudeliste',
    'add_building': 'Gebäude hinzufügen',

    'apartments': 'Wohnungen',
    'apartment_list': 'Wohnungsliste',
    'add_apartment': 'Wohnung hinzufügen',

    'owners': 'Eigentümer',
    'owner_list': 'Eigentümerliste',
    'add_owner': 'Eigentümer hinzufügen',

    'tenants': 'Mieter',
    'tenant_list': 'Mieterliste',
    'add_tenant': 'Mieter hinzufügen',
    'overdue_rent': 'Überfällige Miete',

    'payments': 'Zahlungen',
    'all_payments': 'Alle Zahlungen',
    'record_payment': 'Zahlung erfassen',
    'payment_stats': 'Zahlungsstatistiken',

    'service_payments': 'Servicezahlungen',
    'manage_services': 'Dienstleistungen verwalten',
    'generate_payments': 'Zahlungen generieren',
    'service_statistics': 'Service-Statistiken',
    'finance': 'Finanzen',
    'transactions': 'Transaktionen',
    'service_charges': 'Servicegebühren',
    'owner_installments': 'Eigentümerraten',
    'messages': 'Nachrichten',
    'announcements_manager': 'Ankündigungsmanager',
    'all_announcements': 'Alle Ankündigungen',
    'sales': 'Verkäufe',
    'sales_management': 'Verkaufsmanagement',
    'inspections': 'Inspektionen',
    'all_inspections': 'Alle Inspektionen',
    'renewal_risk': 'Verlängerungsrisiko',
    'lease_renewals': 'Mietvertragsverlängerungen',
    'lease_applications': 'Mietanträge',
    'application_links': 'Bewerbungslinks',
    'leases': 'Mietverträge',
    'violations': 'Verstöße',
    'notices': 'Benachrichtigungen',
    'screening': 'Überprüfung',
    'documents': 'Dokumente',
    'amenities_parking': 'Annehmlichkeiten & Parken',

    // Messages
    'messages_title': 'Nachrichten',
    'tenants_tab': 'Mieter',
    'owners_tab': 'Eigentümer',
    'no_conversations': 'Noch keine Unterhaltungen',
    'select_conversation_hint': 'Wählen Sie links eine Unterhaltung aus, um mit dem Schreiben zu beginnen',
    'type_message_placeholder': 'Nachricht eingeben...',
    'your_inbox': 'Dein Posteingang',
    'you_label': 'Du: ',
    'mark_as_read': 'Als gelesen markieren',
    'failed_to_load_messages': 'Nachrichten konnten nicht geladen werden',
    'failed_to_load_chat_history': 'Chatverlauf konnte nicht geladen werden',
    'failed_to_send_message': 'Nachricht konnte nicht gesendet werden',

    // Expenses
    'expenses_title': 'Ausgaben',
    'expenses_subtitle': 'Erfassung betrieblicher Ausgaben mit Genehmigungsworkflow',
    'new_expense': 'Neue Ausgabe',
    'new_expense_subtitle': 'Eine betriebliche Ausgabe erfassen',
    'total_expenses': 'Gesamtausgaben',
    'approved_amount': 'Genehmigt',
    'how_it_works': 'Wie es funktioniert',
    'expense_hint1': 'Erfassen Sie alle für ein Gebäude bezahlten Kosten: Reparaturen, Reinigung, Verwaltungsgebühren usw.',
    'expense_hint2': 'Als "Ausstehend" markierte Ausgaben müssen genehmigt werden, bevor sie sich auf das Betriebsergebnis (NOI) auswirken',
    'expense_hint3': '"Dem Eigentümer in Rechnung stellen" bucht die Ausgabe direkt auf das Ledger des Eigentümers',
    'expense_hint4': 'Betriebsergebnis (NOI) = Mieteinnahmen − genehmigte Ausgaben',
    'search_expenses': 'Nach Beschreibung, Kreditor, Kategorie suchen...',
    'expense_records': 'Ausgabenbelege',
    'no_expenses_found': 'Keine Ausgaben gefunden',

    // Storage / Inventory
    'storage_title': 'Lager',
    'storage_subtitle': 'Lagerartikel verfolgen und an Wohnungen ausgeben — wird automatisch als Ausgabe gebucht',
    'add_stock': 'Bestand hinzufügen',
    'stock_value': 'Lagerwert',
    'items_in_storage': 'Artikel im Lager',
    'total_issued': 'Gesamt ausgegeben',
    'stock_on_hand': 'Verfügbarer Bestand',
    'issuance_history': 'Ausgabeverlauf',
    'quantity_on_hand': 'Verfügbar',
    'issue_to_apartment': 'An Wohnung ausgeben',
    'issue': 'Ausgeben',
    'storage_hint1': 'Artikel zuerst ins Lager buchen: Türen, Fenster, Armaturen usw. — noch keine Wohnung nötig',
    'storage_hint2': '"An Wohnung ausgeben" verschiebt Bestand zu einer Einheit und bucht die Kosten automatisch',
    'storage_hint3': 'Ausgegebene Kosten werden als ausstehende Ausgabe zur Genehmigung gebucht',
    'storage_hint4': 'Die Zusammenfassung nach Wohnung zeigt die Gesamtkosten pro Einheit, basierend auf tatsächlich ausgegebenen Artikeln',
    'search_materials': 'Suche nach Artikel, Wohnung, Lieferant...',
    'no_materials_found': 'Noch nichts vorhanden',
    'spend_by_apartment': 'Ausgaben nach Wohnung',
    'apartment_label': 'Wohnung',
    'item_name': 'Artikel',
    'item_name_placeholder': 'z. B. Innentür, Doppelverglasung',
    'items_logged': 'Artikel',
    'quantity': 'Menge',
    'quantity_required': 'Menge ist erforderlich',
    'quantity_exceeds_stock': 'Nur {{available}} auf Lager verfügbar',
    'available_short': '{{qty}} verfügbar',
    'unit_cost': 'Stückkosten',
    'total_cost': 'Gesamtkosten',
    'select_apartment': 'Wohnung auswählen',
    'stock_added': 'Bestand zum Lager hinzugefügt',
    'material_issued': 'An Wohnung ausgegeben und als Ausgabe gebucht',
    'failed_to_load_materials': 'Lagerdaten konnten nicht geladen werden',
    'failed_to_load_apartments': 'Wohnungen konnten nicht geladen werden — Verbindung prüfen und erneut versuchen',

    'approve': 'Genehmigen',
    'void': 'Annullieren',
    'confirm_void': 'Diese Ausgabe annullieren? Dies kann nicht rückgängig gemacht werden.',
    'expense_description_placeholder': 'z.B. Monatliche Schädlingsbekämpfung',
    'select_category': '— Kategorie wählen —',
    'charge_to_owner': 'Dem Eigentümer in Rechnung stellen (wird im Eigentümer-Ledger gebucht)',
    'create_expense': 'Ausgabe erstellen',
    'expense_created': 'Ausgabe erstellt',
    'expense_approved': 'Ausgabe genehmigt',
    'expense_voided': 'Ausgabe annulliert',
    'invoice_number': 'Rechnungs-Nr.',
    'all_statuses': 'Alle Status',
    'failed_to_load_expenses': 'Ausgaben konnten nicht geladen werden',
    'expense_rejected': 'Ausgabe abgelehnt',
    'confirm_reject': 'Diese Ausgabe ablehnen? Dies kann nicht rückgängig gemacht werden.',
    'date_from': 'Von Datum',
    'date_to': 'Bis Datum',
    'failed_to_load': 'Daten konnten nicht geladen werden',
    'assign_failed': 'Zuweisung fehlgeschlagen',
    'unavailable': 'Nicht verfügbar',
    'filtered_by': 'Gefiltert nach:',
    'calendar': 'Kalender',
    'notes_placeholder': 'Zusätzliche Notizen…',
    'no_amenities_match_filter': 'Keine Ausstattung entspricht dem ausgewählten Filter.',
    'all_amenities': 'Alle Einrichtungen',
    'no_bookings_on_day': 'Keine Buchungen an diesem Tag.',
    'parking_assigned': 'Parkplatz zugewiesen',
    'parking_unassigned': 'Parkplatzzuweisung aufgehoben',
    'parking_space_deleted': 'Parkplatz gelöscht',
    'parking_space_created': 'Parkplatz erstellt',
    'parking_space_updated': 'Parkplatz aktualisiert',
    'parking_spaces_generated': 'Parkplätze in großer Menge erstellt',
    'booking_deleted': 'Buchung gelöscht',
    'parking_layout_hint': 'Weisen Sie Reihen über Raum bearbeiten zu, um Ihr Parklayout zu organisieren',
    'delete_amenity_title': 'Ausstattung löschen',
    'confirm_delete_amenity': 'Sind Sie sicher, dass Sie diese Ausstattung löschen möchten? Dies kann nicht rückgängig gemacht werden.',
    'delete_parking_space_title': 'Parkplatz löschen',
    'confirm_delete_parking': 'Sind Sie sicher, dass Sie diesen Parkplatz löschen möchten? Dies kann nicht rückgängig gemacht werden.',
    'delete_booking_title': 'Buchung löschen',
    'confirm_delete_booking': 'Sind Sie sicher, dass Sie diese Buchung löschen möchten? Dies kann nicht rückgängig gemacht werden.',
    'unassign_parking_title': 'Parkzuweisung aufheben',
    'confirm_unassign_parking': 'Sind Sie sicher, dass Sie die Zuweisung dieses Parkplatzes aufheben möchten?',
    'start_end_required': 'Start- und Endnummern erforderlich',
    'space_number_required': 'Platznummer ist erforderlich',
    'row_zone': 'Reihe / Zone',
    'row_zone_hint': 'für Kartenlayout',
    'status_pending_approval': 'Ausstehend',
    'status_approved': 'Genehmigt',
    'status_voided': 'Annulliert',
    'status_rejected': 'Abgelehnt',
    'owner_label': 'Eigentümer',
    'select_building': '— Gebäude wählen —',
    'payment_method': 'Zahlungsart',
    'method_bank_transfer': 'Banküberweisung',
    'method_cash': 'Barzahlung',
    'method_check': 'Scheck',
    'method_credit_card': 'Kreditkarte',
    'method_stripe': 'Stripe',
    'method_wire': 'Telegrafische Überweisung',
    'method_other': 'Sonstiges',
    'items_plural': 'Elemente',
    'item_singular': 'Element',
    'all_buildings': 'Alle Gebäude',

    // Late Fees
    'late_fee_mgmt': 'Verzugskostenmanagement',
    'pending_charges': 'Ausstehende Gebühren',
    'history_tab': 'Verlauf',
    'fee_settings': 'Gebühreneinstellungen',
    'late_fees_disabled_hint': 'Verzugsgebühren sind deaktiviert – in den Einstellungen aktivieren',
    'tenants_due_fee': 'Mieter mit fälligen Verzugsgebühren',
    'next_cron_run': 'Nächster automatischer Lauf um 10:00 Uhr (Ortszeit)',
    'apply_now': 'Jetzt anwenden',
    'applying': 'Wird angewendet...',
    'waive': 'Erlassen',
    'waive_late_fee': 'Verzugsgebühr erlassen',
    'waive_reason_label': 'Grund',
    'waive_reason_placeholder': 'z.B. Zahlungsvereinbarung getroffen, Kulanz beim ersten Mal usw.',
    'confirm_waiver': 'Erlass bestätigen',
    'waiving': 'Wird erlassen...',
    'failed_to_load_pending': 'Ausstehende Gebühren konnten nicht geladen werden',
    'failed_to_load_history': 'Verlauf konnte nicht geladen werden',
    'fee_waived': 'Gebühr erlassen',
    'failed_to_waive': 'Erlass fehlgeschlagen',
    'late_fee_assessed': 'Verzugsgebühr festgesetzt',
    'failed_to_assess': 'Festsetzung fehlgeschlagen',
    'days_overdue': 'Tage überfällig',
    'projected_fee': 'Voraussichtliche Gebühr',
    'last_fee': 'Letzte Gebühr',
    'waive_amount_label': 'Erlassbetrag ($)',
    'not_found': 'Nicht gefunden',
    'never': 'Nie',
    'balance': 'Saldo',
    'source': 'Quelle',
    'auto_label': 'Auto',
    'manual_label': 'Manuell',
    'late_fees_disabled': 'Verzugsgebühren deaktiviert',
    'of_rent': 'der Miete',
    'day_grace': 'Tage Kulanz',
    'no_pending_late_fees': 'Derzeit sind keine Verzugsgebühren für Mieter ausstehend.',
    'enable_late_fees_hint': 'Aktivieren Sie Verzugsgebühren in den Einstellungen, um mit der Erfassung zu beginnen.',
    'no_late_fee_records': 'Keine Verzugsgebühren-Einträge gefunden.',
    'all_late_fee_charges': 'Alle Verzugsgebühren-Belastungen',
    'failed_to_load_owner_balances': 'Eigentümerguthaben konnten nicht geladen werden',
    'select_at_least_one_owner': 'Wählen Sie mindestens einen Eigentümer aus',
    'confirm_bulk_payout': '{{count}} Eigentümer mit insgesamt {{amount}} auszahlen?',
    'bulk_payout_success': '{{count}} Eigentümer ausgezahlt — insgesamt {{amount}}',
    'bulk_payout_failed': 'Massenauszahlung fehlgeschlagen',
    'bulk_owner_payout': 'Massenauszahlung an Eigentümer',
    'bulk_payout_subtitle': 'Alle Eigentümer mit ausstehenden Salden in einer Charge bezahlen',
    'total_owed_all': 'Gesamtschuld (alle Eigentümer)',
    'owners_with_balance': 'Eigentümer mit Guthaben',
    'selected_to_pay': 'Zur Auszahlung ausgewählt',
    'balance_owed': 'Geschuldeter Saldo',
    'last_payout': 'Letzte Auszahlung',
    'payout_settings': 'Auszahlungseinstellungen',
    'period_month': 'Zeitraum Monat',
    'payout_notes_placeholder': 'z.B. Monatliche Ausschüttung',
    'pay_owners_btn': '{{count}} Eigentümer auszahlen · {{amount}}',
    'last_batch_results': 'Ergebnisse der letzten Charge',
    'wire_transfer': 'Telegrafische Überweisung',
    'status_held': 'Gehalten',
    'status_returned': 'Zurückgegeben',
    'status_not_collected': 'Nicht eingezogen',
    'error_loading_deposits': 'Kautionen konnten nicht geladen werden',
    'deposit_collected': 'Kaution eingezogen',
    'deposit_returned': 'Kaution zurückgegeben',
    'security_deposits_subtitle': 'Konforme Kautionsverfolgung — rechtlich getrennt von der Miete',
    'total_held': 'Gesamt gehalten',
    'active_deposits': 'Aktive Kautionen',
    'deposits_returned': 'Rückgezahlte Kautionen',
    'all_tenants_deposit_status': 'Alle Mieter — Kautionsstatus',
    'paid_on': 'Bezahlt am',
    'collect': 'Einziehen',
    'return': 'Zurückgeben',
    'collect_security_deposit': 'Kaution einziehen',
    'return_security_deposit': 'Kaution zurückgeben',
    'damages_unpaid_rent': 'Schäden, unbezahlte Miete usw.',
    'optional_notes': 'Optionale Notizen...',
    'record_collection': 'Einzug erfassen',
    'record_return': 'Rückgabe erfassen',
    'deposit_amount_placeholder': 'z.B. 1500.00',
    'error_loading_utility_data': 'Nebenkostendaten konnten nicht geladen werden',
    'utility_account_created': 'Nebenkostenkonto erstellt',
    'reading_recorded_generate_bills': 'Zählerstand erfasst — Rechnungen unten generieren',
    'rubs_complete_msg': 'RUBS abgeschlossen — {{count}} Mieter mit jeweils {{amount_each}} abgerechnet (Gesamt {{total}})',
    'no_pending_bills_to_charge': 'Keine ausstehenden Rechnungen zum Buchen',
    'confirm_charge_all_bills': '{{count}} ausstehende Rechnungen in die Mieter-Ledger buchen?',
    'confirm_charge_all_bills_title': 'Alle ausstehenden Rechnungen buchen',
    'charge_all_success_msg': '{{count}} Rechnungen in Mieter-Ledger gebucht!{{failed_msg}}',
    'generate_bills_btn': 'Rechnungen generieren',
    'generate_from_meters': 'Aus Zählern generieren',
    'charge_all_btn': 'Alle berechnen ({{count}})',
    'bills_generated_msg': '{{count}} Verbrauchsrechnungen generiert',
    'rubs_failed': 'RUBS-Berechnung fehlgeschlagen',
    'failed_to_update_account': 'Konto konnte nicht aktualisiert werden',
    'utility_management': 'Nebenkostenverwaltung',
    'utility_subtitle': 'Zähler, Ablesungen und Nebenkostenabrechnungen für Mieter verwalten',
    'add_account': 'Konto hinzufügen',
    'utility_accounts': 'Nebenkostenkonten',
    'no_utility_accounts': 'Keine Nebenkostenkonten — fügen Sie eines hinzu, um zu beginnen',
    'provider': 'Anbieter',
    'account_number_label': 'Kontonummer',
    'meter_number_label': 'Zählernummer',
    'utility_bills': 'Nebenkostenabrechnungen',
    'no_bills_found_msg': 'Keine Rechnungen gefunden — nutzen Sie "Rechnungen generieren"',
    'period': 'Zeitraum',
    'usage': 'Verbrauch',
    'charge_tenant': 'Mieter belasten',
    'add_utility_account': 'Nebenkostenkonto hinzufügen',
    'add_utility_account_subtitle': 'Neuen Zähler oder Versorgungsdienst registrieren',
    'utility_type': 'Versorgungsart',
    'provider_name': 'Anbietername',
    'provider_placeholder': 'z.B. Stadtwerke',
    'shared_meter': 'Gemeinschaftszähler (deckt das gesamte Gebäude ab)',
    'add_meter_reading': 'Zählerstand hinzufügen',
    'reading_value': 'Aktueller Zählerstand',
    'reading_date': 'Ablesedatum',
    'record_reading': 'Ablesung erfassen',
    'error_loading_kpi_data': 'KPI-Daten konnten nicht geladen werden',
    'snapshot_complete': 'Snapshot abgeschlossen',
    'snapshot_failed': 'Snapshot fehlgeschlagen',
    'kpi_dashboard': 'KPI-Dashboard',
    'kpi_subtitle': 'Live-Portfolio-Performance — Auslastung, NOI, Cap-Rate, Inkasso-Rate',
    'capturing': 'Erfasse...',
    'snapshot_now': 'Jetzt Snapshot erstellen',
    'occupancy_rate': 'Belegungsrate',
    'annual_gross_rent': 'Jährliche Bruttomiete',
    'portfolio_value': 'Portfoliowert',
    'total_units': 'Gesamteinheiten',
    'units_occupied_msg': '{{occupied}} von {{total}} Einheiten belegt',
    'per_month_suffix': '{{amount}} / Monat',
    'equity_label_val': '{{amount}} Eigenkapital',
    'vacant_units_count': '{{count}} leerstehend',
    'kpi_step1': 'Klicken Sie auf "Jetzt Snapshot erstellen", um die heutigen Kennzahlen für alle Gebäude zu berechnen',
    'kpi_step2': 'Snapshots werden automatisch jede Nacht erstellt',
    'kpi_step3': 'Erfassen Sie Immobilienbewertungen auf der Portfolioseite, um Cap-Rate & Rendite freizuschalten',
    'per_building_metrics': 'Kennzahlen pro Gebäude',
    'no_snapshots_yet': 'Noch keine Snapshots vorhanden — klicken Sie auf "Jetzt Snapshot erstellen"',
    'collection_rate': 'Inkasso',
    'monthly_noi': 'Monatlicher NOI',
    'cap_rate': 'Cap-Rate',
    'gross_yield': 'Bruttorendite',
    'overdue_tenants': 'Überfällig',
    'investment_summary': 'Investitionsübersicht',
    'current_value': 'Aktueller Wert',
    'purchase_cost': 'Kaufkosten',
    'equity': 'Eigenkapital',
    'error_loading_portfolio_data': 'Portfolio-Daten konnten nicht geladen werden',
    'valuation_recorded': 'Bewertung erfasst',
    'investment_portfolio': 'Investment-Portfolio',
    'portfolio_subtitle': 'Portfoliobewertung, Eigenkapital, Cap-Rate und Rendite pro Gebäude',
    'record_valuation': 'Bewertung erfassen',
    'total_portfolio_value': 'Portfoliowert',
    'annualized_amount': '{{amount}} auf das Jahr hochgerechnet',
    'avg_cap_rate': 'Ø Cap-Rate',
    'annualized': 'Annualisiert',
    'avg_gross_yield': 'Ø Bruttorendite',
    'gross_rent_on_value': 'Bruttomiete / Wert',
    'portfolio_step1': 'Klicken Sie auf "Bewertung erfassen", um den aktuellen Marktwert eines Gebäudes einzugeben',
    'portfolio_step2': 'Cap-Rate = Jahres-NOI ÷ Immobilienwert × 100',
    'portfolio_step3': 'Bruttorendite = Jährliche Bruttomiete ÷ Immobilienwert × 100',
    'portfolio_step4': 'NOI-Daten stammen aus dem KPI-Dashboard — erstellen Sie zuerst einen Snapshot',
    'per_building_breakdown': 'Aufschlüsselung pro Gebäude',
    'no_portfolio_data': 'Keine Portfolio-Daten — erstellen Sie zuerst einen KPI-Snapshot und erfassen Sie dann Bewertungen',
    'last_valuation': 'Letzte Bewertung',
    'occupied_short': 'belegt',
    'no_valuation': 'Keine Bewertung',
    'update_value': 'Wert aktualisieren',
    'record_valuation_subtitle': 'Aktuellen Marktwert für ein Gebäude erfassen',
    'appraised_value': 'Schätzwert',
    'valuation_date': 'Datum',
    'method': 'Methode',
    'record': 'Erfassen',
    'error_loading_accounts': 'Konten konnten nicht geladen werden',
    'error_loading_journal_entries': 'Journalbuchungen konnten nicht geladen werden',
    'error_loading_trial_balance': 'Summen- und Saldenliste konnte nicht geladen werden',
    'error_loading_pnl': 'GuV konnte nicht geladen werden',
    'gl_account_required_fields': 'Code, Name und Typ sind erforderlich',
    'account_created': 'Konto erstellt',
    'journal_min_lines_error': 'Mindestens 2 Zeilen erforderlich',
    'entry_out_of_balance_error': 'Buchung nicht ausgeglichen: Soll {{debits}} ≠ Haben {{credits}}',
    'journal_account_required_error': 'Für alle Zeilen muss ein Konto ausgewählt werden',
    'journal_entry_posted': 'Journalbuchung gebucht',
    'reason_for_reversal_prompt': 'Grund für die Stornierung:',
    'entry_reversed': 'Buchung storniert',
    'reversal_failed': 'Stornierung fehlgeschlagen',
    'chart_of_accounts': 'Kontenplan',
    'journal_entries': 'Journalbuchungen',
    'trial_balance': 'Summen- und Saldenliste',
    'pnl_statement': 'Gewinn- und Verlustrechnung',
    'general_ledger': 'Hauptbuch',
    'gl_subtitle': 'Kontenplan, Journalbuchungen, Summen- und Saldenliste & GuV',
    'new_gl_account': 'Neues Sachkonto',
    'normal_balance': 'Normaler Saldo',
    'no_accounts_found': 'Keine Konten gefunden',
    'all_sources': 'Alle Quellen',
    'new_entry': 'Neue Buchung',
    'new_journal_entry': 'Neue Journalbuchung',
    'select_account': 'Konto auswählen...',
    'line_description_placeholder': 'Zeilenbeschreibung',
    'balanced_msg': '✓ Ausgeglichen',
    'out_of_balance_amount': 'Nicht ausgeglichen um {{amount}}',
    'add_line': '+ Zeile hinzufügen',
    'post_entry': 'Buchung abschließen',
    'posting': 'Buche...',
    'no_journal_entries_found': 'Keine Journalbuchungen gefunden',
    'reversed': 'Storniert',
    'posted': 'Gebucht',
    'draft': 'Entwurf',
    'lines_count': '{{count}} Zeilen',
    'as_of_date': 'Stichtag',
    'balanced': 'Ausgeglichen',
    'out_of_balance': 'Nicht ausgeglichen',
    'net': 'Netto',
    'total_revenue': 'Gesamtertrag',
    'total_expenses': 'Gesamtaufwand',
    'net_income': 'Nettoeinkommen',
    'no_revenue_entries': 'Keine Ertragsbuchungen',
    'no_expense_entries': 'Keine Aufwandsbuchungen',
    'select_date_range_run_msg': 'Wählen Sie einen Zeitraum aus und klicken Sie auf Ausführen',
    'asset': 'Aktivum',
    'liability': 'Passivum',
    'revenue': 'Ertrag',
    'expense': 'Aufwand',
    'market': 'Markt',
    'income': 'Ertrag',
    'cost': 'Kosten',
    'broker_opinion': 'Maklermeinung',
    'appraisal': 'Gutachten',
    'waive_confirm_hint': 'Verzugsgebühr für {{name}} wird erlassen. Dies fügt eine Haben-Buchung in das Ledger ein – die ursprüngliche Gebühr bleibt für Prüfzwecke erhalten.',
    'enter_reason_error': 'Bitte geben Sie einen Grund ein',
    'enter_valid_amount_error': 'Geben Sie einen gültigen Betrag ein',
    'confirm_manual_assess': 'Verzugsgebühr für {{name}} manuell festsetzen?',
    'search_late_fees': 'Suche nach Mieter, Einheit, Gebäude...',
    'page_info': 'Seite {{current}} von {{total}}',

    'reports': 'Berichte',
    'reports_dashboard': 'Berichts-Dashboard',
    'revenue_report': 'Umsatzbericht',
    'payment_logs': 'Zahlungsprotokolle',
    'occupancy_report': 'Belegungsbericht',
    'tenant_payments': 'Mieterzahlungen',
    'building_revenue': 'Gebäudeumsatz',
    'owner_revenue': 'Eigentümerumsatz',

    'activity_logs': 'Aktivitätsprotokolle',
    'all_activities': 'Alle Aktivitäten',
    'tenant_activities': 'Mieteraktivitäten',
    'monthly_revenue': 'Monatlicher Umsatz',

    'settings': 'Einstellungen',
    'profile_settings': 'Profileinstellungen',
    'system_settings': 'Systemeinstellungen',

    'logout': 'Abmelden',
    'sales': 'Verkäufe',
    'inspections': 'Inspektionen',
    'maintenance_hub': 'Wartungszentrum',
    'vendors': 'Anbieter',
    'finance': 'Finanzen',
    'transactions': 'Transaktionen',
    'service_charges': 'Servicegebühren',
    'owner_installments': 'Ratenzahlungen des Eigentümers',
    'financial_matrix': 'Finanzielle Matrix',
    'cash_flow_forecast': '7-Tage-Prognose',
    'receivables': 'Forderungen',
    'receivables_sub': 'Geschuldetes Geld, nach Überfälligkeit.',
    'no_receivables': 'Niemand schuldet etwas.',
    'books_need_attention': 'Buchhaltung erfordert Aufmerksamkeit',
    'books_tie_out': 'Forderungen stimmen mit dem Hauptbuch überein',
    'ar_gl_drift': 'Forderungen stimmen nicht mit dem Hauptbuch überein',
    'unmirrored_charges': 'Forderungen',
    'unmirrored_payments': 'Zahlungen',
    'not_in_receivables': 'noch nicht in den Forderungen',
    'closed_periods': 'abgeschlossene Periode(n)',
    'fix_now': 'Jetzt beheben',
    'fixing': 'Wird behoben…',
    'accounting_statement': 'Kontoauszug →',
    'statement': 'Kontoauszug',
    'open_full_record': 'Vollständigen Datensatz öffnen →',
    'credit_on_account': 'Guthaben auf dem Konto',
    'opening_balance': 'Anfangssaldo',
    'closing_balance': 'Endsaldo',
    'no_activity': 'Keine Aktivität in diesem Zeitraum.',
    'charge': 'Gebühr',
    'kind_rent': 'Miete',
    'kind_service': 'Servicegebühr',
    'kind_late_fee': 'Mahngebühr',
    'kind_utility': 'Nebenkosten',
    'kind_parking': 'Parken',
    'kind_deposit': 'Kaution',
    'kind_sale_installment': 'Kaufrate',
    'kind_management_fee': 'Verwaltungsgebühr',
    'kind_maintenance_fee': 'Wartungsgebühr',
    'kind_payment': 'Zahlung',
    'ledger_activity_report': 'Hauptbuch-Aktivität',
    'management_fee_report': 'Verwaltungsgebühren',
    'messages': 'Nachrichten',
    'announcements_manager': 'Ankündigungsmanager',
    'all_announcements': 'Alle Ankündigungen',
    'subscription': 'Abonnement',
    'contract_templates': 'Vertragsvorlagen',
    'whatsapp_and_sms': 'WhatsApp & SMS',
    'late_fees_org_config': 'Säumnisgebühren & Org-Konfig',
    'building_amenities': 'Gebäudeausstattung',
    'parking_spaces': 'Parkplätze',
    'amenity_bookings': 'Ausstattungsbuchungen',
    'pm_schedules': 'PM-Zeitpläne',
    'work_orders': 'Arbeitsaufträge',
    'security_deposits': 'Kautionen',
    'expenses': 'Ausgaben',
    'late_fees': 'Säumnisgebühren',
    'bulk_owner_payout': 'Sammelauszahlung an Eigentümer',
    'utilities': 'Versorgungsleistungen',
    'kpi_dashboard': 'KPI-Dashboard',
    'portfolio': 'Portfolio',
    'general_ledger': 'Hauptbuch',
    'reports_1099': '1099-Berichte',
    'notification_log': 'Benachrichtigungsprotokoll',
    'all_messages': 'Alle Nachrichten',
    'notification_log': 'Benachrichtigungsprotokoll',

    // AI Intelligence & Sidebar
    'ai_intelligence': 'KI-Intelligenz',
    'rent_pricing_ai': 'Mietpreis-KI',
    'churn_prediction': 'Abwanderungsvorhersage',
    'showings': 'Besichtigungen',
    'tenant_surveys': 'Mieterumfragen',
    'insurance': 'Versicherung',
    'vendor_1099': 'Kreditor 1099',
    'rent_roll': 'Mietliste',
    'ar_aging': 'Offene Posten Liste',
    'webhooks': 'Webhooks',

    // AI Rent Pricing Page
    'ai_rent_pricing': 'KI-Mietpreise',
    'ai_rent_pricing_desc': 'Erhalten Sie KI-gestützte Marktmietvorschläge basierend auf Ihren Portfolio-Vergleichen, Belegung und Verlängerungstrends',
    'select_unit_to_analyze': 'Einheit zur Analyse auswählen',
    'choose_an_apartment': 'Wohnung wählen...',
    'analyze': 'Analysieren',
    'analyzing': 'Analyse läuft...',
    'ai_recommended_rent': 'KI-Empfohlene Miete',
    'range': 'Bereich',
    'high_confidence': 'Hoch',
    'medium_confidence': 'Mittel',
    'low_confidence': 'Niedrig',
    'confidence_suffix': 'Vertrauen',
    'comparable_units_found': 'Vergleichbare Einheiten ({{count}} gefunden)',
    'avg_comparable_rent': 'Durchschnitt: {{amount}}/Mo',
    'vs_suggestion': 'vs. Vorschlag',
    'select_unit_analyze_desc': 'Wählen Sie eine Einheit aus und klicken Sie auf Analysieren',
    'claude_analyze_desc': 'Die KI analysiert Vergleichswerte, Belegung und Trends, um die optimale Miete vorzuschlagen',

    // Churn Prediction Page
    'churn_prediction_desc': 'KI-Verlängerungswahrscheinlichkeit für alle aktiven Mieter',
    'run_ai_scoring': 'KI-Scoring ausführen',
    'running': 'Wird ausgeführt...',
    'high_churn_risk': 'Hohes Abwanderungsrisiko',
    'medium_risk': 'Mittleres Risiko',
    'likely_to_renew': 'Verlängerung wahrscheinlich',
    'no_churn_scores': 'Noch keine Churn-Scores vorhanden',
    'run_scoring_desc': 'Klicken Sie auf "KI-Scoring ausführen", um alle aktiven Mieter zu analysieren',
    'run_scoring_now': 'Scoring jetzt starten',
    'renewal_score': 'Verlängerungs-Score',
    'risk_level': 'Risikostufe',
    'lease_ends': 'Mietende',
    'key_factors': 'Schlüsselfaktoren',
    'send_offer': 'Angebot senden',
    'late_payments_6m': '{{count}} verspätete Zahlungen',
    'current_balance_factor': '${{amount}} Saldo',
    'prior_renewals_factor': '{{count}} vorherige Verlängerungen',

    // Showings Page
    'showings_desc': 'Besichtigungen für Interessenten planen und verfolgen',
    'schedule_showing': 'Besichtigung planen',
    'upcoming': 'Anstehend',
    'today': 'Heute',
    'no_shows': 'Nichterscheinen',
    'all': 'Alle',
    'no_showings_found': 'Keine Besichtigungen gefunden',
    'schedule_first_showing': 'Erste Besichtigung planen',
    'prospect': 'Interessent',
    'unit': 'Einheit',
    'date_and_time': 'Datum & Zeit',
    'scheduled': 'Geplant',
    'completed': 'Abgeschlossen',
    'cancelled': 'Storniert',
    'no_show': 'Nichterscheinen',
    'edit_showing': 'Besichtigung bearbeiten',
    'prospect_name': 'Name des Interessenten',
    'prospect_phone': 'Telefon',
    'prospect_email': 'E-Mail',
    'start_time': 'Startzeit',
    'end_time': 'Endzeit',
    'assigned_to': 'Zugewiesen an',
    'notes': 'Notizen',

    // Insurance Page
    'insurance_tracking': 'Versicherungs-Tracking',
    'insurance_desc': 'Versicherungspolicen für Mieter, Eigentümer und Gebäude verwalten',
    'add_policy': 'Police hinzufügen',
    'expiring_30d': 'Läuft in 30 Tagen ab',
    'total_coverage': 'Gesamtdeckung',
    'all_status': 'Alle Status',
    'all_types': 'Alle Typen',
    'no_policies_found': 'Keine Policen gefunden',
    'add_first_policy': 'Erste Police hinzufügen',
    'entity': 'Einheit/Person',
    'insurer': 'Versicherer',
    'policy_type': 'Versicherungsart',
    'coverage': 'Deckung',
    'expiry': 'Ablaufdatum',
    'expired_days_ago': 'Vor {{days}} Tagen abgelaufen',
    'days_left': 'noch {{days}} Tage',
    'edit_policy': 'Police bearbeiten',
    'entity_type': 'Einheitentyp',
    'policy_number': 'Versicherungsnummer',
    'coverage_amount': 'Deckungssumme',
    'annual_premium': 'Jahresprämie',
    'start_date': 'Startdatum',
    'expiry_date': 'Ablaufdatum',
    'document_url': 'Dokument-URL (COI-Link)',

    // Survey Results Page
    'tenant_surveys_desc': 'CSAT-Bewertungen und Feedback von Mietern',
    'overall_rating': 'Gesamtbewertung',
    'distribution': 'Verteilung',
    'by_category': 'Nach Kategorie',
    'no_surveys_yet': 'Noch keine Umfragen vorhanden',
    'tenants_submit_feedback_desc': 'Mieter können Feedback über ihr Portal einreichen',

    // Financial Matrix
    'financial_matrix_subtitle': 'Einheitliche Ansicht aller Finanzaktivitäten über alle Einheiten',
    'total_charged': 'Gesamt berechnet',
    'total_collected': 'Gesamt eingezogen',
    'overdue_balance': 'Überfälliger Saldo',
    'partial_balance': 'Teilsaldo',
    'all_floors': 'Alle Etagen',
    'floor_label': 'Etage',
    'legend_paid': 'Bezahlt',
    'legend_partial': 'Teilweise',
    'legend_overdue': 'Überfällig',
    'legend_upcoming': 'Anstehend',
    'legend_no_charges': 'Keine Gebühren',
    'table_unit': 'Einheit',
    'table_now': 'jetzt',
    'no_apartments_found_building': 'Keine Wohnungen für dieses Gebäude gefunden.',
    'view_all': 'Alle',
    'view_rent': 'Miete',
    'view_service': 'Service',
    'view_sales': 'Verkäufe',

    // Cash Flow Forecast
    'cash_flow_subtitle': 'Bevorstehende erwartete Zahlungen von Mietern und Eigentümern',
    'expected_this_period': 'Erwartet in diesem Zeitraum',
    'total_overdue_balance': 'Gesamter überfälliger Saldo',
    'collected_today': 'Heute gesammelt',
    'no_upcoming_payments': 'Keine anstehenden Zahlungen in diesem Zeitraum.',
    'today': 'Heute',
    'overdue_label': 'ÜBERFÄLLIG',
    'expected_label': 'erwartet',

    // Quick Pay
    'quick_pay': 'Schnellzahlung',
    'recording': 'Aufzeichnung...',
    'record_payment_btn': '{{amount}} Zahlung erfassen',
    'no_active_tenant_error': 'Kein aktiver Mieter — Zahlung kann hier nicht erfasst werden.',
    'view_full_ledger': 'Vollständiges Hauptbuch für {{name}} anzeigen',
    'full_payment_form': 'Vollständiges Zahlungsformular',
    'enter_valid_amount': 'Geben Sie einen gültigen Betrag ein',
    'no_active_tenant_found': 'Kein aktiver Mieter für diese Einheit gefunden',
    'payment_recorded_success': 'Zahlung erfolgreich erfasst',
    'treasury_quick_pay': 'Tresor-Schnellzahlung',
    'payment_amount': 'Zahlungsbetrag',
    'memo': 'Vermerk / Referenz',
    'add_a_note_about_this_treasury_event': 'Notiz zu diesem Vorgang hinzufügen...',
    'view_owner_file_and_distribution': 'Eigentümerakte & Verteilung ansehen',
    'view_resident_ledger': 'Bewohner-Ledger ansehen',
    'processing': 'Verarbeitung...',
    'confirm_and_record': 'Bestätigen & Erfassen',
    'no_entity_found': 'Kein Mieter oder Eigentümer für diese Einheit gefunden',
    'owner_view': 'Eigentümer',
    'tenant_view': 'Mieter',
    'search_owner_unit_building': 'Eigentümer, Einheit oder Gebäude suchen...',
    'showing_all_installments': 'Alle {{count}} Raten werden angezeigt',
    'showing_overdue_within_days': 'Zeigt überfällige + fällige Zahlungen innerhalb von {{days}} Tagen · {{hidden}} zukünftige Raten ausgeblendet',
    'hide_future_count': 'Zukünftige ausblenden ({{count}})',
    'show_all_future_count': 'Alle Zukünftigen anzeigen ({{count}})',
    'no_overdue_upcoming_all_clear': 'Keine überfälligen oder bevorstehenden Zahlungen — alles in Ordnung!',
    'no_records_match_search': 'Keine Einträge entsprechen Ihrer Suche.',

    // Months Short
    'jan_short': 'Jan', 'feb_short': 'Feb', 'mar_short': 'Mär', 'apr_short': 'Apr', 'may_short': 'Mai', 'jun_short': 'Jun',
    'jul_short': 'Jul', 'aug_short': 'Aug', 'sep_short': 'Sep', 'oct_short': 'Okt', 'nov_short': 'Nov', 'dec_short': 'Dez',

    // Months Full
    'january': 'Januar', 'february': 'Februar', 'march': 'März', 'april': 'April', 'may': 'Mai', 'june': 'Juni',
    'july': 'Juli', 'august': 'August', 'september': 'September', 'october': 'Oktober', 'november': 'November', 'december': 'Dezember',

    // AI Assistant
    'ai_assistant': 'KI-Assistent',
    'ask_ai': 'KI fragen',
    'ai_greeting': "Hallo! Ich bin Ihr KI-Finanzanalyst. Wie kann ich Ihnen heute helfen?",
    'ai_error': "Entschuldigung, ich konnte das nicht verarbeiten. Bitte versuchen Sie es erneut.",
    'analyzing_data': 'Daten werden analysiert...',
    'ai_placeholder': 'Was möchten Sie wissen?',
    'overdue_tenants_q': 'Welche Mieter sind überfällig?',
    'revenue_30d_q': 'Umsatz der letzten 30 Tage?',
    'expenses_month_q': 'Ausgaben diesen Monat?',
    'utility_pending_q': 'Nebenkostenabrechnungen ausstehend?',
    'kpi_noi_summary_q': 'KPI & NOI Zusammenfassung?',
    'security_deposits_q': 'Gehaltene Kautionen?',
    'late_fees_q': 'Berechnete Säumnisgebühren?',
    'owner_payouts_q': 'Auszahlungen an Eigentümer diesen Monat?',


    // Apartment Detail View
    'loading_apartment_details': 'Wohnungsdetails werden geladen...',
    'error_loading_apartment': 'Fehler beim Laden der Wohnungsdetails',
    'try_again': 'Erneut versuchen',
    'back_to_apartments': 'Zurück zu den Wohnungen',
    'apartment_not_found': 'Wohnung nicht gefunden',
    'apartment_not_found_message': 'Die gesuchte Wohnung existiert nicht oder wurde entfernt.',

    'building_and_location': 'Gebäude & Standort',
    'building': 'Gebäude',
    'floor': 'Etage',
    'address': 'Adresse',

    'apartment_details': 'Wohnungsdetails',
    'apartment_type': 'Typ',
    'size': 'Größe',
    'furnished': 'Möbliert',

    'owner_information': 'Eigentümerinformationen',
    'owner_name': 'Name',
    'owner_contact': 'Kontakt',

    'additional_information': 'Zusätzliche Informationen',
    'created_at': 'Erstellt am',
    'updated_at': 'Zuletzt aktualisiert',

    'status_management': 'Statusverwaltung',
    'status_vacant': 'Leerstehend',
    'status_occupied': 'Vermietet',
    'status_maintenance': 'In Wartung',
    'status_vacant_description': 'Zur Miete oder Pacht verfügbar',
    'status_occupied_description': 'Derzeit an einen Mieter vermietet',
    'status_maintenance_description': 'Wird derzeit gewartet oder renoviert',
    'change_status': 'Status ändern zu',

    'quick_actions': 'Schnellaktionen',
    'create_lease': 'Mietvertrag erstellen',
    'view_tenant_info': 'Mieterinformationen ansehen',
    'mark_maintenance_complete': 'Wartung als abgeschlossen markieren',
    'view_building': 'Gebäude ansehen',
    'edit_apartment': 'Wohnung bearbeiten',

    'same_building_apartments': 'Selbes Gebäude',
    'view_all_apartments_in_building': 'Alle Wohnungen im Gebäude ansehen',
    'view_vacant_apartments': 'Leerstehende Wohnungen ansehen',

    // Delete confirmation
    'delete_apartment_confirmation': 'Sind Sie sicher, dass Sie die Wohnung "{{name}}" löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',

    // Apartment Form
    'loading_apartment_data': 'Wohnungsdaten werden geladen...',
    'edit_apartment': 'Wohnung bearbeiten',
    'add_new_apartment': 'Neue Wohnung hinzufügen',

    'basic_information': 'Grundinformationen',
    'apartment_number': 'Wohnungsnummer',
    'enter_apartment_number': 'Wohnungsnummer eingeben',
    'floor_number': 'Etagen-Nummer',
    'enter_floor_number': 'Etagen-Nummer eingeben',
    'size_sqm': 'Größe (m²)',
    'enter_size': 'Größe in Quadratmetern eingeben',
    'apartment_type': 'Wohnungstyp',
    'select_apartment_type': 'Wohnungstyp auswählen',
    'select_building': 'Gebäude auswählen',
    'furnished': 'Möbliert',

    // Validation messages
    'floor_required': 'Etage ist erforderlich',
    'apartment_number_required': 'Wohnungsnummer ist erforderlich',
    'size_required': 'Größe ist erforderlich',
    'type_required': 'Typ ist erforderlich',
    'building_required': 'Gebäude ist erforderlich',
    'invalid_size': 'Die Größe muss größer als 0 sein',

    // Form actions
    'update': 'Aktualisieren',
    'save': 'Speichern',
    'saving': 'Speichern...',


    // Apartment List
    'apartments': 'Wohnungen',
    'search_apartments': 'Wohnungen suchen...',
    'filter': 'Filter',
    'grid_view': 'Raster',
    'list_view': 'Liste',
    'add_apartment': 'Wohnung hinzufügen',
    'all_buildings': 'Alle Gebäude',
    'all_types': 'Alle Typen',
    'all_statuses': 'Alle Status',
    'all': 'Alle',
    'vacant_apartments': 'Leerstehende Wohnungen',
    'occupied_apartments': 'Vermietete Wohnungen',
    'maintenance_apartments': 'In Wartung',
    'loading_apartments': 'Wohnungen werden geladen...',
    'error_loading_apartments': 'Fehler beim Laden der Wohnungen',
    'no_apartments_found': 'Keine Wohnungen gefunden',
    'no_apartments_message': 'Es befinden sich noch keine Wohnungen im System.',
    'create_first_apartment': 'Erste Wohnung erstellen',
    'showing_filtered_results': 'Zeige {{showing}} von {{total}} Wohnungen',

    // Statuses
    'vacant': 'Leerstehend',
    'occupied': 'Vermietet',
    'maintenance': 'In Wartung',

    // Apartment card
    'furnished': 'Möbliert',

    // Delete confirmation
    'delete_apartment_confirmation': 'Sind Sie sicher, dass Sie die Wohnung "{{name}}" löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
    'deleting': 'Wird gelöscht...',


    // Bulk Apartment Creator
    'bulk_apartment_creation': 'Massen-Wohnungserstellung',
    'preview': 'Vorschau',
    'apartment_number_format': 'Wohnungsnummern-Format',
    'format_pattern': 'Formatmuster',
    'format_pattern_help': 'Verwenden Sie {floor} für die Etagennummer und {unit} für die Einheitsnummer. Beispiel: {floor}{unit} = 0201',
    'preview_example': 'Vorschaubeispiel',
    'floor_plans': 'Grundrisse',
    'add_floor_plan': 'Grundriss hinzufügen',
    'floor_plan_number': 'Grundriss {number}',
    'floors_comma_separated': 'Etagen (kommagetrennt)',
    'unit_types': 'Einheitstypen',
    'add_unit_type': 'Einheitstyp hinzufügen',
    'unit_type_number': 'Einheitstyp {number}',
    'name': 'Name',
    'quantity': 'Menge',
    'type': 'Typ',
    'area_sqm': 'Fläche (m²)',
    'furnished': 'Möbliert',
    'apartment_preview_count': 'Wohnungsvorschau ({count} Einheiten)',
    'floor_unit_type': 'Etage {floor} • {type}',
    'close': 'Schließen',
    'create_apartments': 'Wohnungen erstellen',
    'create_apartments_count': '{count} Wohnungen erstellen',
    'creating_apartments': 'Wohnungen werden erstellt...',
    'add_at_least_one_floor_plan': 'Bitte fügen Sie mindestens einen Grundriss hinzu',
    'no_apartments_to_create': 'Keine Wohnungen zu erstellen',


    'building_name_required': 'Gebäudename ist erforderlich',
    'building_address_required': 'Gebäudeadresse ist erforderlich',
    'invalid_floors': 'Die Gesamtanzahl der Etagen muss mindestens 1 betragen',
    'invalid_apartments': 'Die Gesamtanzahl der Wohnungen muss mindestens 0 betragen',
    'loading_building_data': 'Gebäudedaten werden geladen...',
    'edit_building': 'Gebäude bearbeiten',
    'add_new_building': 'Neues Gebäude hinzufügen',
    'basic_information': 'Grundinformationen',
    'building_name': 'Gebäudename',
    'enter_building_name': 'Gebäudenamen eingeben',
    'total_floors': 'Gesamtanzahl Etagen',
    'number_of_floors': 'Anzahl der Etagen',
    'total_apartments': 'Gesamtanzahl Wohnungen',
    'number_of_apartments': 'Anzahl der Wohnungen',
    'address': 'Adresse',
    'enter_complete_building_address': 'Vollständige Gebäudeadresse eingeben',
    'cancel': 'Abbrechen',
    'saving': 'Speichern...',
    'update': 'Aktualisieren',
    'save': 'Speichern',


    'buildings': 'Gebäude',
    'search_buildings': 'Gebäude suchen...',
    'bulk_add_apartments': 'Wohnungen in großen Mengen hinzufügen',
    'add_building': 'Gebäude hinzufügen',
    'loading_buildings': 'Gebäude werden geladen...',
    'error_loading_buildings': 'Fehler beim Laden der Gebäude',
    'try_again': 'Erneut versuchen',
    'no_buildings_found': 'Keine Gebäude gefunden',
    'no_buildings_yet': 'Noch keine Gebäude',
    'no_buildings_match_search': 'Keine Gebäude entsprechen "{{search}}"',
    'no_buildings_message': 'Es befinden sich noch keine Gebäude im System. Fügen Sie Ihr erstes Gebäude hinzu, um zu beginnen.',
    'create_first_building': 'Erstes Gebäude erstellen',
    'showing_filtered_results': 'Zeige {{showing}} von {{total}} Gebäuden',
    'floors': 'Etagen',
    'apartments': 'Wohnungen',
    'occupancy': 'Auslastung',
    'vacant': 'Leerstehend',
    'occupied': 'Vermietet',
    'no_apartments_yet': 'Noch keine Wohnungen',
    'add_apartments': '+ Wohnungen hinzufügen',
    'confirm_deletion': 'Löschen bestätigen',
    'delete_building_confirmation': 'Sind Sie sicher, dass Sie das Gebäude "{{name}}" löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
    'cancel': 'Abbrechen',
    'deleting': 'Wird gelöscht...',
    'delete': 'Löschen',
    'create_building_first': 'Bitte erstellen Sie zuerst ein Gebäude',
    'create': 'Wohnungen erstellen',
    'unnamed_building': 'Unbenanntes Gebäude',
    'no_address_provided': 'Keine Adresse angegeben',

    'select_building_for_bulk_creation': 'Gebäude für die Massen-Wohnungserstellung auswählen',

    'loading_building_details': 'Gebäudedetails werden geladen...',
    'error_loading_building': 'Fehler beim Laden des Gebäudes',
    'try_again': 'Erneut versuchen',
    'back_to_buildings': 'Zurück zu den Gebäuden',
    'building_not_found': 'Gebäude nicht gefunden',
    'building_not_found_message': 'Das gesuchte Gebäude existiert nicht oder wurde entfernt.',
    'add_apartment': 'Wohnung hinzufügen',
    'edit_building': 'Gebäude bearbeiten',
    'generate_reports': 'Berichte generieren',
    'total_apartments': 'Gesamtanzahl Wohnungen',
    'units': 'Einheiten',
    'across_floors': 'Über {{floors}} Etagen',
    'vacant_apartments': 'Leerstehend',
    'available_for_rent': 'Zur Miete verfügbar',
    'no_vacancies': 'Keine freien Wohnungen',
    'occupancy_rate': 'Belegungsquote',
    'occupied_units': 'Vermietete Einheiten',
    'maintenance_apartments': 'Wartung',
    'needs_attention': 'Erfordert Aufmerksamkeit',
    'average_apartment_size': 'Durchschnittliche Größe',
    'furnished_apartments': 'Möbliert',
    'utility_status': 'Versorgungsstatus',
    'water': 'Wasser',
    'electricity': 'Strom',
    'internet': 'Internet',
    'hide_details': 'Details ausblenden',
    'show_details': 'Details anzeigen',
    'search_apartments': 'Suchen nach Wohnungen, Eigentümern, Mietern...',
    'all_statuses': 'Alle Status',
    'vacant': 'Leerstehend',
    'occupied': 'Vermietet',
    'maintenance': 'Wartung',
    'top_floor_first': 'Oberste Etage zuerst',
    'ground_floor_first': 'Erdgeschoss zuerst',
    'showing_results': 'Zeige {{count}} von {{total}} Wohnungen',
    'matching': 'übereinstimmend',
    'with_status': 'mit Status',
    'no_apartments_found': 'Keine Wohnungen gefunden',
    'no_apartments_match_filters': 'Keine Wohnungen entsprechen Ihren aktuellen Filtern.',
    'clear_filters': 'Filter zurücksetzen',
    'floor_number': 'Etage {{number}}',
    'apartments': 'Wohnungen',
    'owner': 'Eigentümer',
    'status': 'Status',
    'vacant_status': 'Verfügbar',
    'maintenance_status': 'In Wartung',
    'furnished': 'Möbliert',
    'unfurnished': 'Unmöbliert',
    'no_matching_apartments_on_floor': 'Keine Wohnungen auf Etage {{floor}} entsprechen Ihren aktuellen Filtern.',
    'construction_year': 'Baujahr: {{year}}',

    'activity_logs': 'Aktivitätsprotokolle',
    'track_all_system_activities': 'Verfolgen Sie alle Systemaktivitäten und Änderungen',
    'filter': 'Filtern',
    'export_to_excel': 'Nach Excel exportieren',
    'exporting': 'Exportiere...',
    'filter_logs': 'Protokolle filtern',
    'action_type': 'Aktionstyp',
    'all_actions': 'Alle Aktionen',
    'entity_type': 'Entitätstyp',
    'all_entities': 'Alle Entitäten',
    'entries_per_page': 'Einträge pro Seite',
    'start_date': 'Startdatum',
    'end_date': 'Enddatum',
    'reset': 'Zurücksetzen',
    'apply_filter': 'Filter anwenden',
    'previous': 'Zurück',
    'next': 'Weiter',
    'tenant_activity_logs': 'Mieter-Aktivitätsprotokolle',
    'payment_activity_logs': 'Zahlungs-Aktivitätsprotokolle',
    'building_activity_logs': 'Gebäude-Aktivitätsprotokolle',
    'apartment_activity_logs': 'Wohnungs-Aktivitätsprotokolle',
    'owner_activity_logs': 'Eigentümer-Aktivitätsprotokolle',
    'user_activity_logs': 'Benutzer-Aktivitätsprotokolle',
    'system_activity_logs': 'System-Aktivitätsprotokolle',

    'monthly_revenue_by_user': 'Monatlicher Umsatz nach Benutzer',
    'export_to_excel': 'Nach Excel exportieren',
    'exporting': 'Exportiere...',
    'total_revenue': 'Gesamter Umsatz',
    'total_payments': 'Gesamte Zahlungen',
    'recorded_by': 'Erfasst von',
    'average_payment': 'Durchschnittliche Zahlung',
    'per_transaction': 'Pro Transaktion',
    'revenue_by_user': 'Umsatz nach Benutzer',
    'no_revenue_data': 'Keine Umsatzdaten',
    'no_revenue_data_message': 'Keine Zahlungsdatensätze für {{month}} {{year}} gefunden. Versuchen Sie, einen anderen Monat oder ein anderes Jahr auszuwählen.',


    'loading_owner_data': 'Eigentümerdaten werden geladen...',
    'error_loading_owner': 'Fehler beim Laden des Eigentümers',
    'back_to_owners': 'Zurück zu den Eigentümern',
    'send_reminder': 'Erinnerung senden',
    'edit': 'Bearbeiten',
    'overview': 'Übersicht',
    'properties': 'Wohnungen',
    'payments': 'Zahlungen',
    'contracts': 'Verträge',
    'outstanding': 'Ausstehend',
    'financial_overview': 'Finanzielle Übersicht',
    'portfolio_summary': 'Portfolio-Zusammenfassung',
    'financial_ledger': 'Finanzbuch',
    'no_installments': 'Keine Raten in Ihrem Buch gefunden.',
    'total_outstanding': 'Gesamt ausstehend',
    'management_agreement': 'Verwaltungsvertrag',
    'my_agreements': 'Meine Verträge',
    'active_agreements': 'Aktive Verträge',
    'no_active_agreements': 'Keine aktiven Verträge',
    'remaining': 'Verbleibend',
    'total_value': 'Gesamtwert',
    'contact_information': 'Kontaktinformationen',
    'property_overview': 'Immobilienübersicht',
    'add_apartment': 'Wohnung hinzufügen',
    'no_properties': 'Keine Wohnungen',
    'no_properties_message': 'Dieser Eigentümer hat noch keine Wohnungen.',
    'add_first_property': 'Erste Wohnung hinzufügen',
    'view_details': 'Details ansehen',
    'payment_history': 'Zahlungsverlauf',
    'no_payments': 'Keine Zahlungen',
    'no_payments_message': 'Es wurden noch keine Zahlungen erfasst.',
    'outstanding_fees': 'Ausstehende Gebühren',
    'no_outstanding_fees': 'Keine ausstehenden Gebühren',
    'all_fees_paid': 'Alle Gebühren sind auf dem neuesten Stand.',
    'total_outstanding': 'Gesamt ausstehend',
    'add_payment': 'Zahlung hinzufügen',
    'property': 'Wohnung',
    'select_property': 'Wohnung auswählen',
    'amount': 'Betrag',
    'payment_date': 'Zahlungsdatum',
    'payment_method': 'Zahlungsmethode',
    'cash': 'Bargeld',
    'bank_transfer': 'Banküberweisung',
    'check': 'Scheck',
    'credit_card': 'Kreditkarte',
    'online_payment': 'Online-Zahlung',
    'reference_number': 'Referenznummer',
    'notes': 'Notizen',
    'cancel': 'Abbrechen',

    'owner_information': 'Eigentümerinformationen',
    'name': 'Name',
    'phone': 'Telefon',
    'owner_lives_property': 'Eigentümer wohnt im Objekt',
    'select_apartments': 'Wohnungen auswählen',
    'available_apartments': 'verfügbare Wohnungen',
    'no_apartments_available': 'Keine Wohnungen verfügbar. Alle Wohnungen haben bereits Eigentümer.',
    'apartment_number': 'Wohnung {{number}}',
    'floor': 'Etage',
    'size': 'Größe',
    'type': 'Typ',
    'status': 'Status',
    'cancel': 'Abbrechen',
    'saving': 'Speichern...',
    'update_owner': 'Eigentümer aktualisieren',
    'create_owner': 'Eigentümer erstellen',
    'edit_property_owner': 'Immobilieneigentümer bearbeiten',
    'add_property_owner': 'Immobilieneigentümer hinzufügen',

    'property_owners': 'Immobilieneigentümer',
    'add_owner': 'Eigentümer hinzufügen',
    'search_owners': 'Eigentümer suchen...',
    'filter': 'Filtern',
    'list_view': 'Liste',
    'grid_view': 'Raster',
    'export': 'Exportieren',
    'exporting': 'Exportiere...',

    // Owner Contracts & Installments - NEW
    'owner_contracts': 'Eigentümerverträge',
    'contracts': 'Verträge',
    'add_contract': 'Vertrag hinzufügen',
    'contract_details': 'Vertragsdetails',
    'installments': 'Raten',
    'installment_details': 'Ratendetails',
    'pay_now': 'Jetzt bezahlen',
    'contract_type': 'Vertragsart',
    'purchase_agreement': 'Kaufvertrag',
    'service_agreement': 'Servicevertrag',
    'next_installment': 'Nächste Rate',
    'outstanding_balance': 'Ausstehender Restbetrag',
    'total_contract_value': 'Gesamter Vertragswert',
    'installment_plan': 'Ratenplan',
    'payment_successful': 'Zahlung erfolgreich! Ihre Daten werden in Kürze aktualisiert.',
    'payment_canceled': 'Die Zahlung wurde abgebrochen.',
    'redirecting_to_payment': 'Weiterleitung zur sicheren Zahlung...',
    'no_contracts_found': 'Keine Verträge gefunden.',
    'no_installments_found': 'Keine Raten gefunden.',

    'living_status': 'Wohnstatus',
    'all': 'Alle',
    'living_on_property': 'Wohnt im Objekt',
    'not_living_on_property': 'Wohnt nicht im Objekt',
    'country': 'Land',
    'all_countries': 'Alle Länder',
    'apartment_status': 'Wohnungsstatus',
    'all_statuses': 'Alle Status',
    'with_vacant': 'Mit leerstehenden Wohnungen',
    'fully_occupied': 'Vollständig vermietet',
    'with_maintenance': 'Mit Wartung',
    'min_apartments': 'Min. Wohnungen',
    'max_apartments': 'Max. Wohnungen',
    'min_occupancy_rate': 'Min. Belegungsquote (%)',
    'clear_filters': 'Filter zurücksetzen',
    'apply_filters': 'Filter anwenden',
    'total_owners': 'Gesamte Eigentümer',
    'resident_owners': 'Ansässige Eigentümer',
    'with_apartments': 'Mit Wohnungen',
    'without_apartments': 'Ohne Wohnungen',
    'loading_owners': 'Eigentümer werden geladen...',
    'error_loading_owners': 'Fehler beim Laden der Eigentümer',
    'try_again': 'Erneut versuchen',
    'no_owners_found': 'Keine Immobilieneigentümer gefunden',
    'no_owners_message': 'Es gibt noch keine Immobilieneigentümer im System. Klicken Sie auf die Schaltfläche \'Eigentümer hinzufügen\', um Ihren ersten Eigentümer zu erstellen.',
    'create_first_owner': 'Ersten Eigentümer erstellen',
    'showing_filtered_results': 'Zeige {showing} von {total} Eigentümern',
    'confirm_deletion': 'Löschen bestätigen',
    'delete_owner_confirmation': 'Sind Sie sicher, dass Sie den Eigentümer "{name}" löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
    'cancel': 'Abbrechen',
    'delete': 'Löschen',
    'deleting': 'Wird gelöscht...',

    'resident_owner': 'Ansässiger Eigentümer',
    'apartments_count': 'Anzahl Wohnungen',
    'show_apartments': 'Wohnungen anzeigen',
    'hide_apartments': 'Wohnungen ausblenden',
    'size_unit_sqm': 'Einheitsgröße Quadratmeter',

    "loading": "Wird geladen...",
    "edit_property_owner": "Immobilieneigentümer bearbeiten",
    "add_property_owner": "Immobilieneigentümer hinzufügen",
    "owner_information": "Eigentümerinformationen",
    "name": "Name",
    "phone": "Telefon",
    "owner_lives_on_property": "Eigentümer wohnt im Objekt",
    "select_apartments": "Wohnungen auswählen ({{count}})",
    "available_apartments": "{{count}} verfügbare Wohnungen",
    "no_apartments_available": "Keine Wohnungen verfügbar. Alle Wohnungen haben bereits Eigentümer.",
    "floor": "Etage",
    "size": "Größe",
    "size_unit_sqm": "m²",
    "type": "Typ",
    "status": "Status",
    "cancel": "Abbrechen",
    "saving": "Speichern...",
    "update_owner": "Eigentümer aktualisieren",
    "create_owner": "Eigentümer erstellen",
    "failed_to_load_data": "Daten konnten nicht geladen werden",
    "failed_to_save_owner": "Eigentümer konnte nicht gespeichert werden",


    "activity_logs": "Aktivitätsprotokolle",
    "tenant_activity_logs": "Mieter-Aktivitätsprotokolle",
    "payment_activity_logs": "Zahlungs-Aktivitätsprotokolle",
    "building_activity_logs": "Gebäude-Aktivitätsprotokolle",
    "apartment_activity_logs": "Wohnungs-Aktivitätsprotokolle",
    "owner_activity_logs": "Eigentümer-Aktivitätsprotokolle",
    "user_activity_logs": "Benutzer-Aktivitätsprotokolle",
    "system_activity_logs": "System-Aktivitätsprotokolle",
    "track_all_system_activities": "Verfolgen Sie alle Systemaktivitäten und Änderungen",
    "filter": "Filtern",
    "export_to_excel": "Nach Excel exportieren",
    "exporting": "Exportiere...",
    "search_logs_placeholder": "Protokolle nach Name, Benutzer oder Details suchen...",
    "showing_entries": "Zeige {{showing}} von {{total}} Einträgen",
    "filter_logs": "Protokolle filtern",
    "action_type": "Aktionstyp",
    "all_actions": "Alle Aktionen",
    "entity_type": "Entitätstyp",
    "all_entities": "Alle Entitäten",
    "entries_per_page": "Einträge pro Seite",
    "start_date": "Startdatum",
    "end_date": "Enddatum",
    "reset": "Zurücksetzen",
    "apply_filter": "Filter anwenden",
    "time": "Zeit",
    "user": "Benutzer",
    "action": "Aktion",
    "entity": "Entität",
    "details": "Details",
    "view": "Ansehen",
    "system": "System",
    "view_entity_details": "Details von {{type}} ansehen",
    "no_logs_matching_search": "Keine Aktivitätsprotokolle entsprechen Ihren Suchkriterien",
    "no_logs_for_filters": "Keine Aktivitätsprotokolle für die ausgewählten Filter gefunden",
    "showing_range": "Zeige {{start}} bis {{end}} von {{total}} Einträgen",
    "previous": "Zurück",
    "next": "Weiter",
    "failed_to_load_logs": "Aktivitätsprotokolle konnten nicht geladen werden",
    "failed_to_export_logs": "Protokolle konnten nicht nach Excel exportiert werden",

    "tenant": "Mieter",
    "payment": "Zahlung",
    "building": "Gebäude",
    "apartment": "Wohnung",
    "owner": "Eigentümer",
    "user": "Benutzer",
    "system": "System",

    "created": "Erstellt",
    "updated": "Aktualisiert",
    "deleted": "Gelöscht",
    "viewed": "Angesehen",
    "login": "Anmeldung",
    "logout": "Abmeldung",
    "payment_made": "Zahlung getätigt",
    "payment_received": "Zahlung erhalten",
    "status_changed": "Status geändert",
    "approved": "Genehmigt",
    "rejected": "Abgelehnt",
    "maintenance_request": "Wartungsanfrage",
    "maintenance_completed": "Wartung abgeschlossen",

    "loading_payment_data": "Zahlungsdaten werden geladen...",
    "error_loading_payment": "Fehler beim Laden der Zahlung",
    "payment_not_found": "Zahlung nicht gefunden",
    "back_to_payments": "Zurück zu den Zahlungen",
    "confirm_deletion": "Löschen bestätigen",
    "delete_payment_confirmation": "Sind Sie sicher, dass Sie diese Zahlung in Höhe von {{amount}} löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
    "cancel": "Abbrechen",
    "deleting": "Wird gelöscht...",
    "delete": "Löschen",
    "print_receipt": "Quittung drucken",
    "edit": "Bearbeiten",
    "tenant": "Mieter",
    "unknown_tenant": "Unbekannter Mieter",
    "apartment": "Wohnung",
    "apt": "Whg",
    "none": "Keine",
    "payment_period": "Zahlungszeitraum",
    "payment_details": "Zahlungsdetails",
    "tenant_information": "Mieterinformationen",
    "payment_information": "Zahlungsinformationen",
    "amount": "Betrag",
    "payment_date": "Zahlungsdatum",
    "payment_type": "Zahlungsart",
    "created": "Erstellt",
    "last_updated": "Zuletzt aktualisiert",
    "notes": "Notizen",
    "view_tenant": "Mieter ansehen",
    "unknown_period": "Unbekannter Zeitraum",
    "to": "bis",
    "invalid_period_data": "Ungültige Zeitraumsdaten",
    "unknown_type": "Unbekannter Typ",
    "unknown": "Unbekannt",
    "failed_to_load_payment_data": "Zahlungsdaten konnten nicht geladen werden",
    "failed_to_delete_payment": "Zahlung konnte nicht gelöscht werden",

    "rent": "Miete",
    "service": "Servicegebühr",
    "deposit": "Kaution",
    "maintenance": "Wartung",
    "other": "Andere",


    "generate": "Generieren",
    "generated": "Generiert",
    "generate_payment_for": "Zahlung generieren für",
    "payment_amount": "Zahlungsbetrag",
    "enter_amount": "Betrag eingeben",
    "mark_as_paid_immediately": "Sofort als bezahlt markieren",
    "notes": "Notizen",
    "payment_notes": "Zahlungsnotizen",
    "required_fields": "Pflichtfelder",
    "cancel": "Abbrechen",
    "generate_payment": "Zahlung generieren",

    "loading": "Wird geladen...",
    "edit_payment": "Zahlung bearbeiten",
    "record_payment": "Zahlung erfassen",
    "payment_information": "Zahlungsinformationen",
    "tenant": "Mieter",
    "select_tenant": "Mieter auswählen",
    "apt": "Whg",
    "no_apartment": "Keine Wohnung",
    "amount": "Betrag",
    "payment_date": "Zahlungsdatum",
    "payment_type": "Zahlungsart",
    "payment_period": "Zahlungszeitraum",
    "period_start": "Zeitraum Beginn",
    "period_end": "Zeitraum Ende",
    "additional_information": "Zusätzliche Informationen",
    "notes": "Notizen",
    "notes_placeholder": "Zusätzliche Notizen zu dieser Zahlung...",
    "cancel": "Abbrechen",
    "saving": "Speichern...",
    "update_payment": "Zahlung aktualisieren",
    "failed_to_load_tenants_format": "Laden der Mieter fehlgeschlagen: Unerwartetes Datenformat",
    "failed_to_load_tenants": "Mieter konnten nicht geladen werden. Bitte versuchen Sie es erneut.",
    "failed_to_load_payment_data": "Zahlungsdaten konnten nicht geladen werden",
    "failed_to_save_payment": "Zahlung konnte nicht gespeichert werden",

    "rent": "Miete",
    "service": "Servicegebühr",
    "deposit": "Kaution",
    "maintenance": "Wartung",
    "other": "Andere",

    "payments": "Zahlungen",
    "refresh": "Aktualisieren",
    "refresh_payments": "Zahlungen aktualisieren",
    "stats": "Statistiken",
    "toggle_statistics": "Statistikansicht umschalten",
    "search_payments": "Zahlungen suchen...",
    "filter": "Filtern",
    "record_payment": "Zahlung erfassen",
    "confirm_deletion": "Löschen bestätigen",
    "confirm_delete_payment": "Sind Sie sicher, dass Sie die Zahlung in Höhe von {amount} für {tenantName} löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
    "cancel": "Abbrechen",
    "deleting": "Wird gelöscht...",
    "delete": "Löschen",
    "filter_payments": "Zahlungen filtern",
    "reset_all": "Alle zurücksetzen",
    "payment_type": "Zahlungsart",
    "all_types": "Alle Typen",
    "payment_type_rent": "Miete",
    "payment_type_service": "Service",
    "payment_type_deposit": "Kaution",
    "payment_type_other": "Andere",

    "payment_type_commission": "Provision",
    "payment_type_security_deposit": "Kaution",    "building": "Gebäude",
    "all_buildings": "Alle Gebäude",
    "from_date": "Von Datum",
    "to_date": "Bis Datum",
    "total_payments": "Gesamte Zahlungen",
    "payment": "Zahlung",
    "payments": "Zahlungen",
    "recorded": "erfasst",
    "rent_payments": "Mietzahlungen",
    "service_payments": "Servicezahlungen",
    "payment_statistics": "Zahlungsstatistiken",
    "payments_by_month": "Zahlungen nach Monat",
    "payment_types_distribution": "Verteilung der Zahlungsarten",
    "recent_activity": "Letzte Aktivität",
    "close_statistics": "Statistiken schließen",
    "loading_payments": "Zahlungen werden geladen...",
    "this_may_take_moment": "Dies kann einen Moment dauern",
    "error_loading_payments": "Fehler beim Laden der Zahlungen",
    "try_again": "Erneut versuchen",
    "no_payments_found": "Keine Zahlungen gefunden",
    "no_payments_match_filters": "Keine Zahlungen entsprechen Ihren aktuellen Filtern. Versuchen Sie, Ihre Filterkriterien anzupassen, um mehr Ergebnisse zu sehen.",
    "no_payments_in_system": "Es befinden sich noch keine Zahlungen im System. Beginnen Sie, indem Sie Ihre erste Zahlung erfassen.",
    "reset_filters": "Filter zurücksetzen",
    "record_first_payment": "Erste Zahlung erfassen",
    "unknown_period": "Unbekannter Zeitraum",
    "to": "bis",
    "invalid_period_data": "Ungültige Zeitraumsdaten",
    "unknown_type": "Unbekannter Typ",
    "apt": "Whg",
    "print_receipt": "Quittung drucken",
    "view_details": "Details ansehen",
    "edit_payment": "Zahlung bearbeiten",
    "delete_payment": "Zahlung löschen",
    "showing_payments": "Zeige {{start}}-{{end}} von {{total}} Zahlungen",
    "showing_filtered_payments": "Zeige {{filtered}} von {{total}} Zahlungen basierend auf Ihrer Suche",
    "authentication_required": "Authentifizierung erforderlich",
    "failed_load_payments": "Laden der Zahlungsdaten fehlgeschlagen",
    "auth_failed_login_again": "Authentifizierung fehlgeschlagen. Bitte melden Sie sich erneut an.",
    "access_denied_admin_required": "Zugriff verweigert. Administratorrolle erforderlich.",
    "server_error_check_backend": "Serverfehler. Bitte überprüfen Sie, ob das Backend ausgeführt wird.",
    "cannot_connect_server": "Keine Verbindung zum Server möglich. Bitte überprüfen Sie, ob das Backend ausgeführt wird.",
    "error_fetching_payments": "Fehler beim Abrufen der Zahlungen",
    "error_deleting_payment": "Fehler beim Löschen der Zahlung",
    "failed_delete_payment": "Zahlung konnte nicht gelöscht werden",

    "occupancy_report": "Belegungsbericht",
    "loading": "Wird geladen...",
    "refresh": "Aktualisieren",
    "back": "Zurück",
    "error_fetching_occupancy": "Fehler beim Abrufen der Belegungsdaten",
    "failed_load_occupancy": "Belegungsdaten konnten nicht geladen werden",
    "occupied": "Vermietet",
    "vacant": "Leerstehend",
    "maintenance": "Wartung",
    "apartments": "Wohnungen",
    "occupancy_rate": "Belegungsquote",
    "of": "von",
    "vacant_apartments": "Leerstehende Wohnungen",
    "of_total": "vom Gesamtbestand",
    "maintenance_apartments": "In Wartung",
    "potential_income": "Potenzielles monatliches Einkommen",
    "buildings": "Gebäude",
    "occupancy_distribution": "Belegungsverteilung",
    "occupancy_by_building": "Belegung nach Gebäude",
    "building": "Gebäude",
    "total_apartments": "Gesamte Wohnungen",
    "print_report": "Bericht drucken",
    "export_report": "Bericht exportieren",

    "rent": "Miete",
    "service": "Service",
    "commission": "Provision",
    "insurance": "Versicherung",
    "total": "Gesamt",
    "occupied": "Vermietet",
    "vacant": "Leerstehend",
    "maintenance": "Wartung",
    "apartments": "Wohnungen",
    "of": "von",
    "excellent": "Ausgezeichnet",
    "good": "Gut",
    "needs_improvement": "Verbesserungswürdig",
    "error_fetching_occupancy": "Fehler beim Abrufen der Belegungsdaten",
    "failed_load_occupancy": "Belegungsdaten konnten nicht geladen werden",

    "overdue": "Überfällig",
    "pending": "Ausstehend",
    "paid": "Bezahlt",
    "no_overdue_payments": "Keine überfälligen Zahlungen gefunden",
    "apt": "Whg",
    "days_overdue": "Tage überfällig",
    "more_overdue_tenants": "weitere überfällige Mieter...",
    "error_fetching_tenant_status": "Fehler beim Abrufen des Zahlungsstatus der Mieter",
    "failed_load_tenant_status": "Zahlungsstatus der Mieter konnte nicht geladen werden",

    "rent": "Miete",
    "service": "Service",
    "deposit": "Kaution",
    "no_recent_payments": "Keine aktuellen Zahlungen gefunden",
    "error_fetching_payments": "Fehler beim Abrufen der letzten Zahlungen",
    "failed_load_payments": "Die letzten Zahlungen konnten nicht geladen werden",

    "payment_logs": "Zahlungsprotokolle",
    "filter": "Filtern",
    "back": "Zurück",
    "search_payment_logs_placeholder": "Zahlungsprotokolle suchen...",
    "showing_entries": "Zeige {{showing}} von {{total}} Einträgen",
    "filter_payments": "Zahlungen filtern",
    "time_period": "Zeitraum",
    "start_date": "Startdatum",
    "end_date": "Enddatum",
    "payment_type": "Zahlungsart",
    "all_types": "Alle Typen",
    "entries_per_page": "Einträge pro Seite",
    "reset": "Zurücksetzen",
    "apply_filter": "Filter anwenden",
    "payment_id": "Zahlungs-ID",
    "date": "Datum",
    "tenant": "Mieter",
    "building": "Gebäude",
    "type": "Typ",
    "amount": "Betrag",
    "actions": "Aktionen",
    "print_receipt": "Quittung drucken",
    "view_details": "Details ansehen",
    "no_logs_matching_search": "Keine Zahlungsprotokolle entsprechen Ihren Suchkriterien",
    "no_logs_for_period": "Keine Zahlungsprotokolle für den ausgewählten Zeitraum verfügbar",
    "showing_range": "Zeige {{start}} bis {{end}} von {{total}} Einträgen",
    "previous": "Zurück",
    "next": "Weiter",
    "print_report": "Bericht drucken",
    "export_to_excel": "Nach Excel exportieren",
    "failed_to_load_payment_logs": "Zahlungsprotokolle konnten nicht geladen werden",

    "current_month": "Aktueller Monat",
    "last_month": "Letzter Monat",
    "current_quarter": "Aktuelles Quartal",
    "current_year": "Aktuelles Jahr",
    "custom": "Benutzerdefinierter Bereich",

    "rent": "Miete",
    "service": "Service",
    "commission": "Provision",
    "insurance": "Versicherung",
    "other": "Andere",

    "reports_dashboard": "Berichts-Dashboard",
    "overview_of_financial_performance": "Überblick über finanzielle Leistung und Immobilienstatistiken",
    "view_all_reports": "Alle Berichte ansehen",
    "failed_to_load_report_data": "Berichtsdaten konnten nicht geladen werden",
    "total_revenue": "Gesamter Umsatz",
    "total_payments_count": "{{count}} Zahlungen",
    "total_tenants": "Gesamte Mieter",
    "new_tenants_this_year": "{{count}} neu dieses Jahr",
    "total_properties": "Gesamte Immobilien",
    "total_buildings_count": "{{count}} Gebäude",
    "total_owners": "Gesamte Eigentümer",
    "ended_contracts_count": "{{count}} beendete Verträge",
    "monthly_revenue_year": "Monatlicher Umsatz - {{year}}",
    "view_details": "Details ansehen",
    "occupancy_rate": "Belegungsquote",
    "recent_payments": "Aktuelle Zahlungen",
    "view_all": "Alle ansehen",
    "overdue_payments": "Überfällige Zahlungen",
    "quick_reports": "Schnellberichte",
    "annual_revenue": "Jahresumsatz",
    "yearly_breakdown": "Jährliche Aufschlüsselung aller Einnahmen",
    "building_revenue": "Gebäudeumsatz",
    "revenue_by_building": "Umsatzaufschlüsselung nach Gebäude",
    "owner_revenue": "Eigentümerumsatz",
    "revenue_by_owner": "Umsatzaufschlüsselung nach Immobilieneigentümer",
    "payment_logs": "Zahlungsprotokolle",
    "detailed_payment_history": "Detaillierter Zahlungsverlauf und Protokolle",

    "revenue_report": "Umsatzbericht",
    "filter": "Filtern",
    "loading": "Wird geladen...",
    "refresh": "Aktualisieren",
    "back": "Zurück",
    "filter_report": "Bericht filtern",
    "time_period": "Zeitraum",
    "start_date": "Startdatum",
    "end_date": "Enddatum",
    "cancel": "Abbrechen",
    "apply_filter": "Filter anwenden",
    "failed_to_load_revenue_data": "Umsatzdaten konnten nicht geladen werden",
    "total_revenue": "Gesamter Umsatz",
    "total_payments_count": "{{count}} Zahlungen",
    "rent_revenue": "Mietumsätze",
    "percent_of_total": "{{percent}}% der Gesamtsumme",
    "service_revenue": "Serviceumsätze",
    "unique_tenants": "Einzigartige Mieter",
    "avg_per_tenant": "Durchschnittlich {{amount}} pro Mieter",
    "revenue_by_building": "Umsatz nach Gebäude",
    "view_details": "Details ansehen",
    "building": "Gebäude",
    "tenants": "Mieter",
    "no_building_revenue_data": "Keine Gebäudeumsatzdaten verfügbar",
    "revenue_by_owner": "Umsatz nach Eigentümer",
    "owner": "Eigentümer",
    "apartments": "Wohnungen",
    "no_owner_revenue_data": "Keine Eigentümerumsatzdaten verfügbar",
    "print_report": "Bericht drucken",
    "export_report": "Bericht exportieren",

    "current_month": "Aktueller Monat",
    "last_month": "Letzter Monat",
    "current_quarter": "Aktuelles Quartal",
    "current_year": "Aktuelles Jahr",
    "custom": "Benutzerdefinierter Bereich",

    "service_payments_management": "Servicezahlungsverwaltung",
    "refresh": "Aktualisieren",
    "back_to_dashboard": "Zurück zum Dashboard",
    "building": "Gebäude",
    "select_building": "Gebäude auswählen",
    "year": "Jahr",
    "search": "Suchen",
    "search_apartments_tenants": "Wohnungen, Mieter suchen...",
    "generate_payments": "Zahlungen generieren",
    "view_statistics": "Statistiken ansehen",
    "filter_by_status": "Nach Status filtern",
    "all": "Alle",
    "paid": "Bezahlt",
    "unpaid": "Unbezahlt",
    "clear_filters": "Filter zurücksetzen",
    "loading_service_data": "Servicezahlungsdaten werden geladen...",
    "no_building_selected": "Kein Gebäude ausgewählt",
    "please_select_building": "Bitte wählen Sie ein Gebäude aus, um Servicezahlungen anzuzeigen.",
    "no_search_results": "Keine Suchergebnisse",
    "no_matching_apartments": "Keine Wohnungen oder Mieter entsprechen Ihren Suchkriterien.",
    "service_payments_for_building_year": "Servicezahlungen für {{building}} - {{year}}",
    "floor_number": "Etage {{number}}",
    "apartments": "Wohnungen",
    "rate": "Satz",
    "tenant_owner": "Mieter/Eigentümer",
    "vacant": "Leerstehend",
    "mark_as_paid": "Als bezahlt markieren",
    "mark_as_unpaid": "Als unbezahlt markieren",
    "view_details": "Details ansehen",
    "summary": "Zusammenfassung",
    "floor_apartment_count": "{{floors}} Etagen, {{apartments}} Wohnungen",
    "no_floors_available": "Keine Etagen verfügbar",
    "no_floors_message": "Es gibt keine Etagen mit Wohnungen in diesem Gebäude, oder es wurden noch keine Servicezahlungen generiert.",
    "failed_to_load_buildings": "Gebäude konnten nicht geladen werden. Bitte versuchen Sie es erneut.",
    "failed_to_load_floors": "Etagen konnten nicht geladen werden",
    "failed_to_load_building_floors": "Gebäudeetagen konnten nicht geladen werden",
    "failed_to_load_floor_data": "Etagendaten konnten nicht geladen werden",
    "data_refreshed_successfully": "Daten erfolgreich aktualisiert.",
    "failed_to_refresh_data": "Aktualisieren der Daten fehlgeschlagen",
    "marked_as_paid_via_service_management": "Über die Serviceverwaltung als bezahlt markiert",
    "marked_as_unpaid_via_service_management": "Über die Serviceverwaltung als unbezahlt markiert",
    "payment_marked_as_paid": "Zahlung erfolgreich als bezahlt markiert.",
    "payment_marked_as_unpaid": "Zahlung erfolgreich als unbezahlt markiert.",
    "failed_to_update_payment": "Zahlung konnte nicht aktualisiert werden",
    "payment_details": "Zahlungsdetails",
    "payment_due": "Zahlung fällig",
    "amount": "Betrag",
    "status": "Status",
    "paid_on": "Bezahlt am",
    "no_apartments_on_floor": "Keine Wohnungen auf dieser Etage gefunden.",

    "month_1": "Januar",
    "month_2": "Februar",
    "month_3": "März",
    "month_4": "April",
    "month_5": "Mai",
    "month_6": "Juni",
    "month_7": "Juli",
    "month_8": "August",
    "month_9": "September",
    "month_10": "Oktober",
    "month_11": "November",
    "month_12": "Dezember",


    "service_payment_details": "Servicezahlungsdetails",
    "print_receipt": "Quittung drucken",
    "loading": "Wird geladen...",
    "failed_to_load_payment_details": "Zahlungsdetails konnten nicht geladen werden",
    "api_endpoint_missing_message": "Dieser Fehler weist auf einen fehlenden API-Endpunkt auf Ihrem Backend-Server hin. Fügen Sie eine Route für GET /api/services/:id in Ihrer serviceRoutes.js-Datei hinzu, um dies zu beheben.",
    "payment_information": "Zahlungsinformationen",
    "apartment": "Wohnung",
    "period": "Zeitraum",
    "amount": "Betrag",
    "status": "Status",
    "tenant": "Mieter",
    "owner": "Eigentümer",
    "payment_date": "Zahlungsdatum",
    "paid_by": "Bezahlt von",
    "notes": "Notizen",
    "update_payment": "Zahlung aktualisieren",
    "mark_as_paid": "Als bezahlt markieren",
    "currency": "Währung",
    "select_payer": "Zahler auswählen",
    "management": "Verwaltung",
    "other": "Andere",
    "payment_notes_placeholder": "Geben Sie zusätzliche Notizen zu dieser Zahlung ein...",
    "cancel": "Abbrechen",
    "saving": "Speichern...",
    "payment_history": "Zahlungsverlauf",
    "date": "Datum",
    "action": "Aktion",
    "by": "Von",
    "paid": "Bezahlt",
    "unpaid": "Unbezahlt",
    "payment_marked_as_paid": "Zahlung erfolgreich als bezahlt markiert.",
    "payment_marked_as_unpaid": "Zahlung erfolgreich als unbezahlt markiert.",
    "failed_to_update_payment": "Zahlung konnte nicht aktualisiert werden",
    "service_payment_receipt": "Quittung für Servicezahlung",
    "property_management": "Immobilienverwaltung",
    "receipt_generated": "Diese Quittung wurde am {{date}} um {{time}} generiert",
    "automated_receipt_notice": "Dies ist eine automatisch generierte Quittung und erfordert keine Unterschrift.",
    "us_dollar": "US-Dollar",
    "iraqi_dinar": "Irakischer Dinar",
    "euro": "Euro",

    "month_1": "Januar",
    "month_2": "Februar",
    "month_3": "März",
    "month_4": "April",
    "month_5": "Mai",
    "month_6": "Juni",
    "month_7": "Juli",
    "month_8": "August",
    "month_9": "September",
    "month_10": "Oktober",
    "month_11": "November",
    "month_12": "Dezember",

    "tenant": "Mieter",
    "owner": "Eigentümer",
    "management": "Verwaltung",
    "other": "andere",

    "generate_service_payments": "Servicezahlungen generieren",
    "recipients": "Empfänger",
    "entire_building": "Ganzes Gebäude",
    "generate_for_all_apartments": "Für alle Wohnungen in einem Gebäude generieren",
    "specific_tenants": "Spezifische Mieter",
    "generate_for_selected_tenants": "Nur für ausgewählte Mieter generieren",
    "specific_owners": "Spezifische Eigentümer",
    "generate_for_selected_owners": "Nur für ausgewählte Eigentümer generieren",
    "select_building": "Gebäude auswählen",
    "include_vacant_apartments": "Leerstehende Wohnungen einbeziehen",
    "selected_tenants": "Ausgewählte Mieter",
    "selected_owners": "Ausgewählte Eigentümer",
    "select_tenants": "Mieter auswählen",
    "select_owners": "Eigentümer auswählen",
    "no_tenants_selected": "Keine Mieter ausgewählt",
    "no_owners_selected": "Keine Eigentümer ausgewählt",
    "payment_details": "Zahlungsdetails",
    "amount": "Betrag",
    "currency": "Währung",
    "us_dollar": "US-Dollar",
    "iraqi_dinar": "Irakischer Dinar",
    "euro": "Euro",
    "initial_status": "Anfänglicher Status",
    "unpaid": "Unbezahlt",
    "paid": "Bezahlt",
    "notes": "Notizen",
    "payment_notes_placeholder": "Geben Sie zusätzliche Notizen zu diesen Zahlungen ein...",
    "time_period": "Zeitraum",
    "generation_type": "Generierungsart",
    "single_month": "Ein einzelner Monat",
    "multiple_months": "Mehrere Monate",
    "month_range": "Monatsbereich",
    "year": "Jahr",
    "month": "Monat",
    "select_months": "Monate auswählen",
    "from": "Von",
    "to": "Bis",
    "selected_months": "Ausgewählte Monate",
    "payment_generation_summary": "Zusammenfassung der Zahlungsgenerierung",
    "all_apartments_in": "Alle Wohnungen in",
    "selected_building": "ausgewähltes Gebäude",
    "tenants": "Mieter",
    "owners": "Eigentümer",
    "cancel": "Abbrechen",
    "generating": "Generiere...",
    "generate_payments": "Zahlungen generieren",
    "search": "Suchen",
    "search_by_tenant_name_or_phone": "Nach Mietername, Telefon oder Wohnungsnummer suchen...",
    "search_by_owner_name_or_phone": "Nach Eigentümername oder Telefon suchen...",
    "no_results_found": "Keine Ergebnisse gefunden",
    "selected": "ausgewählt",
    "done": "Fertig",
    "no_tenants_available": "Keine Mieter verfügbar. Bitte fügen Sie zuerst Mieter hinzu.",
    "no_owners_available": "Keine Eigentümer verfügbar. Bitte fügen Sie zuerst Eigentümer hinzu.",
    "apt": "Whg",
    "january": "Januar",
    "february": "Februar",
    "march": "März",
    "april": "April",
    "may": "Mai",
    "june": "Juni",
    "july": "Juli",
    "august": "August",
    "september": "September",
    "october": "Oktober",
    "november": "November",
    "december": "Dezember",
    "failed_to_load_buildings": "Gebäude konnten nicht geladen werden. Bitte versuchen Sie es erneut.",
    "failed_to_load_tenants": "Mieter konnten nicht geladen werden. Bitte versuchen Sie es erneut.",
    "failed_to_load_owners": "Eigentümer konnten nicht geladen werden. Bitte versuchen Sie es erneut.",
    "please_select_building": "Bitte wählen Sie ein Gebäude",
    "please_select_at_least_one_recipient": "Bitte wählen Sie mindestens einen {{recipient}}",
    "please_enter_valid_amount": "Bitte geben Sie einen gültigen Betrag ein",
    "please_select_month": "Bitte wählen Sie einen Monat",
    "please_select_at_least_one_month": "Bitte wählen Sie mindestens einen Monat",
    "end_month_must_be_after_start_month": "Der Endmonat muss nach dem Startmonat liegen",
    "successfully_generated_payments": "Erfolgreich {{count}} Servicezahlungen über {{months}} Monat(e) generiert. {{skipped}} Zahlungen wurden bereits generiert.",
    "failed_to_generate_service_payments": "Generieren von Servicezahlungen fehlgeschlagen",
    "tenant": "Mieter",
    "owner": "Eigentümer",

    "service_payment_statistics": "Servicezahlungs-Statistiken",
    "back_to_services": "Zurück zu den Diensten",
    "building": "Gebäude",
    "year": "Jahr",
    "loading_statistics": "Statistiken werden geladen...",
    "no_building_selected": "Kein Gebäude ausgewählt",
    "please_select_building_statistics": "Bitte wählen Sie ein Gebäude aus, um die Statistiken der Servicezahlungen anzuzeigen.",
    "overall_statistics": "Gesamtstatistiken",
    "total_collection": "Gesamte Einnahmen",
    "of": "von",
    "payment_rate": "Zahlungsquote",
    "payments": "Zahlungen",
    "outstanding_amount": "Ausstehender Betrag",
    "unpaid_payments": "unbezahlte Zahlungen",
    "monthly_statistics": "Monatliche Statistiken",
    "no_monthly_data": "Keine monatlichen Daten für das ausgewählte Jahr verfügbar.",
    "month": "Monat",
    "total_amount": "Gesamtbetrag",
    "collected": "Eingenommen",
    "outstanding": "Ausstehend",
    "progress": "Fortschritt",
    "failed_to_load_service_statistics": "Servicestatistiken konnten nicht geladen werden",

    "loading_tenant_data": "Mieterdaten werden geladen...",
    "error_loading_tenant": "Fehler beim Laden des Mieters",
    "tenant_not_found": "Mieter nicht gefunden",
    "back_to_tenants": "Zurück zu Mietern",
    "record_payment": "Zahlung erfassen",
    "edit": "Bearbeiten",
    "status_unknown": "Status unbekannt",
    "apartment": "Wohnung",
    "apt": "Whg",
    "none": "Keine",
    "monthly_rent": "Monatliche Miete",
    "payment_date": "Zahlungsdatum",
    "overview": "Übersicht",
    "leases": "Mietverträge",
    "payments": "Zahlungen",
    "contact_information": "Kontaktinformationen",
    "lease_information": "Mietvertragsinformationen",
    "contract_period": "Vertragsdauer",
    "rent": "Miete",
    "discount": "Rabatt",
    "rent_after_discount": "Miete nach Rabatt",
    "additional_fees": "Zusätzliche Gebühren",
    "service_fee": "Servicegebühr",
    "office_commission": "Büroprovision",
    "insurance": "Versicherung",
    "notes": "Notizen",
    "no_leases": "Keine Mietverträge",
    "no_leases_message": "Diesem Mieter ist noch keine Wohnung zugewiesen.",
    "active_leases": "Aktive Mietverträge",
    "inactive_leases": "Inaktive Mietverträge",
    "active": "Aktiv",
    "ended": "Beendet",
    "expiring_soon": "Läuft bald ab",
    "end_lease": "Mietvertrag beenden",
    "start_date": "Startdatum",
    "end_date": "Enddatum",
    "duration": "Dauer",
    "remaining": "Verbleibend",
    "months": "Monate",
    "security_deposit": "Kaution",
    "total_value": "Gesamtwert",
    "no_payments": "Keine Zahlungen",
    "no_payments_message": "Für diesen Mieter wurden noch keine Zahlungen erfasst.",
    "record_first_payment": "Erste Zahlung erfassen",
    "payment_period": "Zahlungszeitraum",
    "reference": "Referenz",
    "payment_type": "Zahlungsart",
    "rent_payment": "Mietzahlung",
    "additional_fee": "Zusätzliche Gebühr",
    "utility_payment": "Nebenkostenzahlung",
    "other_payment": "Andere Zahlung",
    "start": "Start",
    "end": "Ende",
    "reference_number": "Referenznummer",
    "cancel": "Abbrechen",
    "unknown_period": "Unbekannter Zeitraum",
    "invalid_period_format": "Ungültiges Zeitraumsformat",
    "to": "bis",
    "invalid_period_data": "Ungültige Zeitraumsdaten",
    "please_enter_valid_payment_amount": "Bitte geben Sie einen gültigen Zahlungsbetrag ein",
    "end_date_must_be_after_start_date": "Enddatum muss nach dem Startdatum liegen",
    "failed_to_add_payment": "Zahlung konnte nicht hinzugefügt werden",
    "maintenance_requests_not_supported": "Wartungsanfragen werden in der aktuellen Datenbankstruktur nicht unterstützt",
    "failed_to_create_maintenance_request": "Wartungsanfrage konnte nicht erstellt werden",
    "confirm_end_lease": "Sind Sie sicher, dass Sie diesen Mietvertrag beenden möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
    "lease_ended_by_administrator": "Mietvertrag vom Administrator beendet",
    "failed_to_end_lease": "Mietvertrag konnte nicht beendet werden",
    "failed_to_load_tenant_data": "Mieterdaten konnten nicht geladen werden",
    "actual_end_date": "Tatsächliches Enddatum",

    "edit_tenant": "Mieter bearbeiten",
    "add_tenant": "Mieter hinzufügen",
    "basic_information": "Grundinformationen",
    "first_name": "Vorname",
    "last_name": "Nachname",
    "email": "E-Mail",
    "phone": "Telefon",
    "apartment": "Wohnung",
    "select_apartment": "Wohnung auswählen",
    "floor": "Etage",
    "rent_amount": "Mietbetrag",
    "discount": "Rabatt",
    "service_fee": "Servicegebühr",
    "office_commission": "Büroprovision",
    "insurance": "Versicherung",
    "contract_start_date": "Vertragsbeginn",
    "contract_end_date": "Vertragsende",
    "payment_date": "Zahlungsdatum",
    "payment_end_date": "Zahlungsende",
    "rent_status": "Mietstatus",
    "additional_information": "Zusätzliche Informationen",
    "notes": "Notizen",
    "tenant_notes_placeholder": "Zusätzliche Notizen zu diesem Mieter...",
    "cancel": "Abbrechen",
    "saving": "Speichern...",
    "update_tenant": "Mieter aktualisieren",
    "create_tenant": "Mieter erstellen",
    "loading": "Wird geladen...",
    "failed_to_load_tenant_data": "Mieterdaten konnten nicht geladen werden",
    "failed_to_save_tenant": "Mieter konnte nicht gespeichert werden",
    "pending": "Ausstehend",
    "paid": "Bezahlt",
    "late": "Verspätet",
    "overdue": "Überfällig",
    "unpaid": "Unbezahlt",

    "tenants": "Mieter",
    "refresh_tenants": "Mieter aktualisieren",
    "selected": "ausgewählt",
    "delete_selected_tenants": "Ausgewählte Mieter löschen",
    "search_tenants": "Mieter suchen...",
    "filter": "Filtern",
    "switch_to_list_view": "Zur Listenansicht wechseln",
    "switch_to_grid_view": "Zur Rasteransicht wechseln",
    "list_view": "Liste",
    "grid_view": "Raster",
    "hide_inactive_tenants": "Inaktive Mieter ausblenden",
    "show_inactive_tenants": "Inaktive Mieter anzeigen",
    "hide_inactive": "Inaktive ausblenden",
    "show_inactive": "Inaktive anzeigen",
    "add_tenant": "Mieter hinzufügen",
    "rent_status": "Mietstatus",
    "all_statuses": "Alle Status",
    "all_buildings": "Alle Gebäude",
    "all_apartments": "Alle Wohnungen",
    "min_rent": "Min. Miete",
    "max_rent": "Max. Miete",
    "unlimited": "Unbegrenzt",
    "contracts_ending_before": "Verträge enden vor",
    "clear_filters": "Filter zurücksetzen",
    "apply_filters": "Filter anwenden",
    "active_tenants": "Aktive Mieter",
    "inactive_tenants": "Inaktive Mieter",
    "with_apartments": "Mit Wohnungen",
    "without_apartments": "Ohne Wohnungen",
    "loading_tenants": "Mieter werden geladen...",
    "error_loading_tenants": "Fehler beim Laden der Mieter",
    "try_again": "Erneut versuchen",
    "no_tenants_found": "Keine Mieter gefunden",
    "no_tenants_message": "Es gibt noch keine Mieter im System. Klicken Sie auf die Schaltfläche 'Mieter hinzufügen', um Ihren ersten Mieter zu erstellen.",
    "create_first_tenant": "Ersten Mieter erstellen",
    "page": "Seite",
    "showing_items": "Zeige {start}-{end} von {total}",
    "first_page": "Erste Seite",
    "previous_page": "Vorherige Seite",
    "next_page": "Nächste Seite",
    "last_page": "Letzte Seite",
    "showing_filtered_results": "Zeige {showing} von {total} Mietern",
    "confirm_deletion": "Löschen bestätigen",
    "delete_tenant_confirmation": "Sind Sie sicher, dass Sie den Mieter \"{name}\" löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
    "cancel": "Abbrechen",
    "deleting": "Wird gelöscht...",
    "delete": "Löschen",
    "tenant": "Mieter",
    "apartment": "Wohnung",
    "rent": "Miete",
    "contract": "Vertrag",
    "status": "Status",
    "actions": "Aktionen",
    "apt": "Whg",
    "unknown_building": "Unbekanntes Gebäude",
    "no_apartment_assigned": "Keine Wohnung zugewiesen",
    "status_unknown": "Status unbekannt",
    "monthly_rent": "Monatliche Miete",
    "after_discount": "Nach Rabatt",
    "payment_date": "Zahlungsdatum",
    "not_set": "Nicht festgelegt",
    "contract_start": "Vertragsbeginn",
    "contract_end": "Vertragsende",
    "service": "Service",
    "commission": "Provision",
    "insurance": "Versicherung",
    "hide_owner_details": "Eigentümerdetails ausblenden",
    "show_owner_details": "Eigentümerdetails anzeigen",
    "apartment_owner": "Wohnungseigentümer",
    "loading_owner_details": "Eigentümerdetails werden geladen...",
    "no_owner_information": "Keine Eigentümerinformationen verfügbar",
    "lives_on_property": "Wohnt im Objekt",
    "yes": "Ja",
    "no": "Nein",
    "total_apartments": "Gesamte Wohnungen",
    "apartment_details": "Wohnungsdetails",
    "apartment_number": "Wohnungs-Nr.",
    "unknown": "Unbekannt",
    "floor": "Etage",
    "apartment_type": "Wohnungstyp",
    "standard": "Standard",
    "furnished": "Möbliert",
    "view_owner_profile": "Eigentümerprofil ansehen",
    "mark_as_inactive": "Als inaktiv markieren",
    "mark_as_active": "Als aktiv markieren",
    "record_payment": "Zahlung erfassen",
    "view_details": "Details ansehen",
    "edit_tenant": "Mieter bearbeiten",
    "delete_tenant": "Mieter löschen",
    "to": "Bis",
    "payment": "Zahlung",
    "apartment_financial_details": "Wohnungs- & Finanzdetails",
    "not_authenticated": "Nicht authentifiziert. Bitte melden Sie sich an.",
    "authentication_required": "Authentifizierung erforderlich",
    "authentication_failed": "Authentifizierung fehlgeschlagen. Bitte melden Sie sich erneut an.",
    "access_denied": "Zugriff verweigert. Administratorrolle erforderlich.",
    "server_error": "Serverfehler. Bitte überprüfen Sie, ob das Backend ausgeführt wird.",
    "cannot_connect_to_server": "Keine Verbindung zum Server möglich. Bitte prüfen Sie, ob das Backend auf Port 3000 läuft.",
    "failed_to_load_tenants_data": "Mieterdaten konnten nicht geladen werden",
    "unknown_error": "Unbekannter Fehler",
    "failed_to_delete_tenant": "Mieter konnte nicht gelöscht werden",
    "confirm_bulk_delete": "Sind Sie sicher, dass Sie {count} Mieter löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
    "failed_to_delete_tenants": "Mieter konnten nicht gelöscht werden",
    "failed_to_update_tenant_status": "Mietstatus konnte nicht aktualisiert werden",
    "pending": "Ausstehend",
    "paid": "Bezahlt",
    "late": "Verspätet",
    "overdue": "Überfällig",

    'add_new_user': 'Neuen Benutzer hinzufügen',
    'search_users': 'Benutzer suchen',
    'total_users': 'Gesamte Benutzer',
    'active_users': 'Aktive Benutzer',
    'inactive_users': 'Inaktive Benutzer',
    'financial_summary': 'Finanzielle Zusammenfassung',
    'filters': 'Filter',
    'search_tenants_by_name_phone_or_apartment': 'Mieter nach Name, Telefon oder Wohnung suchen',
    'view_profile': 'Profil ansehen',

    // WhatsApp Settings
    'whatsapp_settings': 'WhatsApp-Einstellungen',
    'whatsapp_settings_description': 'Automatisierte WhatsApp-Benachrichtigungen für Mieter und Eigentümer',
    'whatsapp_enable': 'WhatsApp-Benachrichtigungen aktivieren',
    'whatsapp_enable_sub': 'Schalten Sie alle automatisierten WhatsApp-Nachrichten ein oder aus',
    'general_settings': 'Allgemeine Einstellungen',
    'default_country_code': 'Standard-Ländercode',
    'tenant_rent_reminder': 'Miet-Erinnerung für Mieter',
    'tenant_rent_reminder_sub': 'Senden Sie Erinnerungen an Mieter vor oder nach dem Fälligkeitsdatum der Zahlung',
    'days_before_due': 'Tage vor Fälligkeit',
    'reminder_message_template': 'Nachrichten-Vorlage',
    'service_fee_reminder': 'Erinnerung an Servicegebühren',
    'enable_service_fee_reminder': 'Servicegebühren-Erinnerung aktivieren',
    'service_fee_reminder_sub': 'Benachrichtigen Sie Mieter über anstehende Zahlungen von Servicegebühren',
    'owner_reminder': 'Eigentümer-Erinnerung',
    'enable_owner_reminders': 'Eigentümer-Erinnerungen aktivieren',
    'owner_reminder_sub': 'Benachrichtigen Sie Eigentümer, wenn ihre Mieter überfällige Zahlungen haben',
    'owner_message_template': 'Eigentümer-Nachrichtenvorlage',
    'payment_confirmation': 'Zahlungsbestätigung',
    'send_on_payment': 'Bestätigung senden, wenn Zahlung erfasst wird',
    'payment_confirmation_sub': 'Wird automatisch an den Mieter gesendet, wenn eine Zahlung erfasst wird',
    'payment_confirmation_template': 'Bestätigungs-Nachrichtenvorlage',
    'whatsapp_test_send': 'Testnachricht senden',
    'test_message': 'Nachricht',
    'send_test_message': 'Testnachricht senden',
    'whatsapp_test_sent': 'Testnachricht gesendet!',
    'whatsapp_test_default_message': 'Testnachricht vom Immobilienverwaltungssystem',
    'send_reminders_now': 'Erinnerungen jetzt senden',
    'send_reminders_now_description': 'Senden Sie sofort Erinnerungen an alle Mieter und Eigentümer, die jetzt eine benötigen.',
    'whatsapp_must_be_enabled': 'WhatsApp muss zuerst aktiviert werden',
    'failed_to_load_settings': 'Einstellungen konnten nicht geladen werden',
    'settings_saved': 'Einstellungen erfolgreich gespeichert',
    'failed_to_save': 'Speichern fehlgeschlagen',
    'failed_to_send': 'Senden fehlgeschlagen',
    'server_error': 'Server-Verbindungsfehler',
    'sent': 'Gesendet',
    'errors': 'Fehler',
    'skipped': 'Übersprungen',

    // Bookings
    'bookings': 'Buchungen',
    'booking_management': 'Buchungsverwaltung',
    'new_booking': 'Neue Buchung',
    'create_booking': 'Buchung erstellen',
    'edit_booking': 'Buchung bearbeiten',
    'booking_details': 'Buchungsdetails',
    'prospect': 'Interessent',
    'prospect_name': 'Name des Interessenten',
    'prospect_phone': 'Telefonnummer',
    'prospect_email': 'E-Mail-Adresse',
    'move_in_date': 'Einzugsdatum',
    'move_out_date': 'Auszugsdatum',
    'hold_duration': 'Reservierungsdauer',
    'hold_hours': 'Reservierungsstunden',
    'hold_expiration': 'Ablauf der Reservierung',
    'internal_notes': 'Interne Notizen',
    'check_availability': 'Verfügbarkeit prüfen',
    'checking_availability': 'Verfügbarkeit wird geprüft...',
    'no_bookings_found': 'Keine Buchungen gefunden',
    'calendar_view': 'Kalenderansicht',
    'waitlist': 'Warteliste',
    'new_booking_hold': 'Neue Reservierung',
    'property_information': 'Immobilieninformationen',
    'prospect_details': 'Interessentendetails',
    'requested_dates': 'Gewünschte Daten',
    'conflict_detected': 'Konflikt erkannt',
    'booking_timeline': 'Buchungszeitleiste',
    'monthly_view_holds': 'Monatliche Ansicht aktiver Wohnungsreservierungen',
    'confirmed_hold': 'Bestätigte Reservierung',
    'pending_payment': 'Ausstehende Zahlung',
    'move_in': 'Einzug',
    'move_out': 'Auszug',
    'convert_to_tenant': 'In Mieter umwandeln',
    'confirm_booking': 'Buchung bestätigen',
    'cancel_booking': 'Buchung stornieren',
    'booking_confirmed': 'Buchung bestätigt',
    'booking_cancelled': 'Buchung storniert',
    'booking_converted': 'Buchung erfolgreich in Mieter umgewandelt!',
    'process_to_booking': 'Zur Buchung verarbeiten',
    'waitlist_management': 'Wartelistenverwaltung',
    'waitlist_empty': 'Warteliste ist leer',
    'search_waitlist': 'Warteliste durchsuchen...',
    'priority': 'Priorität',
    'desired_unit': 'Gewünschte Einheit',
    'move_in_preference': 'Einzugspräferenz',
    'added': 'Hinzugefügt',
    'rank': 'Rang',
    'process_waitlist_success': 'Erfolgreich in eine ausstehende Buchung umgewandelt!',
    'remove_from_waitlist': 'Möchten Sie diesen Eintrag wirklich aus der Warteliste entfernen?',
    'entry_removed': 'Eintrag entfernt',
    'hold_expires': 'Reservierung läuft ab',
    'hours': 'Stunden',
    'optional': 'Optional',
    'apartment_element': 'Wohnungselement',
    'select_unit': 'Einheit auswählen',
    'error_loading_data': 'Fehler beim Laden der Daten',
    'error_saving_booking': 'Fehler beim Speichern der Buchung',
    'save_changes': 'Änderungen speichern',
    'select_apartment_move_in_date_error': 'Bitte wählen Sie eine Wohnung und ein Einzugsdatum, um die Verfügbarkeit zu prüfen',
    'apartment_available': 'Wohnung ist für diese Daten verfügbar!',
    'error_checking_availability': 'Fehler bei der Verfügbarkeitsprüfung',
    'confirm_conflict_booking': 'Es gibt Terminkonflikte. Sind Sie sicher, dass Sie fortfahren möchten?',
    'booking_updated': 'Buchung erfolgreich aktualisiert',
    'booking_number': 'Buchung #{{id}}',
    'created_at': 'Erstellt am {{date}}',
    'created_by': 'von {{name}}',
    'system': 'System',
    'confirm': 'Bestätigen',
    'target_property': 'Zielimmobilie',
    'furnished': 'Möbliert',
    'unfurnished': 'Unmöbliert',
    'booking_window': 'Buchungsfenster',
    'indefinite': 'Unbegrenzt',
    'created_source': 'Erstellt ({{source}})',
    'view_tenant_profile': 'Mieterprofil ansehen',
    'convert_to_active_tenant': 'In aktiven Mieter umwandeln',
    'lease_details_move_in_instruction': 'Vervollständigen Sie die folgenden Mietvertragsdetails, um {{name}} in Einheit {{unit}} einziehen zu lassen.',
    'monthly_rent': 'Monatliche Miete',
    'first_payment_date': 'Erstes Zahlungsdatum',
    'contract_start': 'Vertragsbeginn',
    'contract_end': 'Vertragsende',
    'confirm_convert': 'Bestätigen & Umwandeln',
    'confirm_booking_question': 'Buchung abschließen: Sind Sie sicher, dass Sie diese Reservierung bestätigen und die Einheit für diesen Interessenten blockieren möchten?',
    'confirm_booking_question_ar': 'تأكيد الحجز: هل أنت متأكد من رغبتك في تثبيت هذا الحجز وحجز الوحدة لهذا العميل؟',
    'confirm_booking_question_ku': 'پشتڕاستکردنەوەی حجز: ئایا دڵنیایت کە دەتەوێت ئەم حجزە پشتڕاست بکەیتەوە و یەکەکە بۆ ئەم کڕیارە دابنێیت؟',
    'reason_optional': 'Bitte geben Sie einen Grund an (optional):',
    'amount': 'Betrag',
    'today': 'Heute',
    'sun': 'So',
    'mon': 'Mo',
    'tue': 'Di',
    'wed': 'Mi',
    'thu': 'Do',
    'fri': 'Fr',
    'sat': 'Sa',
    'more': 'Mehr',
    'close': 'Schließen',
    'hold_expiration': 'Ablauf der Reservierung',
    'view_details': 'Details ansehen',
    'waitlist_management': 'Wartelistenverwaltung',
    'search_waitlist': 'Warteliste durchsuchen...',
    'waitlist_empty': 'Warteliste ist leer',
    'no_prospective_tenants_waiting': 'Keine potenziellen Mieter warten derzeit auf eine freie Wohnung.',
    'priority': 'Priorität',
    'rank': 'Rang: {{priority}}',
    'desired_unit': 'Gewünschte Einheit',
    'move_in_preference': 'Einzugspräferenz',
    'process_to_booking': 'Zur Buchung verarbeiten',
    'remove': 'Entfernen',
    'remove_waitlist_confirm': 'Möchten Sie diesen Eintrag wirklich aus der Warteliste entfernen?',
    'waitlist_processed': 'Erfolgreich in eine ausstehende Buchung umgewandelt!',
    'entry_removed': 'Eintrag entfernt',
    'failed_process_waitlist': 'Verarbeitung des Wartelisteneintrags fehlgeschlagen',
    'failed_remove_entry': 'Eintrag konnte nicht entfernt werden',
    'booking_analytics': 'Buchungsanalysen',
    'track_conversion_and_holds': 'Verfolgen Sie Konversionsraten und Reservierungsdauern',
    'last_7_days': 'Letzte 7 Tage',
    'last_30_days': 'Letzte 30 Tage',
    'last_90_days': 'Letzte 90 Tage',
    'last_year': 'Letztes Jahr',
    'total_bookings': 'Gesamte Buchungen',
    'in_selected_period': 'Im ausgewählten Zeitraum',
    'conversion_rate': 'Konversionsrate',
    'converted_to_tenants': '{{count}} in Mieter umgewandelt',
    'cancellation_rate': 'Stornierungsrate',
    'cancelled_holds': '{{count}} stornierte Reservierungen',
    'avg_hold_time': 'Durchschnittliche Reservierungszeit',
    'before_conversion_cancel': 'Vor Umwandlung/Stornierung',
    'volume_trends': 'Volumentrends',
    'no_trend_data': 'Keine Trenddaten verfügbar',
    'total_holds': 'Gesamte Reservierungen',
    'status_breakdown': 'Statusaufschlüsselung',
    'no_status_data': 'Keine Statusdaten verfügbar',
    'active_holds': 'Aktive Reservierungen',
    'overdue_rent': 'Überfällige Miete',
    'subscription': 'Abonnement',
    'whatsapp': 'WhatsApp',
    'apartment_unit_display': 'Wohnung {{number}} - Etage {{floor}}',
    'building_view': 'Gebäudeansicht',
    'showing_all_apartments': 'Zeige alle Wohnungen',
    'expand_all_floors': 'Alle Etagen ausklappen',
    'collapse_all_floors': 'Alle Etagen einklappen',
    'pending_move_in': 'Ausstehender Einzug',
    'tenant_name': 'Name',
    'tenant_phone': 'Telefon',
    'tenant_email': 'E-Mail',
    'lease_details': 'Mietvertragsdetails',
    'start_date': 'Startdatum',
    'end_date': 'Enddatum',
    'monthly_pay_date': 'Monatliches Zahlungsdatum',
    'day_number': 'Tag {{number}}',
    'duration': 'Dauer',
    'months': 'Monate',
    'remaining_time': 'Verbleibende Zeit',
    'financial_summary': 'Finanzielle Zusammenfassung',
    'monthly_rent': 'Monatliche Miete',
    'effective_rent': 'Effektive Miete',
    'rent_status': 'Mietstatus',
    'future_tenant_upcoming_move_in': 'Zukünftiger Mieter (Bevorstehender Einzug)',
    'move_in_date': 'Einzugsdatum',
    'contract_end': 'Vertragsende',
    'recent_bookings': 'Aktuelle Buchungen & Reservierungen',
    'new_hold': 'Neue Reservierung',
    'available_now': 'Jetzt verfügbar',
    'lease_ending_soon': 'Mietvertrag endet bald',
    'no_apartments_found': 'Keine passenden Wohnungen gefunden',
    'ready': 'Bereit',
    'ends_in_days': 'Endet in {{count}} T',
    'search_unit': 'Wohnung suchen...',
    'currently_occupied': 'Derzeit belegt',
    'occupied': 'Vermietet',
    'all_service_payments': 'Alle Servicezahlungen',
    'manage_all_service_payments_across_buildings': 'Verwalten Sie alle Servicezahlungen über alle Gebäude hinweg',
    'tenants_management': 'Mieterverwaltung',
    'manage_tenants_and_leases': 'Verwalten Sie Mieter und Mietverträge',
    'past_tenants': 'Ehemalige Mieter',
    'lease_ended': 'Mietvertrag beendet',
    'end_lease_confirm_title': 'Beendigung des Mietvertrags bestätigen',
    'end_lease_confirm_body': 'Sind Sie sicher, dass Sie diesen Mietvertrag beenden möchten?',
    'no_past_tenants': 'Keine ehemaligen Mieter',
    'sign_up_to_get_started': 'Registrieren Sie sich, um zu beginnen',
    'company_name': 'Firmenname',
    'already_have_account': 'Haben Sie bereits ein Konto?',
    'status_expired_description': 'Dieser Mietvertrag ist abgelaufen. Es können keine weiteren Zahlungen angewendet werden.',
    'lease_expired_warning': 'Dieser Mietvertrag ist abgelaufen.',
    'tenant_lease_expired_message': 'Es können keine weiteren Zahlungen angewendet werden.',
    'expired_on': 'Abgelaufen am',
    'manage_tenant': 'Mieter verwalten',
    'move_in_pending': 'Ausstehender Einzug',
    'lease_expired': 'Mietvertrag abgelaufen',
    'create_hold': 'Reservierung erstellen',
    'billing_subscription': 'Abrechnung & Abonnement',
    'current_plan': 'Aktueller Plan',
    'subscribe_now': 'Jetzt abonnieren',
    'manage_your_subscription_and_billing': 'Verwalten Sie Ihr Abonnement und Ihre Abrechnung',
    'view_payment_logs': 'Zahlungsprotokolle ansehen',
    'view_activity_logs': 'Aktivitätsprotokolle ansehen',
    'view_revenue_report': 'Umsatzbericht ansehen',
    'view_occupancy_report': 'Belegungsbericht ansehen',
    'view_tenant_logs': 'Mieterprotokolle ansehen',
    'login_success': 'Erfolgreich angemeldet',
    'logout_success': 'Erfolgreich abgemeldet',
    'record_payment': 'Zahlung erfassen',
    'occupied_status': 'Vermietet',
    'financial_status': 'Finanzstatus',
    'occupancy_physical': 'Physische Belegung',
    'unit_indicators': 'Einheitsindikatoren',
    'furnished_unit': 'Möblierte Einheit',
    'lease_expired_short': 'Mietvertrag abgelaufen',
    'lease_ended_short': 'Mietvertrag beendet',
    'expired_label': 'Abgelaufen',
    'scheduled_tenants': 'Geplante Mieter',
    'multiple_leases': 'Mehrere Mietverträge',

    // Portal Common
    'owner_portal': 'Eigentümerportal',
    'tenant_portal': 'Mieterportal',
    'sign_out': 'Abmelden',
    'indefinite': 'Unbegrenzt',
    'total_value': 'Gesamtwert',
    'remaining_balance': 'Verbleibendes Guthaben',

    // Portal Navigation
    'lease_details': 'Mietvertragsdetails',
    'installments': 'Raten',
    'documents': 'Dokumente',
    'announcements': 'Ankündigungen',

    // Owner Portal / Admin
    'management_fees': 'Verwaltungsgebühren',
    'management_fees_subtitle': 'Übersicht aller Verwaltungseinnahmen und -pläne des Vermieters.',
    'ledger_subtitle': 'Detaillierte Aufschlüsselung Ihrer Raten für Verwaltungsgebühren und ausstehenden Beträge.',
    'agreements_subtitle': 'Sehen Sie alle Ihre Verwaltungsverträge und Eigentumsunterlagen an.',

    // Tenant Portal
    'welcome_back_user': 'Willkommen zurück, {{name}}!',
    'tenancy_overview': "Hier sehen Sie, was heute in Ihrem Mietverhältnis passiert.",
    'current_balance': 'Aktueller Saldo',
    'action_required': 'Handlung erforderlich',
    'account_good_standing': 'Konto im guten Zustand',
    'view_lease_short': 'Mietvertrag ansehen',
    'need_repairs': 'Reparaturen nötig?',
    'repairs_subtitle': 'Reichen Sie schnell ein Online-Wartungsticket ein.',
    'create_request': 'Anfrage erstellen',
    'building_news': 'Neuigkeiten & Mitteilungen',
    'payments_billing': 'Zahlungen & Abrechnung',
    'payments_subtitle': 'Verwalten Sie Ihre Mietzahlungen und sehen Sie Ihren Transaktionsverlauf ein.',
    'download_statement': 'Kontoauszug als PDF herunterladen',
    'amount_due': 'Aktuell fälliger Betrag',
    'due_on': 'Fällig am {{date}}',
    'pay_now': 'Jetzt bezahlen',
    'transaction_history': 'Transaktionsverlauf',
    'no_transactions': 'Noch keine Transaktionen',
    'first_payment_message': 'Ihr Zahlungsverlauf wird hier angezeigt, sobald Sie Ihre erste Zahlung tätigen.',
    'unit_display': 'Einheit {{number}}',

    // Tenant Lease
    'lease_details_subtitle': 'Überprüfen Sie Ihren aktiven Mietvertrag und die Immobilieninformationen.',
    'lease_signed': 'Mietvertrag unterzeichnet',
    'sign_lease_now': 'Mietvertrag jetzt unterschreiben',
    'contract_term': 'Vertragslaufzeit',
    'property_info': 'Immobilieninformationen',
    'landlord_owner': 'Vermieter / Eigentümer',
    'electronic_signature_recorded': 'Elektronische Unterschrift erfasst',
    'signed_on': 'Unterzeichnet am: {{date}}',
    'digital_trace': 'Digitale Spur',
    'legal_disclosure': 'Rechtliche Offenlegung',
    'legal_disclosure_text': 'Durch die elektronische Unterzeichnung dieses Dokuments erklären Sie sich damit einverstanden, dass Ihre elektronische Unterschrift das rechtliche Äquivalent zu Ihrer manuellen Unterschrift auf diesem Vertrag ist.',
    'electronic_lease_signing': 'Elektronische Unterzeichnung des Mietvertrags',
    'confirmation_statement': '"Ich, {{name}}, bestätige hiermit, dass ich alle Bedingungen des Mietvertrags für {{building}}, Einheit {{unit}} gelesen habe und ihnen zustimme."',
    'type_full_name': 'Vollständigen Namen eingeben zum Unterschreiben',
    'digital_verification_required': 'Digitale Signaturüberprüfung erforderlich',
    'complete_signing': 'Unterschreiben abschließen',
    'lease_not_found': 'Mietvertrag nicht gefunden',
    'lease_not_found_subtitle': 'Wenden Sie sich an die Verwaltung, wenn Sie glauben, dass dies ein Fehler ist.',

    // Lease Management
    'renew_lease': 'Mietvertrag verlängern',
    'extend_lease': 'Mietvertrag ausdehnen',
    'current_end_date': 'Aktuelles Enddatum',
    'new_end_date': 'Neues Enddatum',
    'extend': 'Verlängern',
    'transfer': 'Übertragen',
    'transfer_apartment': 'Wohnung übertragen',
    'current_apartment': 'Aktuelle Wohnung',
    'select_new_apartment': 'Neue Wohnung auswählen',
    'new_monthly_rent': 'Neue monatliche Miete',
    'transferring': 'Wird übertragen...',
    'failed_to_transfer_tenant': 'Mieterübertragung fehlgeschlagen',
    'tenant_transferred_success': 'Mieter erfolgreich übertragen',
    'expired': 'Abgelaufen',
    'select_option': 'Option auswählen',
    'invite_portal': 'Ins Portal einladen',
    'tenant_documents': 'Mieterdokumente',
    'maintenance_requests': 'Wartungsanfragen',
    'add_request': 'Anfrage hinzufügen',
    'reported_on': 'Gemeldet am',
    'send_portal_invitation': 'Portaleinladung senden',
    'fully_signed': 'Vollständig unterzeichnet',
    'voided': 'Storniert',
    'upgrade_for_analytics': 'Für Analysen aktualisieren',
    'upgrade_analytics_message': 'Aktualisieren Sie, um fortgeschrittene Analysenfunktionen freizugeben.',
    'view_plans': 'Pläne anzeigen',
    'choose_a_plan': 'Pläne auswählen',
    'subscribe_with_stripe': 'mit stripe abonnieren',
    'manage_subscription': 'Abonnement verwalten',
    'subscribe_with_stripe': 'mit stripe abonnieren',
    'upgrade': 'Aktualisieren',
    'contact_sales': 'Verkauf kontaktieren',
    'no_payment_history': 'Kein Zahlungshistorie',
    'no_subscription_history': 'Kein Abonnementshistorie',

    // ID Documents (Tenant & Owner)
    'id_documents': 'Ausweisdokumente',
    'id_document_front': 'Vorderseite',
    'id_document_back': 'Rückseite',
    'id_document_type': 'Dokumentenart',
    'id_document_number': 'Dokumentennummer',
    'id_document_uploaded_at': 'Hochgeladen am',
    'select_document_type': 'Dokumentenart auswählen',
    'national_id': 'Personalausweis',
    'passport': 'Reisepass',
    'driving_license': 'Führerschein',
    'residence_permit': 'Aufenthaltsgenehmigung',
    'other_document': 'Sonstige',
    'document_number_placeholder': 'Dokumentennummer eingeben (optional)',
    'front_side': 'Vorderseite',
    'back_side': 'Rückseite',
    'drag_drop_or_click': 'Ziehen & ablegen oder klicken zum Hochladen',
    'supported_formats': 'Unterstützt: JPG, PNG, WEBP (max 5MB)',
    'upload_id_documents': 'Ausweisdokumente hochladen',
    'uploading': 'Wird hochgeladen...',
    'id_documents_uploaded': 'Ausweisdokumente erfolgreich hochgeladen',
    'id_documents_upload_failed': 'Fehler beim Hochladen der Ausweisdokumente',
    'delete_document_side': '{{side}}-Dokument löschen',
    'confirm_delete_document': 'Möchten Sie dieses Dokument wirklich löschen?',
    'document_deleted': 'Dokument erfolgreich gelöscht',
    'document_delete_failed': 'Fehler beim Löschen des Dokuments',
    'no_id_documents': 'Noch keine Ausweisdokumente hochgeladen',
    'view_document': 'Dokument anzeigen',
    'close_preview': 'Vorschau schließen',
    'save_changes': 'Änderungen speichern',
    'pending_upload': 'Ausstehend',
    'id_documents_tab': 'Ausweisdokumente',
    'tenant_id_documents': 'Ausweisdokumente des Mieters',
    'owner_id_documents': 'Ausweisdokumente des Eigentümers',
    'id_documents_description': 'Ausweisdokumentbilder hochladen und verwalten',

    'waitlist': 'Warteliste',
    'waitlist_management': 'Wartelistenverwaltung',
    'search_waitlist': 'Suche nach Name, Telefon oder Einheit...',
    'waitlist_empty': 'Warteliste ist leer',
    'no_prospective_tenants_waiting': 'Keine zukünftigen Mieter warten derzeit auf eine Einheit.',

    // Waitlist table columns
    'priority': 'Priorität',
    'prospect': 'Interessent',
    'desired_unit': 'Gewünschte Einheit',
    'move_in_preference': 'Bevorzugtes Einzugsdatum',
    'added': 'Hinzugefügt',
    'rank': '#{{priority}}',
    'process_to_booking': 'In Buchung umwandeln',
    'remove': 'Entfernen',
    'remove_from_waitlist': 'Aus Warteliste entfernen',
    'remove_waitlist_confirm': 'Sind Sie sicher, dass Sie diesen Interessenten aus der Warteliste entfernen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',

    // Waitlist status messages
    'waitlist_processed': 'Interessent erfolgreich in eine ausstehende Buchung umgewandelt',
    'failed_process_waitlist': 'Fehler bei der Umwandlung dieses Wartelisteneintrags in eine Buchung',
    'entry_removed': 'Eintrag aus Warteliste entfernt',
    'failed_remove_entry': 'Fehler beim Entfernen des Eintrags aus der Warteliste',

    // Add to Waitlist Modal
    'add_to_waitlist': 'Zur Warteliste hinzufügen',
    'waitlist_form_subtitle': 'Der Interessent wird automatisch befördert, wenn die Einheit verfügbar wird',
    'desired_unit': 'Gewünschte Einheit',
    'prospect_details': 'Interessentendetails',
    'prospect_name': 'Name des Interessenten',
    'prospect_phone': 'Telefon des Interessenten',
    'prospect_email': 'E-Mail des Interessenten',
    'scheduling_priority': 'Planung & Priorität',
    'preferred_move_in_date': 'Bevorzugtes Einzugsdatum',
    'higher_is_first': 'Höher = zuerst in der Warteschlange',
    'priority_hint': 'Interessenten mit höherer Priorität rücken in der Warteschlange vor. Standard ist 0 (FIFO).',
    'priority_range_error': 'Priorität muss zwischen 0 und 10 liegen',
    'loading_apartments': 'Lade Wohnungen...',
    'field_required': 'Dieses Feld ist erforderlich',
    'adding': 'Wird hinzugefügt...',
    'added_to_waitlist': 'Interessent erfolgreich zur Warteliste hinzugefügt',
    'failed_add_waitlist': 'Fehler beim Hinzufügen des Interessenten zur Warteliste',
    'waitlist_auto_promote_info': 'Wenn die ausgewählte Einheit verfügbar wird, wird dieser Interessent automatisch in eine ausstehende Buchung umgewandelt, basierend auf seiner Priorität und Position in der Warteschlange.',
    'waitlist_notes_placeholder': 'Spezielle Anforderungen, Quelle des Leads, Notizen des Agenten...',

    // ── Maintenance Hub ───────────────────────────────────────────
    'maintenance_hub': 'Wartungszentrum',
    'track_and_assign_maintenance': 'Verfolgen Sie Mieteranfragen und weisen Sie Arbeitsaufträge an Lieferanten zu',
    'search_requests': 'Suche nach Problem, Mieter oder Wohnung...',
    'loading_requests': 'Lade Anfragen...',
    'no_maintenance_found': 'Keine Wartungsanfragen gefunden',
    'issue': 'Problem',
    'location': 'Standort',
    'tenant': 'Mieter',
    'assign_vendor': 'Lieferanten zuweisen',
    'update_status': 'Status aktualisieren',
    'status_updated': 'Status erfolgreich aktualisiert',
    'error_updating_status': 'Fehler beim Aktualisieren des Status',
    'error_fetching_data': 'Fehler beim Abrufen der Daten',

    // Work Orders
    'create_work_order': 'Arbeitsauftrag erstellen',
    'work_order_created': 'Arbeitsauftrag erstellt und zugewiesen',
    'error_creating_work_order': 'Fehler beim Erstellen des Arbeitsauftrags',
    'select_vendor': 'Lieferanten auswählen',
    'select_a_vendor': 'Wählen Sie einen Lieferanten',
    'estimated_cost': 'Geschätzte Kosten',
    'scheduled_date': 'Geplanter Termin',
    'work_description': 'Arbeitsbeschreibung',

    // Maintenance statuses
    'open': 'Offen',
    'in_progress': 'In Bearbeitung',
    'completed': 'Abgeschlossen',
    'cancelled': 'Abgebrochen',

    // ── Vendor Management ─────────────────────────────────────────
    'vendor_management': 'Lieferantenmanagement',
    'manage_maintenance_vendors': 'Verwalten Sie externe Wartungsunternehmen und Dienstleister',
    'add_vendor': 'Lieferanten hinzufügen',
    'add_new_vendor': 'Neuen Lieferanten hinzufügen',
    'edit_vendor': 'Lieferanten bearbeiten',
    'search_vendors': 'Suche nach Lieferantenname oder Kategorie...',
    'no_vendors_found': 'Keine Lieferanten gefunden',
    'vendor_name': 'Lieferantenname',
    'category': 'Kategorie',
    'contact_person': 'Ansprechpartner',
    'vendor_created': 'Lieferant erfolgreich erstellt',
    'vendor_updated': 'Lieferant erfolgreich aktualisiert',
    'vendor_deleted': 'Lieferant erfolgreich gelöscht',
    'update_vendor': 'Lieferanten aktualisieren',
    'save_vendor': 'Lieferanten speichern',
    'confirm_delete_vendor': 'Sind Sie sicher, dass Sie diesen Lieferanten löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
    'error_fetching_vendors': 'Fehler beim Abrufen der Lieferanten',
    'error_saving_vendor': 'Fehler beim Speichern des Lieferanten',
    'error_deleting_vendor': 'Fehler beim Löschen des Lieferanten',
    'confirm_delete_vendor_title': 'Lieferant löschen',
    'vendor_no_email': 'Lieferant hat keine E-Mail-Adresse',
    'vendor_invite_saved': 'Einladung gespeichert!',
    'vendor_invite_link_copied': 'Einrichtungslink in die Zwischenablage kopiert',
    'vendor_invite_failed': 'Einladung konnte nicht gesendet werden',
    'vendor_invite_portal': 'Zum Lieferantenportal einladen',
    'vendor_category_placeholder': 'z.B. Klempner, IT, Elektro',
    'vendor_1099_nec': 'Lieferant 1099-NEC',
    'vendor_1099_desc': 'IRS-Jahresbericht — Lieferanten, die ≥ 600 $ als Nichtarbeitnehmervergütung erhalten haben',
    'vendor_1099_disclaimer': '1099-NEC-Formulare sind für jeden Lieferanten (Nichtarbeitnehmer) erforderlich, der ≥ 600 $ in einem Kalenderjahr erhalten hat. Die IRS-Einreichungsfrist ist in der Regel der 31. Januar. Wenden Sie sich vor der Einreichung immer an einen Steuerexperten.',
    '1099_required': '1099 Erforderlich',
    'no_vendor_payments_recorded': 'Keine Lieferantenzahlungen erfasst für',

    // ── Contract Templates ────────────────────────────────────────
    'contract_templates': 'Vertragsvorlagen',
    'manage_legal_templates_desc': 'Verwalten Sie rechtliche Rahmenbedingungen und automatisierte Regeln für Verträge.',
    'create_template': 'Vorlage erstellen',
    'search_templates': 'Suche nach Vorlagen...',
    'no_templates_found': 'Keine Vorlagen gefunden',
    'create_first_template_desc': 'Beginnen Sie mit der Erstellung Ihrer ersten rechtlichen Vertragsvorlage.',
    'no_description_provided': 'Keine Beschreibung angegeben.',
    'default_rules': 'Standardregeln',
    'failed_to_load_templates': 'Fehler beim Laden der Vorlagen',
    'template_deleted_successfully': 'Vorlage erfolgreich gelöscht',
    'failed_to_delete_template': 'Fehler beim Löschen der Vorlage',
    'confirm_delete_template': 'Sind Sie sicher, dass Sie diese Vorlage löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',

    // Contract Template Form
    'edit_template': 'Vorlage bearbeiten',
    'create_new_template': 'Neue Vorlage erstellen',
    'template_details': 'Vorlagendetails',
    'template_name': 'Vorlagenname',
    'is_active': 'Aktive Vorlage',
    'legal_text': 'Inhalt des Rechtstextes',
    'default_variable_rules': 'Standard-Variablenregeln',
    'default_rules_desc': 'Definieren Sie Standardvariablen (wie commission_rate), die der Ersteller verwenden wird.',
    'add_rule': 'Regel hinzufügen',
    'no_default_rules': 'Keine Standardregeln definiert.',
    'variable_name_placeholder': 'Variablenname (z.B. commission_rate)',
    'default_value_placeholder': 'Standardwert (z.B. 8)',
    'archive_template': 'Vorlage archivieren',
    'archive_template_confirm': 'Sind Sie sicher, dass Sie diese Vorlage archivieren möchten? Sie wird für neue Verträge nicht mehr verfügbar sein.',
    'archive': 'Archivieren',
    'template_archived_successfully': 'Vorlage erfolgreich archiviert',
    'failed_to_archive_template': 'Fehler beim Archivieren der Vorlage',
    'template_updated_successfully': 'Vorlage erfolgreich aktualisiert',
    'template_created_successfully': 'Vorlage erfolgreich erstellt',
    'failed_to_save_template': 'Fehler beim Speichern der Vorlage',
    'failed_to_load_template': 'Fehler beim Laden der Vorlage',

    // Contract types
    'management': 'Verwaltung',
    'lease': 'Miete',
    'sale': 'Verkauf',
    'lease_progress': 'Mietfortschritt',
    'status_open': 'Offen',
    'status_in_progress': 'In Bearbeitung',
    'status_completed': 'Abgeschlossen',
    'status_cancelled': 'Abgebrochen',
    'priority_low': 'Niedrig',
    'priority_medium': 'Mittel',
    'priority_high': 'Hoch',
    'priority_urgent': 'Dringend',
    'priority_emergency': 'Notfall',
    'estimated_cost': 'Gesch. Kosten',
    'tenant_portal_submissions': 'Mieterportal-Einreichungen',
    'portal_submission_note': 'Vom Mieter über das Selbstbedienungsportal eingereichte Dateien',
    'tenant_proof_document': 'Ausweis / Nachweis',
    'tenant_insurance_document': 'Versicherung / Bescheinigung',
    'not_submitted': 'Nicht eingereicht',
    'saved': 'Gespeichert',
    'payment_method': 'Methode',
    'tenant_ledger': 'Mieter-Hauptbuch',
    'ledger_description': 'Unveränderliches Protokoll aller Gebühren und Zahlungen. Guthaben hinzufügen, um Fehler zu korrigieren.',
    'ledger_generate_monthly': 'Monatlich generieren',
    'ledger_add_charge': 'Gebühr hinzufügen',
    'ledger_add_credit': 'Guthaben hinzufügen',
    'ledger_apply_late_fee': 'Verzugsgebühr anwenden',
    'ledger_late_fee': 'Verzugsgebühr',
    'ledger_charge': 'Gebühr',
    'ledger_deposit': 'Kaution',
    'ledger_payment': 'Zahlung',
    'ledger_credit': 'Guthaben',
    'ledger_charge_rent_fee': 'Gebühr (Miete / Sonstiges)',
    'ledger_description_placeholder': 'z. B. Wartungsgebühr',
    'outstanding_balance': 'Offener Saldo',
    'ledger_balance_note': 'Abgeleitet aus allen Buchhaltungseinträgen',
    'ledger_total_entries': 'Einträge gesamt',
    'ledger_no_entries': 'Noch keine Buchhaltungseinträge',
    'ledger_no_entries_hint': 'Generieren Sie die erste monatliche Gebühr oder buchen Sie manuell eine Gebühr.',
    'ledger_balance_after': 'Saldo danach',
    'ledger_charge_added': 'Gebühr im Hauptbuch eingetragen',
    'ledger_charge_failed': 'Gebühr konnte nicht hinzugefügt werden',
    'ledger_credit_added': 'Guthaben im Hauptbuch eingetragen',
    'ledger_credit_failed': 'Guthaben konnte nicht hinzugefügt werden',
    'ledger_late_fee_applied': 'Verzugsgebühr im Hauptbuch eingetragen',
    'ledger_late_fee_failed': 'Verzugsgebühr konnte nicht angewendet werden',
    'ledger_monthly_generated': 'Monatliche Gebühr generiert',
    'ledger_monthly_failed': 'Gebühr konnte nicht generiert werden',
    'ledger_load_failed': 'Hauptbuch konnte nicht geladen werden',
    'created_by': 'Erstellt von',
    'expired': 'Abgelaufen',
    'expiring_soon': 'Läuft bald ab',
    'email': 'E-Mail',

    // ── Mieterportal ──────────────────────────────────────────────────────────

    // Dashboard
    'failed_to_load_dashboard_data': 'Dashboard-Daten konnten nicht geladen werden',
    'welcome_back_user': 'Willkommen zurück, {{name}}',
    'tenancy_overview': 'Überblick über Ihr Mietverhältnis',
    'unit_display': 'Einheit {{number}}',
    'current_balance': 'Aktueller Saldo',
    'action_required': 'Maßnahme erforderlich',
    'account_good_standing': 'Konto in gutem Zustand',
    'lease_ends': 'Mietende',
    'view_lease_short': 'Mietvertrag anzeigen',
    'need_repairs': 'Reparaturen nötig?',
    'repairs_subtitle': 'Wartungsanfrage einreichen',
    'create_request': 'Anfrage erstellen',
    'quick_actions': 'Schnellaktionen',
    'pay_now': 'Jetzt bezahlen',
    'recent_account_activity': 'Letzte Kontoaktivität',
    'view_ledger': 'Hauptbuch anzeigen',
    'no_ledger_entries_yet': 'Noch keine Einträge',
    'active_maintenance': 'Aktive Wartung',
    'view_all': 'Alle anzeigen',
    'all_clear_maintenance': 'Keine offenen Anfragen',
    'maintenance_request_default': 'Wartungsanfrage',
    'building_news': 'Gebäudenachrichten',
    'lease_progress': 'Mietvertragsverlauf',
    'days_left': 'Noch {{days}} Tage',
    'expires_today': 'Läuft heute ab!',
    'pct_elapsed': '{{pct}}% verstrichen',
    'balance_after': 'Saldo:',

    // Zahlungen
    'failed_to_load_payment_data': 'Zahlungsdaten konnten nicht geladen werden',
    'failed_to_initiate_payment': 'Zahlung konnte nicht eingeleitet werden',
    'payments_billing': 'Zahlungen & Abrechnung',
    'payments_billing_subtitle': 'Mietverlauf, Servicegebühren und vollständiges Hauptbuch',
    'download_statement': 'Kontoauszug herunterladen',
    'current_amount_due': 'Aktuell fälliger Betrag',
    'due_on': 'Fällig am',
    'view_ledger_hint': 'Möchten Sie sehen, wie das berechnet wurde?',
    'view_your_ledger': 'Ihr Hauptbuch anzeigen',
    'in_n_days': 'In {{count}} Tag',
    'in_n_days_plural': 'In {{count}} Tagen',
    'due_today': '⚡ Heute fällig',
    'all_paid_up': 'Alles bezahlt!',
    'tab_rent_payments': 'Mietzahlungen',
    'tab_service_charges': 'Servicegebühren',
    'tab_service_charges_due': 'Servicegebühren ({{count}} fällig)',
    'tab_account_ledger': 'Kontobuch',
    'transaction_history': 'Transaktionsverlauf',
    'no_transactions': 'Noch keine Transaktionen',
    'no_transactions_subtitle': 'Ihr Zahlungsverlauf erscheint hier, sobald Zahlungen erfasst wurden.',
    'rejected': 'Abgelehnt',
    'outstanding_service_charges': 'Ausstehende Servicegebühren',
    'paid_service_history': 'Bezahlte Servicehistorie',
    'service_charge_default': 'Servicegebühr',
    'pay': 'Bezahlen',
    'paid_badge': 'Bezahlt',
    'no_service_charges': 'Keine Servicegebühren',
    'no_service_charges_subtitle': 'Sie haben derzeit keine Servicegebühren.',
    'account_balance': 'Kontostand',
    'ledger_calculated_from': 'Berechnet aus {{count}} Einträgen',
    'full_account_statement': 'Vollständiger Kontoauszug',
    'full_account_statement_subtitle': 'Jede Gebühr und Zahlung auf Ihrem Konto mit laufendem Saldo.',
    'balance_after_col': 'Saldo danach',
    'no_ledger_entries': 'Noch keine Hauptbucheinträge',
    'no_ledger_entries_subtitle': 'Ihre Finanzhistorie erscheint hier, sobald Gebühren gebucht wurden.',
    'ledger_type_charge': 'Gebühr',
    'ledger_type_late_fee': 'Verzugsgebühr',
    'ledger_type_deposit': 'Kaution',
    'ledger_type_payment': 'Zahlung',
    'ledger_type_credit': 'Guthaben',
    'payment_success_stripe': 'Zahlung erfolgreich! Ihr Konto wird in Kürze aktualisiert.',
    'payment_cancelled_stripe': 'Zahlung abgebrochen. Es wurde kein Betrag belastet.',
    'online_payments_not_enabled': 'Online-Zahlungen sind noch nicht aktiviert.',

    // Mietvertrag
    'failed_to_load_lease_details': 'Mietvertragsdaten konnten nicht geladen werden',
    'lease_signed_success': 'Mietvertrag erfolgreich unterzeichnet!',
    'failed_to_sign_lease': 'Mietvertrag konnte nicht unterzeichnet werden',
    'lease_pdf_download_success': 'Mietvertrag-PDF erfolgreich heruntergeladen',
    'lease_pdf_download_failed': 'Mietvertrag konnte nicht heruntergeladen werden. Bitte versuchen Sie es erneut.',
    'generating': 'Wird erstellt…',
    'download_pdf': 'PDF herunterladen',
    'download_your_lease': 'Unterzeichneten Mietvertrag als PDF herunterladen',
    'unit_prefix': 'Einheit',
    'ip_trace': 'IP-Nachweis:',
    'integrity_hash': 'Integritäts-Hash:',
    'signature_graphic': 'Unterschriftsgrafik:',
    'lease_details': 'Mietvertragsdetails',
    'lease_details_subtitle': 'Ihr aktiver Mietvertrag und Zahlungsinformationen',
    'lease_signed': 'Unterzeichnet',
    'sign_lease_now': 'Mietvertrag jetzt unterzeichnen',
    'contract_term': 'Vertragslaufzeit',
    'start_date': 'Startdatum',
    'end_date': 'Enddatum',
    'property_information': 'Immobiliendaten',
    'landlord_owner': 'Vermieter / Eigentümer',
    'payment_status': 'Zahlungsstatus',
    'payment_required': 'Zahlung erforderlich',
    'e_signature_recorded': 'Elektronische Unterschrift erfasst',
    'signed_on': 'Unterzeichnet am',
    'legal_disclosure': 'Rechtliche Hinweise',
    'legal_disclosure_text': 'Dieser Mietvertrag ist rechtlich bindend. Durch elektronische Unterzeichnung stimmen Sie allen Bedingungen zu. Bitte lesen Sie das vollständige Dokument vor der Unterzeichnung.',
    'lease_not_found': 'Kein Mietvertrag gefunden',
    'contact_management_error': 'Bitte kontaktieren Sie die Verwaltung, wenn Sie der Meinung sind, dass dies ein Fehler ist.',

    // Profil
    'my_profile': 'Mein Profil',
    'my_profile_subtitle': 'Kontaktinformationen und Passwort aktualisieren',
    'personal_information': 'Persönliche Informationen',
    'full_name': 'Vollständiger Name',
    'your_full_name_placeholder': 'Ihr vollständiger Name',
    'phone_placeholder': '+49 1XX XXXXXXXX',
    'email_placeholder': 'ihre@email.de',
    'save_changes': 'Änderungen speichern',
    'change_password': 'Passwort ändern',
    'current_password': 'Aktuelles Passwort',
    'new_password': 'Neues Passwort',
    'confirm_new_password': 'Neues Passwort bestätigen',
    'min_8_chars': 'Mind. 8 Zeichen',
    'repeat_new_password': 'Neues Passwort wiederholen',
    'update_password': 'Passwort aktualisieren',
    'updating': 'Wird aktualisiert...',
    'passwords_do_not_match': 'Passwörter stimmen nicht überein',
    'password_min_8': 'Das Passwort muss mindestens 8 Zeichen lang sein',
    'failed_to_load_profile': 'Profil konnte nicht geladen werden',
    'profile_updated': 'Profil erfolgreich aktualisiert!',
    'password_changed': 'Passwort erfolgreich geändert!',
    'failed_to_update_profile': 'Profil konnte nicht aktualisiert werden',
    'failed_to_change_password': 'Passwort konnte nicht geändert werden',
    'account_id': 'Konto-ID',
    'tenant_since': 'Mieter seit',

    // Inspektionen
    'my_inspections': 'Meine Inspektionen',
    'my_inspections_subtitle': 'Inspektionsberichte für Ihre Einheit',
    'no_inspections_yet': 'Noch keine Inspektionen',
    'no_inspections_subtitle': 'Abgeschlossene Inspektionsberichte erscheinen hier.',
    'items_checked': '{{done}}/{{total}} Punkte geprüft',
    'inspection_items': 'Inspektionspunkte',
    'general_notes': 'Allgemeine Notizen',
    'failed_to_load_inspections': 'Inspektionen konnten nicht geladen werden',
    'inspection_type_move_in': 'Einzug',
    'inspection_type_move_out': 'Auszug',
    'inspection_type_periodic': 'Periodisch',
    'inspection_type_maintenance': 'Wartung',
    'inspection_status_completed': 'Abgeschlossen',
    'inspection_status_signed': 'Unterzeichnet',
    'inspection_status_draft': 'Entwurf',

    // Servicegebühren
    'service_charges_title': 'Servicegebühren',
    'service_charges_subtitle': 'Monatliche Gebäudeservicegebühren für Ihre Einheit',
    'total_charges': 'Gesamtgebühren',
    'outstanding_balance_label': 'Ausstehender Saldo',
    'service_charges_year': 'Servicegebühren — {{year}}',
    'no_service_charges_year': 'Keine Servicegebühren für {{year}}',
    'no_service_charges_year_hint': 'Servicegebühren erscheinen hier, wenn sie von Ihrem Verwalter erstellt wurden.',
    'paid_on': 'Bezahlt am {{date}}',
    'unpaid': 'Unbezahlt',
    'pay_online': 'Online bezahlen',
    'service_paid_success': 'Servicegebühr erfolgreich bezahlt!',
    'payment_canceled': 'Zahlung abgebrochen.',
    'failed_to_load_service_charges': 'Servicegebühren konnten nicht geladen werden',

    // Nachrichten
    'management_team': 'Verwaltungsteam',
    'management_team_subtitle': 'Direktnachricht an die Immobilienverwaltung',
    'message_empty_state': 'Senden Sie eine Nachricht, um die Verwaltung zu kontaktieren.',
    'message_placeholder': 'Nachricht an die Verwaltung eingeben...',
    'failed_to_load_messages': 'Nachrichten konnten nicht geladen werden',
    'failed_to_send_message': 'Nachricht konnte nicht gesendet werden',

    'portfolio_summary': 'Portfolio-Übersicht',
    'portfolio_subtitle': 'Echtzeit-Leistungskennzahlen für {{name}}.',
    'portfolio_statement': 'Portfolio-Auszug',
    'total_units': 'Gesamte Einheiten',
    'occupancy_rate': 'Belegungsrate',
    'active_leases': '{{count}} aktive Mietverträge',
    'monthly_revenue': 'Monatliche Einnahmen',
    'vacant_units': 'Freie Einheiten',
    'installment_summary': 'Ratenzusammenfassung',
    'view_detailed_ledger': 'Detailliertes Hauptbuch anzeigen',
    'outstanding': 'Ausstehend',
    'across_installments': 'Über {{count}} Raten',
    'actions_required': '{{count}} sofortige Maßnahmen erforderlich',
    'proceed_to_payments': 'Zu Zahlungen wechseln',
    'revenue_performance': 'Einnahmenentwicklung (letzte 6 Monate)',
    'no_revenue_data': 'Keine Umsatzdaten gefunden',
    'portfolio_distribution': 'Portfolio-Verteilung',
    'no_building_data': 'Keine Gebäudedaten gefunden',
    'occupied_label': 'BELEGT',
    'ready_to_scale': 'Bereit zu skalieren?',
    'ready_to_scale_subtitle': 'Verwalten Sie Ihre Immobilien mit maximaler Transparenz.',
    'financials': 'Finanzen',
    'approvals': 'Genehmigungen',
    'failed_to_download_statement': 'Auszug konnte nicht heruntergeladen werden',
    'my_properties': 'Meine Immobilien',
    'my_properties_subtitle': 'Übersicht aller Einheiten in Ihrem Verwaltungsportfolio.',
    'portfolio_empty': 'Portfolio leer',
    'portfolio_empty_subtitle': 'Ihrem Konto sind derzeit keine Einheiten zugewiesen.',
    'floor_prefix': 'Etage',
    'current_rent': 'Aktuelle Miete',
    'per_month_short': '/Monat',
    'sqm': 'm²',
    'maintenance_approvals': 'Wartungsgenehmigungen',
    'maintenance_approvals_subtitle': 'Überprüfen und genehmigen Sie Reparaturanfragen Ihrer Mieter.',
    'no_maintenance_requests': 'Keine Wartungsanfragen',
    'no_maintenance_subtitle': 'Alle Ihre Immobilien sind derzeit gut gewartet.',
    'pending_approval': 'Ausstehende Genehmigung',
    'approved_in_progress': 'Genehmigt / In Bearbeitung',
    'rejected_cancelled': 'Abgelehnt/Storniert',
    'above_threshold': 'Über ${{amount}}-Schwelle',
    'high_priority': 'Hohe Priorität',
    'medium_priority': 'Mittlere Priorität',
    'low_priority': 'Niedrige Priorität',
    'est_cost': 'Geschätzte Kosten',
    'approve': 'Genehmigen',
    'reject': 'Ablehnen',
    'request_status_updated': 'Anfragestatus aktualisiert',
    'failed_to_update_request': 'Status konnte nicht aktualisiert werden',
    'failed_to_load_maintenance': 'Wartungsanfragen konnten nicht geladen werden',
    'failed_to_load_properties': 'Ihre Immobilien konnten nicht geladen werden',
    'financial_overview': 'Finanzübersicht',
    'financial_subtitle': 'Verfolgen Sie die Einnahmen Ihrer Mieter über alle Immobilien.',
    'no_financial_data': 'Keine Finanzdaten',
    'no_payments_message': 'Derzeit keine aufgezeichneten Zahlungen für Ihr Portfolio.',
    'recent_payments': 'Letzte Zahlungen',
    'overdue_payments': 'Überfällige Zahlungen',
    'property_tenant': 'Immobilie / Mieter',
    'gross_amount': 'Bruttobetrag',
    'commission': 'Provision',
    'net_amount': 'Nettobetrag',
    'since': 'Seit',
    'amount_owed': 'Geschuldeter Betrag',
    'management_commission': 'Verwaltungsprovision',
    'failed_to_load_financials': 'Finanzdaten konnten nicht geladen werden',
    'statement_downloaded': 'Kontoauszug für {{month}} {{year}} heruntergeladen!',
    'member_since': 'Mitglied seit',
    'saving': 'Speichern...',
    'owner_messages_title': 'Immobilienverwaltung',
    'owner_messages_subtitle': 'Direktnachricht mit dem Verwaltungsteam',
    'owner_service_charges': 'Servicekosten',
    'owner_service_charges_subtitle': 'Monatliche Gebäudeservicegebühren für Ihre leerstehenden Einheiten',
    'owner_service_info': 'Servicegebühren gelten nur für Ihre <strong>leerstehenden</strong> Einheiten. Vermietete Einheiten werden direkt dem Mieter in Rechnung gestellt.',
    'total_charges': 'Gesamtgebühren',
    'outstanding_balance': 'Offener Saldo',
    'no_service_charges_year': 'Keine Servicegebühren für {{year}}',
    'no_service_charges_subtitle': 'Servicegebühren für leerstehende Einheiten werden hier nach der Generierung angezeigt.',
    'paid_on': 'Bezahlt am {{date}}',
    'pay_online': 'Online bezahlen',
    'service_charge_paid': 'Servicegebühr erfolgreich bezahlt!',
    'unpaid': 'Unbezahlt',
    'my_agreements': 'Meine Vereinbarungen',
    'agreements_subtitle': 'Alle Ihre Verwaltungsverträge und Eigentumsunterlagen anzeigen.',
    'no_active_agreements': 'Keine aktiven Vereinbarungen',
    'no_contracts_message': 'Sie haben noch keine Verwaltungsverträge in unserem System gespeichert.',
    'total_value': 'Gesamtwert',
    'remaining': 'Verbleibend',
    'indefinite': 'Unbefristet',
    'sign_now': 'Jetzt unterzeichnen',
    'failed_to_load_agreements': 'Vereinbarungen konnten nicht geladen werden',
    'financial_ledger': 'Finanzbuch',
    'ledger_subtitle': 'Detaillierte Aufschlüsselung der Verwaltungsgebühr-Raten und ausstehenden Salden.',
    'total_outstanding': 'Gesamtausstand',
    'no_installments': 'Keine Raten in Ihrem Hauptbuch gefunden.',
    'settled': 'Beglichen',
    'pay_amount': '{{amount}} zahlen',
    'failed_to_load_installments': 'Ratenplan konnte nicht geladen werden',
    'failed_to_initiate_payment': 'Zahlung konnte nicht initiiert werden',
    'error_connecting_payment': 'Fehler bei der Verbindung zum Zahlungsanbieter',
    'payment_success_msg': 'Zahlung erfolgreich abgeschlossen!',
    'payment_canceled_msg': 'Zahlung abgebrochen.',
    'welcome_user': 'Willkommen, {{name}}!',
    'owner_portal': 'Eigentümer-Portal',
    'tenant_portal': 'Mieter-Portal',
    'owner': 'Eigentümer',
    'tenant': 'Mieter',
    'core': 'Kern',
    'properties_&_contracts': 'Immobilien & Verträge',
    'financial': 'Finanzen',
    'financial_&_lease': 'Finanzen & Mietvertrag',
    'Dashboard': 'Dashboard',
    'Properties': 'Immobilien',
    'Contracts': 'Verträge',
    'Installments': 'Raten',
    'Service Charges': 'Servicegebühren',
    'Financials': 'Finanzen',
    'Maintenance': 'Wartung',
    'Payments': 'Zahlungen',
    'Lease Details': 'Mietdetails',
    'Inspections': 'Inspektionen',
    'Profile': 'Profil',
    'documents': 'Dokumente',
    'announcements': 'Ankündigungen',
    'messages': 'Nachrichten',
    'Messages': 'Nachrichten',
    'maintenance_subtitle': 'Alle Wartungsanfragen an einem Ort einreichen und verfolgen.',
    'new_request': 'Neue Anfrage',
    'report_an_issue': 'Problem melden',
    'issue_summary': 'Problemübersicht',
    'issue_summary_placeholder': 'z.B. Undichter Wasserhahn im Bad',
    'urgency_level': 'Dringlichkeitsstufe',
    'low_urgency': 'Niedrig – Nicht dringend',
    'normal_urgency': 'Normal – Benötigt Aufmerksamkeit',
    'high_urgency': 'Hoch – Beeinflusst den Alltag',
    'emergency_urgency': 'Notfall – Sofortiger Handlungsbedarf',
    'describe_the_problem': 'Problem beschreiben',
    'describe_problem_placeholder': 'Bitte beschreiben Sie das Problem so detailliert wie möglich...',
    'upload_photo_optional': 'Foto hochladen (optional)',
    'add_photo': 'Foto hinzufügen',
    'photo_upload_tip': 'Ein Foto hilft uns, Ihr Problem schneller zu lösen.',
    'photo_upload_specs': 'JPG, PNG oder WEBP. Max. 5 MB.',
    'emergency_contact_warning': 'Bei lebensbedrohlichen Notfällen rufen Sie sofort den Notfalldienst an. Wir behandeln diese Anfrage mit höchster Priorität.',
    'processing': 'Wird verarbeitet…',
    'submit_request': 'Anfrage einreichen',
    'ongoing_past_requests': 'Laufende & vergangene Anfragen',
    'submitted': 'Eingereicht',
    'in_progress': 'In Bearbeitung',
    'completed': 'Abgeschlossen',
    'request_cancelled': 'Anfrage storniert',
    'all_clear': 'Alles in Ordnung!',
    'no_maintenance_on_record': 'Keine Wartungsanfragen vorhanden. Alles sieht gut aus!',
    'resolved_on': 'Gelöst am {{date}}',
    'failed_to_load_maintenance_requests': 'Wartungsanfragen konnten nicht geladen werden',
    'failed_to_submit_request': 'Anfrage konnte nicht eingereicht werden',
    'photo_size_limit_error': 'Foto muss kleiner als 5 MB sein',
    'request_submitted_success': 'Anfrage erfolgreich eingereicht',
    'low': 'Niedrig',
    'normal': 'Normal',
    'high': 'Hoch',
    'emergency': 'Notfall',
    'id': 'ID',
    'announcements_subtitle': 'Bleiben Sie über die neuesten Nachrichten Ihrer Hausverwaltung informiert.',
    'no_announcements_title': 'Keine Ankündigungen',
    'no_announcements_subtitle': 'Schauen Sie später wieder vorbei für Updates Ihrer Hausverwaltung.',
    'posted_by': 'Gepostet von {{name}}',
    'failed_to_load_announcements': 'Ankündigungen konnten nicht geladen werden',
    'documents_verification': 'Dokumente & Verifizierung',
    'documents_verification_subtitle': 'Laden Sie Ihre erforderlichen Dokumente hoch und halten Sie sie aktuell.',
    'supported_formats_specs': 'Akzeptierte Formate: PDF, JPG, JPEG, PNG. Maximal 5 MB pro Dokument.',
    'identification_proof': 'Identitätsnachweis',
    'identification_proof_desc': 'Behördlicher Ausweis wie Reisepass, Personalausweis oder Führerschein.',
    'renters_insurance': 'Mieterversicherung',
    'renters_insurance_desc': 'Gültige Mieterversicherungsbescheinigung für Ihre Einheit.',
    'verified': 'Verifiziert',
    'missing': 'Fehlend',
    'pdf_document': 'PDF-Dokument',
    'view_full_size': 'In voller Größe ansehen',
    'replace': 'Ersetzen',
    'upload_file': 'Datei hochladen',
    'need_help_verification': 'Hilfe bei der Verifizierung?',
    'need_help_verification_subtitle': 'Bei Schwierigkeiten mit dem Upload wenden Sie sich an unser Support-Team.',
    'contact_support': 'Support kontaktieren',
    'failed_to_load_document_status': 'Dokumentstatus konnte nicht geladen werden',
    'file_size_large_error': 'Datei zu groß. Max. 5 MB.',
    'document_uploaded_success': 'Dokument erfolgreich hochgeladen',
    'failed_to_upload_document': 'Dokument konnte nicht hochgeladen werden',
    'my_inspections': 'Meine Inspektionen',
    'my_inspections_subtitle': 'Alle Inspektionen im Zusammenhang mit Ihrem Mietverhältnis anzeigen.',
    'no_inspections_yet': 'Noch keine Inspektionen',
    'no_inspections_subtitle': 'Ihre Inspektionsprotokolle erscheinen hier nach Abschluss.',
    'failed_to_load_inspections': 'Inspektionen konnten nicht geladen werden',
    'inspection_type_move_in': 'Einzug',
    'inspection_type_move_out': 'Auszug',
    'inspection_type_periodic': 'Periodisch',
    'inspection_type_maintenance': 'Wartung',
    'inspection_status_completed': 'Abgeschlossen',
    'inspection_status_signed': 'Unterzeichnet',
    'inspection_status_draft': 'Entwurf',
    'unit_prefix': 'Einheit',
    'items_checked': '{{done}} / {{total}} Elemente geprüft',
    'inspection_items': 'Inspektionspunkte',
    'general_notes': 'Allgemeine Notizen',
    'management_team': 'Verwaltungsteam',
    'management_team_subtitle': 'Direktleitung zu Ihrer Hausverwaltung',
    'message_empty_state': 'Noch keine Nachrichten. Starten Sie das Gespräch!',
    'failed_to_load_messages': 'Nachrichten konnten nicht geladen werden',
    'failed_to_send_message': 'Nachricht konnte nicht gesendet werden',
    'message_placeholder': 'Nachricht eingeben...',
    'lease_details_subtitle': 'Überprüfen Sie Ihren Mietvertrag, Zahlungsstatus und digitale Unterschrift.',
    'lease_not_found': 'Kein Mietvertrag gefunden',
    'contact_management_error': 'Bitte wenden Sie sich an Ihre Hausverwaltung.',
    'lease_signed': 'Unterzeichnet',
    'download_your_lease': 'Mietvertrag als PDF herunterladen',
    'generating': 'Wird erstellt...',
    'download_pdf': 'PDF herunterladen',
    'sign_lease_now': 'Jetzt unterschreiben',
    'contract_term': 'Vertragslaufzeit',
    'property_information': 'Immobilie & Eigentümer',
    'landlord_owner': 'Vermieter / Eigentümer',
    'payment_status': 'Zahlungsstatus',
    'current_balance': 'Aktuelles Guthaben',
    'payment_required': 'Zahlung erforderlich',
    'account_good_standing': 'Konto in gutem Zustand',
    'lease_signed_success': 'Mietvertrag erfolgreich unterzeichnet!',
    'failed_to_sign_lease': 'Mietvertrag konnte nicht unterzeichnet werden',
    'lease_pdf_download_success': 'PDF erfolgreich heruntergeladen',
    'lease_pdf_download_failed': 'PDF konnte nicht heruntergeladen werden',
    'e_signature_recorded': 'Elektronische Signatur erfasst',
    'signed_on': 'Unterzeichnet am',
    'ip_trace': 'IP',
    'integrity_hash': 'Hash',
    'signature_graphic': 'Ihre Unterschrift',
    'legal_disclosure': 'Rechtlicher Hinweis',
    'legal_disclosure_text': 'Dieser Mietvertrag ist ein rechtlich bindendes Dokument. Mit elektronischer Unterschrift stimmen Sie allen Bedingungen zu.',
    'payments_billing': 'Zahlungen & Abrechnung',
    'payments_billing_subtitle': 'Verfolgen Sie Mietzahlungen, Nebenkosten und Kontoauszug.',
    'download_statement': 'Kontoauszug herunterladen',
    'current_amount_due': 'Aktuell fälliger Betrag',
    'due_on': 'Fällig am',
    'view_ledger_hint': 'Vollständigen Transaktionsverlauf anzeigen im',
    'view_your_ledger': 'Kontoauszug',
    'all_paid_up': 'Alles bezahlt!',
    'tab_rent_payments': 'Mietzahlungen',
    'tab_service_charges': 'Nebenkosten',
    'tab_service_charges_due': 'Nebenkosten ({{count}} ausstehend)',
    'tab_account_ledger': 'Kontoauszug',
    'transaction_history': 'Transaktionsverlauf',
    'no_transactions': 'Noch keine Transaktionen',
    'no_transactions_subtitle': 'Ihr Zahlungsverlauf erscheint hier.',
    'outstanding_service_charges': 'Offene Nebenkosten',
    'service_charge_default': 'Nebenkosten',
    'paid_service_history': 'Bezahlte Nebenkosten',
    'paid_badge': 'Bezahlt',
    'no_service_charges': 'Keine Nebenkosten',
    'no_service_charges_subtitle': 'Keine Nebenkosten wurden Ihrem Konto berechnet.',
    'account_balance': 'Kontostand',
    'ledger_calculated_from': 'Berechnet aus {{count}} Transaktionen',
    'full_account_statement': 'Vollständiger Kontoauszug',
    'full_account_statement_subtitle': 'Alle Belastungen und Zahlungen Ihres Kontos',
    'no_ledger_entries': 'Keine Buchungen',
    'no_ledger_entries_subtitle': 'Ihre Kontoaktivität erscheint hier.',
    'balance_after_col': 'Saldo nach',
    'ledger_type_charge': 'Belastung',
    'ledger_type_late_fee': 'Verzugsgebühr',
    'ledger_type_deposit': 'Kaution',
    'ledger_type_payment': 'Zahlung',
    'ledger_type_credit': 'Gutschrift',
    'payment_success_stripe': 'Zahlung erfolgreich! Ihr Konto wurde aktualisiert.',
    'payment_cancelled_stripe': 'Zahlung abgebrochen. Es wurden keine Gebühren erhoben.',
    'online_payments_not_enabled': 'Online-Zahlungen sind für Ihr Konto nicht aktiviert.',
    'failed_to_initiate_payment': 'Zahlung konnte nicht eingeleitet werden',
    'failed_to_load_payment_data': 'Zahlungsdaten konnten nicht geladen werden',
    'my_profile': 'Mein Profil',
    'my_profile_subtitle': 'Verwalten Sie Ihre persönlichen Daten und Kontosicherheit.',
    'personal_information': 'Persönliche Informationen',
    'full_name': 'Vollständiger Name',
    'your_full_name_placeholder': 'Ihr vollständiger Name',
    'phone_placeholder': '+49 XXX XXXXXXXX',
    'email_placeholder': 'sie@beispiel.de',
    'saving': 'Wird gespeichert...',
    'save_changes': 'Änderungen speichern',
    'change_password': 'Passwort ändern',
    'current_password': 'Aktuelles Passwort',
    'new_password': 'Neues Passwort',
    'confirm_new_password': 'Neues Passwort bestätigen',
    'min_8_chars': 'Min. 8 Zeichen',
    'repeat_new_password': 'Neues Passwort wiederholen',
    'passwords_do_not_match': 'Passwörter stimmen nicht überein',
    'updating': 'Wird aktualisiert...',
    'update_password': 'Passwort aktualisieren',
    'account_id': 'Konto-ID',
    'tenant_since': 'Mieter seit',
    'failed_to_load_profile': 'Profil konnte nicht geladen werden',
    'profile_updated': 'Profil erfolgreich aktualisiert',
    'failed_to_update_profile': 'Profil konnte nicht aktualisiert werden',
    'password_changed': 'Passwort erfolgreich geändert',
    'failed_to_change_password': 'Passwort konnte nicht geändert werden',
    'password_min_8': 'Das Passwort muss mindestens 8 Zeichen lang sein',
    'service_charges_title': 'Nebenkosten',
    'service_charges_subtitle': 'Nebenkosten anzeigen und bezahlen.',
    'total_charges': 'Gesamtgebühren',
    'outstanding_balance_label': 'Ausstehend',
    'service_charges_year': 'Nebenkosten — {{year}}',
    'no_service_charges_year': 'Keine Nebenkosten für {{year}}',
    'no_service_charges_year_hint': 'Versuchen Sie, ein anderes Jahr auszuwählen.',
    'paid_on_date': 'Bezahlt am {{date}}',
    'unpaid_label': 'Unbezahlt',
    'pay_online': 'Online bezahlen',
    'service_paid_success': 'Nebenkosten erfolgreich bezahlt!',
    'payment_canceled': 'Zahlung abgebrochen.',
    'failed_to_load_service_charges': 'Nebenkosten konnten nicht geladen werden',
    'portfolio_summary': 'Portfolio-Übersicht',
    'portfolio_subtitle': 'Willkommen zurück, {{name}}. Hier ist Ihre Immobilien-Portfolio-Übersicht.',
    'portfolio_statement': 'Portfolio-Auszug',
    'total_units': 'Gesamte Einheiten',
    'occupancy_rate': 'Belegungsrate',
    'active_leases': '{{count}} aktive Mietverträge',
    'monthly_revenue': 'Monatliche Einnahmen',
    'vacant_units': 'Leerstehende Einheiten',
    'installment_summary': 'Ratenübersicht',
    'view_detailed_ledger': 'Detailliertes Konto anzeigen',
    'outstanding': 'Ausstehend',
    'across_installments': 'Über {{count}} Raten',
    'overdue': 'Überfällig',
    'actions_required': '{{count}} Maßnahmen erforderlich',
    'proceed_to_payments': 'Zu Zahlungen',
    'revenue_performance': 'Umsatzentwicklung',
    'no_revenue_data': 'Keine Umsatzdaten verfügbar',
    'portfolio_distribution': 'Portfolio-Verteilung',
    'no_building_data': 'Keine Gebäudedaten verfügbar',
    'occupied_label': 'belegt',
    'ready_to_scale': 'Bereit, Ihr Portfolio zu verwalten?',
    'ready_to_scale_subtitle': 'Zugang zu wichtigen Tools für Ihre Immobilien',
    'failed_to_load_dashboard_data': 'Dashboard-Daten konnten nicht geladen werden',
    'failed_to_download_statement': 'Auszug konnte nicht heruntergeladen werden',
    'owner_messages_title': 'Nachrichten',
    'owner_messages_subtitle': 'Direktkommunikation mit der Hausverwaltung',
    'my_properties': 'Meine Immobilien',
    'my_properties_subtitle': 'Alle Wohnungen und Einheiten Ihres Portfolios anzeigen.',
    'portfolio_empty': 'Keine Immobilien gefunden',
    'portfolio_empty_subtitle': 'Ihrem Portfolio wurden noch keine Wohnungen zugewiesen. Wenden Sie sich an Ihren Verwalter.',
    'floor_prefix': 'Stockwerk',
    'sqm': 'qm',
    'current_rent': 'Aktuelle Miete',
    'per_month_short': '/Mon.',
    'failed_to_load_properties': 'Immobilien konnten nicht geladen werden',
    'maintenance_approvals': 'Wartungsgenehmigungen',
    'maintenance_approvals_subtitle': 'Wartungsanfragen von Mietern prüfen und genehmigen oder ablehnen.',
    'failed_to_load_maintenance': 'Wartungsanfragen konnten nicht geladen werden',
    'request_status_updated': 'Anfragestatus erfolgreich aktualisiert',
    'failed_to_update_request': 'Wartungsanfrage konnte nicht aktualisiert werden',
    'pending_approval': 'Ausstehende Genehmigung',
    'approved_in_progress': 'Genehmigt / In Bearbeitung',
    'rejected_cancelled': 'Abgelehnt / Abgebrochen',
    'above_threshold': 'Über Schwellenwert (${{amount}})',
    'no_maintenance_requests': 'Keine Wartungsanfragen',
    'no_maintenance_subtitle': 'Wartungsanfragen von Mietern, die Ihre Genehmigung benötigen, erscheinen hier.',
    'financial_overview': 'Finanzübersicht',
    'financial_subtitle': 'Verfolgen Sie die Einnahmen aus Ihren Mietern über alle Immobilien.',
    'no_financial_data': 'Keine Finanzdaten',
    'no_payments_message': 'Für Ihr Portfolio sind derzeit keine Zahlungen erfasst.',
    'recent_payments': 'Letzte Zahlungen',
    'property_tenant': 'Immobilie / Mieter',
    'gross_amount': 'Bruttobetrag',
    'commission': 'Provision',
    'net_amount': 'Nettobetrag',
    'overdue_payments': 'Überfällige Zahlungen',
    'failed_to_load_financials': 'Finanzdaten konnten nicht geladen werden',
    'statement_downloaded': 'Auszug für {{month}} {{year}} heruntergeladen',
    'management_commission': 'Verwaltungsprovision',
    'unit_display': 'Einheit {{number}}',
    'since': 'Seit',
    'amount_owed': 'Geschuldeter Betrag',
    'financial_ledger': 'Finanzbuch',
    'ledger_subtitle': 'Alle Ratenzahlungen über Ihre Eigentumsverträge.',
    'total_outstanding': 'Gesamtausstehend',
    'installment': 'Rate',
    'due_date': 'Fälligkeitsdatum',
    'action': 'Aktion',
    'partial': 'Teilweise',
    'owner_contract': 'Eigentümervertrag',
    'pay_amount': '{{amount}} zahlen',
    'settled': 'Beglichen',
    'no_installments': 'Keine Raten gefunden.',
    'failed_to_load_installments': 'Raten konnten nicht geladen werden',
    'payment_success_msg': 'Zahlung erfolgreich! Vielen Dank.',
    'payment_canceled_msg': 'Zahlung abgebrochen.',
    'error_connecting_payment': 'Fehler beim Verbinden mit dem Zahlungssystem',
    'owner_service_charges': 'Nebenkosten',
    'owner_service_charges_subtitle': 'Nebenkosten für Ihre Immobilien anzeigen und bezahlen.',
    'owner_service_info': 'Nebenkosten werden von der Hausverwaltung berechnet. Bitte zahlen Sie offene Beträge zeitnah, um Serviceunterbrechungen zu vermeiden.',
    'outstanding_balance': 'Ausstehender Saldo',
    'service_charge_paid': 'Nebenkosten erfolgreich bezahlt!',
    'paid_on': 'Bezahlt am {{date}}',
    'unpaid': 'Unbezahlt',
    'my_agreements': 'Meine Verträge',
    'agreements_subtitle': 'Prüfen und unterzeichnen Sie Ihre Immobilienverwaltungsverträge.',
    'no_active_agreements': 'Keine Verträge gefunden',
    'no_contracts_message': 'Sie haben derzeit keine gespeicherten Verträge. Wenden Sie sich an Ihren Verwalter.',
    'management_agreement': 'Verwaltungsvertrag',
    'total_value': 'Gesamtwert',
    'remaining': 'Verbleibend',
    'failed_to_load_agreements': 'Verträge konnten nicht geladen werden',
    'rent': 'Miete',
    'download_pdf': 'PDF herunterladen',
    'generating': 'Wird generiert…',
    'announcements_manager': 'Ankündigungen',
    'announcements_manager_subtitle': 'Ankündigungen für Mieter, Eigentümer oder Gebäude veröffentlichen und verwalten.',
    'new_announcement': 'Neue Ankündigung',
    'publish_announcement': 'Veröffentlichen',
    'publishing': 'Wird veröffentlicht…',
    'all_announcements': 'Alle Ankündigungen',
    'announcement_created': 'Ankündigung erfolgreich veröffentlicht!',
    'announcement_create_failed': 'Veröffentlichung fehlgeschlagen.',
    'announcement_deleted': 'Ankündigung gelöscht.',
    'announcement_delete_failed': 'Löschen fehlgeschlagen.',
    'announcement_delete_confirm': 'Diese Ankündigung löschen? Dies kann nicht rückgängig gemacht werden.',
    'announcement_fields_required': 'Titel und Inhalt sind erforderlich.',
    'announcement_building_required': 'Bitte wählen Sie ein Gebäude aus.',
    'announcement_title_placeholder': 'z.B. Geplante Wasserwartung am Montag',
    'announcement_content_placeholder': 'Geben Sie hier Ihre Nachricht ein…',
    'target_audience': 'Zielgruppe',
    'audience_all': 'Alle',
    'audience_tenants': 'Nur Mieter',
    'audience_owners': 'Nur Eigentümer',
    'audience_building': 'Bestimmtes Gebäude',
    'select_building': 'Gebäude auswählen',
    'select_building_placeholder': '— Gebäude wählen —',
    'no_announcements_yet': 'Noch keine Ankündigungen',
    'no_announcements_yet_subtitle': 'Klicken Sie auf „Neue Ankündigung", um Ihre erste Nachricht zu senden.',
    'announcements_owner_subtitle': 'Lesen Sie die neuesten Nachrichten und Updates von Ihrem Immobilienverwalter.',
    'announcements_check_back': 'Schauen Sie später für Neuigkeiten und Updates Ihres Immobilienverwalters vorbei.',
    'posted_by': 'Gepostet von {{name}}',

    // ── Verwaltungsgebührenbericht ─────────────────────────────────────────────
    'management_fee_report': 'Verwaltungsgebührenbericht',
    'management_fee_report_subtitle': 'Verfolgung der Einzahlung von Eigentümer-Raten & Fälligkeitsanalyse',
    'ledger_activity_report': 'Hauptbuch-Aktivitätsbericht',
    'ledger_activity_report_subtitle': 'Alle Mieter-Hauptbucheinträge — Belastungen, Zahlungen, Verzugsgebühren, Gutschriften & Kautionen',
    'ledger_type_charge':   'Belastung',
    'ledger_type_late_fee': 'Verzugsgebühr',
    'ledger_type_deposit':  'Kaution',
    'ledger_type_payment':  'Zahlung',
    'ledger_type_credit':   'Gutschrift',
    'ledger_net_balance':   'Ausstehend',
    'feature_locked': 'Funktion gesperrt',
    'mgmt_fee_analytics_required': 'Verwaltungsgebührenberichte erfordern den Analytics-Plan.',
    'upgrade': 'Upgraden',
    'year': 'Jahr',
    'month': 'Monat',
    'all_months': 'Alle Monate',
    'all_owners': 'Alle Eigentümer',
    'all_statuses': 'Alle Status',
    'status_paid': 'Bezahlt',
    'status_pending_upcoming': 'Ausstehend (bevorstehend)',
    'status_overdue': 'Überfällig',
    'status_partial': 'Teilweise',
    'status_cancelled_label': 'Storniert',
    'clear_filters': 'Filter löschen',
    'print_pdf': 'Drucken / PDF',
    'export_csv': 'CSV exportieren',
    'exporting': 'Exportieren…',
    'total_expected': 'Gesamt erwartet',
    'total_collected': 'Gesamt eingezogen',
    'overdue_balance': 'Überfälliger Saldo',
    'collection_rate': 'Einzugsquote',
    'n_installments': '{{count}} Raten',
    'n_paid': '{{count}} bezahlt',
    'n_overdue_installments': '{{count}} überfällige Raten',
    'n_upcoming': '{{count}} bevorstehend',
    'monthly_breakdown': 'Monatliche Aufschlüsselung — {{year}}',
    'monthly_breakdown_filtered': 'Monatliche Aufschlüsselung — {{year}} (gefiltert auf {{month}})',
    'chart_expected': 'Erwartet',
    'chart_collected': 'Eingezogen',
    'chart_overdue': 'Überfällig',
    'no_installment_data_year': 'Keine Ratendaten für {{year}}',
    'tooltip_expected': 'Erwartet:',
    'tooltip_collected': 'Eingezogen:',
    'tooltip_overdue': 'Überfällig:',
    'all_installments': 'Alle Raten',
    'n_records': '{{count}} Datensatz',
    'n_records_plural': '{{count}} Datensätze',
    'page_of': 'Seite {{page}}/{{total}}',
    'no_installments_found': 'Keine Raten gefunden',
    'try_adjusting_filters': 'Versuchen Sie, Ihre Filter anzupassen.',
    'col_owner': 'Eigentümer',
    'col_apt': 'Whg.',
    'col_building': 'Gebäude',
    'col_due_date': 'Fälligkeitsdatum',
    'col_amount': 'Betrag',
    'col_paid': 'Bezahlt',
    'col_balance': 'Saldo',
    'col_status': 'Status',
    'col_days_late': 'Tage verspätet',
    'totals_all_pages': 'Gesamt (alle Seiten):',
    'previous': '← Zurück',
    'next': 'Weiter →',
    'page_x_of_y': 'Seite {{page}} von {{total}} ({{count}} gesamt)',
    'overdue_aging_title': 'Überfällige Raten — Fälligkeitsanalyse',
    'col_aging': 'Alterung',
    'all_installments_up_to_date': 'Alle Raten sind aktuell!',
    'no_overdue_found': 'Keine überfälligen Verwaltungsgebührenraten gefunden.',
    'total_overdue': 'Gesamt überfällig:',
    'n_days': '{{count}} Tage',
    'aging_1_30': '1–30 Tage',
    'aging_31_60': '31–60 Tage',
    'aging_61_90': '61–90 Tage',
    'aging_90_plus': '90+ Tage',
    'badge_paid': 'Bezahlt',
    'badge_partial': 'Teilweise',
    'badge_pending': 'Ausstehend',
    'badge_overdue': 'Überfällig',
    'badge_cancelled': 'Storniert',
    'failed_to_load_mgmt_fee_report': 'Verwaltungsgebührenbericht konnte nicht geladen werden',
    'export_failed': 'Export fehlgeschlagen',
    'export_downloaded_label': 'Heruntergeladen: {{label}}',

    // Report Templates
    'report_templates': 'Berichtsvorlagen',
    'report_templates_subtitle': 'Erstellen und verwalten Sie wiederverwendbare Berichtskonfigurationen',
    'create_template': 'Neue Vorlage',
    'create_first_template': 'Erste Vorlage erstellen',
    'template_name': 'Vorlagenname',
    'template_description': 'Beschreibung',
    'template_config': 'Konfiguration (JSON)',
    'no_templates': 'Keine Berichtsvorlagen',
    'no_templates_message': 'Speichern Sie Ihre häufig verwendeten Berichtskonfigurationen als wiederverwendbare Vorlagen.',
    'template_created': 'Vorlage erfolgreich erstellt',
    'template_updated': 'Vorlage erfolgreich aktualisiert',
    'template_deleted': 'Vorlage gelöscht',
    'delete_template_title': 'Vorlage löschen',
    'delete_template_message': 'Sind Sie sicher, dass Sie "{{name}}" löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',




    // Email Template Form
    'et_new_title': 'Neue E-Mail-Vorlage',
    'et_edit_title': 'E-Mail-Vorlage bearbeiten',
    'et_basic_info': 'Grundlegende Informationen',
    'et_template_name': 'Vorlagenname *',
    'et_template_name_placeholder': 'z.B. Monatliche Mieterinnerung',
    'et_trigger_event': 'Auslöseereignis',
    'et_description': 'Beschreibung',
    'et_description_placeholder': 'Optionale interne Notiz',
    'et_subject_line': 'Betreffzeile *',
    'et_subject_placeholder': 'z.B. Ihre Miete von ${{rent_amount}} ist fällig am {{due_date}}',
    'et_html_body': 'HTML-Inhalt',
    'et_editor': 'Editor',
    'et_preview': 'Vorschau',
    'et_quick_insert': 'Variablen einfügen',
    'et_update_btn': 'Vorlage aktualisieren',
    'et_create_btn': 'Vorlage erstellen',
    'et_created': 'Vorlage erstellt',
    'et_updated': 'Vorlage aktualisiert',
    'et_failed_load': 'Vorlage konnte nicht geladen werden',
    'et_save_failed': 'Speichern fehlgeschlagen',
    'et_fields_required': 'Name, Betreff und Inhalt sind erforderlich',
    'issue_utility_bill': 'Nebenkostenabrechnung erstellen',
    'tenant_billing_assignment': 'Mieterzuordnung und Abrechnung',
    'select_tenant': 'Mieter auswählen',
    'search_tenant_placeholder': 'Nach Name oder Wohnungsnummer suchen...',
    'utility_details': 'Nebenkostendetails',
    'period_month': 'Monat',
    'period_year': 'Jahr',
    'due_date': 'Fälligkeitsdatum',
    'posting_options': 'Buchungsoptionen',
    'charge_immediately': 'Sofort im Hauptbuch belasten',
    'charge_immediately_desc_on': 'Der Betrag wird sofort nach dem Speichern auf den Mietersaldo gebucht.',
    'charge_immediately_desc_off': 'Die Rechnung wird als "Ausstehend" gespeichert und muss später manuell gebucht werden.',
    'processing': 'Verarbeitung...',
    'issue_and_charge': 'Erstellen und Buchen',
    'issue_bill': 'Rechnung erstellen',
    'meter_identity_provider': 'Zähleridentität und Anbieter',
    'account_number': 'Kontonummer',
    'meter_number': 'Zählernummer',
    'shared_meter_rubs': 'Gemeinsamer Zähler (RUBS-Aufteilung)',
    'pricing_unit_measurement': 'Preise und Maßeinheit',
    'rate_per_unit': 'Preis pro Einheit ($)',
    'unit_of_measure': 'Maßeinheit',
    'billing_day_monthly': 'Abrechnungstag (monatlich)',
    'internal_notes': 'Interne Notizen',

    // Utility — edit / void / mark-paid
    'edit_utility_account': 'Versorgungskonto bearbeiten',
    'void_bill': 'Rechnung stornieren',
    'void_reason': 'Grund (optional)',
    'void_reason_placeholder': 'z.B. Abrechnungsfehler, Duplikat...',
    'confirm_void_bill': 'Diese Rechnung wird storniert und kann nicht mehr berechnet werden.',
    'confirm_void_bill_sent': 'Diese Rechnung wurde bereits belastet. Ein Gutschriftseintrag wird ausgestellt, um die Belastung zu stornieren.',
    'bill_voided': 'Rechnung storniert',
    'bill_marked_paid': 'Rechnung als bezahlt markiert',
    'confirm_mark_paid': 'Diese Rechnung als bezahlt markieren (externe Zahlung)?',
    'deactivate_utility_account': 'Konto deaktivieren',
    'confirm_deactivate_utility_account': 'Sind Sie sicher, dass Sie dieses Versorgungskonto deaktivieren möchten?',
    'post_utility_charge': 'Versorgungsgebühr buchen',
    'account_updated': 'Konto erfolgreich aktualisiert',
    'utility_bill': 'Versorgungsrechnung',
    'tenant_info': 'Mieter',
    'tenant_name_5': 'Name',
    'email_15': 'E-Mail',
    'reading_history': 'Ableseverlauf',
    'usage_breakdown': 'Verbrauchsdetails',
    'previous_reading': 'Vorheriger Zählerstand',
    'current_reading': 'Aktueller Zählerstand',
    'view_account': 'Versorgungskonto anzeigen',

    // Currency
    'currency_selector_label': 'Organisationswährung',
    'currency_stripe_warning': 'Online-Zahlungen über Stripe sind für diese Währung nicht verfügbar. Mieter zahlen nur persönlich.',
    'online_payment_unavailable': 'Online-Zahlung ist für Ihre Währung nicht verfügbar. Bitte zahlen Sie persönlich.',

    // --- HIGH-QUALITY MANUAL TRANSLATIONS ---
    'total_properties': 'Gesamte Immobilien',
    'active_properties': 'Aktive Immobilien',
    'active_tenants': 'Aktive Mieter',
    'monthly_revenue': 'Monatliche Einnahmen',
    'pending_payments': 'Ausstehende Zahlungen',
    'lease_expiring_soon': 'Mietvertrag läuft bald ab',
    'payment_risk': 'Zahlungsrisiko',
    'ai_scored_late_payment': 'Wahrscheinlichkeit für späte Zahlungen (KI)',
    'high_risk': 'Hohes Risiko',
    'medium_risk': 'Mittleres Risiko',
    'low_risk': 'Geringes Risiko',
    'no_scores_yet': 'Noch keine Bewertungen. Klicken Sie auf Aktualisieren.',
    'renewal_risk': 'Erneuerungsrisiko',
    'leases_expiring_in_90_days': 'Mietverträge laufen in 90 Tagen ab',
    'exp_in_30d': 'Läuft in 30T ab',
    'exp_in_90d': 'Läuft in 90T ab',
    'no_leases_expiring_90d': 'Keine Mietverträge laufen in den nächsten 90 Tagen ab.',
    'leasing_office': 'Vermietungsbüro',
    'marketing_links': 'Marketing-Links',
    'bulk_import': 'Massenimport',
    'evictions': 'Räumungen',
    'accounting': 'Buchhaltung',
    'payments': 'Zahlungen',
    'portfolio_kpis': 'Portfolio & KPIs',
    'bulk_comms': 'Massenbenachrichtigung',
    'email_templates': 'E-Mail-Vorlagen',
    'building_view': 'Gebäudeansicht',
    'failed_to_load_logs': 'Fehler beim Laden der Protokolle',
    'export_failed': 'Export der Protokolle fehlgeschlagen',
    'all_user_activities_desc': 'Verfolgen Sie alle Systemaktionen',
    'search_logs': 'Protokolle durchsuchen...',
    'entries': 'Einträge',
    'filter_activities': 'Aktivitäten filtern',
    'action_type': 'Aktionstyp',
    'all_actions': 'Alle Aktionen',
    'entity_type': 'Entitätstyp',
    'all_types': 'Alle Typen',
    'start_date': 'Startdatum',
    'end_date': 'Enddatum',
    'reset': 'Zurücksetzen',
    'apply_filter': 'Filter anwenden',
    'time': 'Zeit',
    'user': 'Benutzer',
    'action': 'Aktion',
    'entity': 'Entität',
    'details': 'Details',
    'amount': 'Betrag',
    'no_logs_matching_search': 'Keine Protokolle stimmen mit der Suche überein.',
    'no_logs_available': 'Keine Aktivitätsprotokolle verfügbar.',
    'showing_range': 'Zeige {{start}} bis {{end}} von {{total}}',
    'previous': 'Zurück',
    'next': 'Weiter',
    'exporting': 'Exportieren...',
    'export': 'Exportieren',
    'filter': 'Filtern',
    'activity_logs': 'Aktivitätsprotokolle',
    'invitation_only_onboarding': 'Anmeldung nur auf Einladung',
    'approve_payment_msg': 'Sind Sie sicher, dass Sie diese Zahlung genehmigen möchten?',
    'reject_payment_msg': 'Bitte geben Sie einen Grund für die Ablehnung an.',
    'errors_serverError': 'Interner Serverfehler',
    'timePeriods_month': 'Monat',
    'timePeriods_quarter': 'Quartal',
    'timePeriods_year': 'Jahr',
    'common_startDate': 'Startdatum',
    'common_endDate': 'Enddatum',
    'common_type': 'Typ',
    'common_all': 'Alle',
    'common_tenant': 'Mieter',

  
  
  
    // Auto-added translations
    'leases_expiring_90d': 'Mietverträge laufen 90 Tage ab',
    'left': 'Links',
    'view_all_renewal_risks': 'Alle Verlängerungsrisiken anzeigen',
    're_run_ai_scoring': 'Führen Sie die KI-Wertung erneut aus',
    'medium': 'Mittel',
    'owed': 'Geschuldet',
    'view_all_risk_scores': 'Alle Risikobewertungen anzeigen',
    'at_12_pm': 'Um 12 Uhr',
    'unpaid_balance': 'Unbezahlter Restbetrag',
    'lease_period': 'Mietdauer',
    'view_record': 'Datensatz anzeigen',
    'apartment_created_successfully': 'Wohnung erfolgreich erstellt',
    'apartment_updated_successfully': 'Wohnung erfolgreich aktualisiert',
    'manage_your_properties': 'Verwalten Sie Ihre Immobilien',
    'filter_apartments': 'Wohnungen filtern',
    'no_matching_apartments_message': 'Keine passende Wohnungsnachricht',
    'furnished_apartment': 'Möblierte Wohnung',
    'manage': 'Verwalten',
    'delete_apartment': 'Wohnung löschen',
    'select_at_least_one_floor': 'Wählen Sie „Mindestens eine Etage“.',
    'add_at_least_one_unit_type': 'Fügen Sie mindestens einen Einheitentyp hinzu',
    'apartments_created': 'Wohnungen erstellt',
    'skipped_duplicates': 'Duplikate übersprungen',
    'apartments_created_successfully': 'Wohnungen erfolgreich erstellt',
    'error_creating_apartments': 'Fehler beim Erstellen der Apartments',
    'select_floors': 'Wählen Sie Etagen aus',
    'clear': 'Klar',
    'qty_per_floor': 'Menge pro Etage',
    'units_per_floor': 'Einheiten pro Etage',
    'select_floors_and_types': 'Wählen Sie Böden und Typen aus',
    'future_tenant_only': 'Nur für zukünftige Mieter',
    'converted': 'Konvertiert',
    'confirmed': 'Bestätigt',
    'hold': 'Halt',
    'failed_confirm_booking': 'Buchungsbestätigung fehlgeschlagen',
    'failed_cancel_booking': 'Buchung stornieren fehlgeschlagen',
    'failed_convert_tenant': 'Konvertierung des Mandanten fehlgeschlagen',
    'converted_to_tenant': 'In Mieter umgewandelt',
    'cancellation_reason': 'Stornierungsgrund',
    'hold_expired': 'Haltezeit abgelaufen',
    'cancel_booking_question': 'Frage zur Buchung stornieren',
    'yes_cancel': 'Ja Abbrechen',
    'keep_it': 'Behalte es',
    'booking_created': 'Buchung erstellt',
    'failed_save_booking': 'Buchung konnte nicht gespeichert werden',
    'building_created_successfully': 'Gebäude erfolgreich erstellt',
    'building_updated_successfully': 'Gebäude erfolgreich aktualisiert',
    'bulk_add': 'Massenhinzufügung',
    'total_buildings': 'Gesamtgebäude',
    'avg_occupancy': 'Durchschnittliche Belegung',
    'current': 'Aktuell',
    'building_has_no_apartments': 'Das Gebäude verfügt über keine Wohnungen',
    'add_apartments_hint': 'Hinweis zu Wohnungen hinzufügen',
    'due': 'Fällig',
    'description': 'Beschreibung',
    'next_7_days': 'Nächste 7 Tage',
    'next_14_days': 'Nächste 14 Tage',
    'next_30_days': 'Nächste 30 Tage',
    'view_arrow': 'Pfeil anzeigen',
    'search_unit_tenant': 'Mieter der Einheit suchen',
    'no_results_for_filters': 'Keine Ergebnisse für Filter',
    'charged': 'Aufgeladen',
    'bank': 'Bank',
    'cheque': 'Überprüfen',
    'stripe': 'Streifen',
    'failed_to_load_revenue': 'Umsatz konnte nicht geladen werden',
    'no_tenant_logs': 'Keine Mieterprotokolle',
    'payment_record_error': 'Fehler im Zahlungsdatensatz',
    'contract_not_found': 'Vertrag nicht gefunden',
    'back_to_owner': 'Zurück zum Eigentümer',
    'contract_id': 'Vertrags-ID',
    'summary_info': 'Zusammenfassende Informationen',
    'n_a': 'N. A',
    'paid_progress': 'Bezahlter Fortschritt',
    'total_installments': 'Gesamtraten',
    'paid_installments': 'Bezahlte Raten',
    'pending_installments': 'Ausstehende Raten',
    'legal_document': 'Rechtsdokument',
    'signatures': 'Unterschriften',
    'owner_signature': 'Unterschrift des Eigentümers',
    'awaiting_owner_signature': 'Warten auf die Unterschrift des Eigentümers',
    'admin_signature': 'Administratorsignatur',
    'awaiting_admin_signature': 'Warten auf die Signatur des Administrators',
    'paid_amount': 'Bezahlter Betrag',
    'save_payment': 'Zahlung speichern',
    'language': 'Sprache',
    'exportPDF': 'PDF exportieren',
    'print': 'Drucken',
    'receiptNo': 'Quittung Nr',
    'contractDetails': 'Vertragsdetails',
    'contractNo': 'Vertragsnr',
    'contractType': 'Vertragstyp',
    'startDate': 'Startdatum',
    'endDate': 'Enddatum',
    'openEnded': 'Offenes Ende',
    'financialSummary': 'Finanzielle Zusammenfassung',
    'totalValue': 'Gesamtwert',
    'totalPaid': 'Gesamtbezahlt',
    'balanceDue': 'Restbetrag fällig',
    'installmentSchedule': 'Ratenzahlungsplan',
    'dueDate': 'Fälligkeitsdatum',
    'paidAmt': 'Bezahlter Betrag',
    'paymentDate': 'Zahlungsdatum',
    'paidWatermark': 'Bezahltes Wasserzeichen',
    'paymentDetails': 'Zahlungsdetails',
    'installmentNo': 'Rate Nr',
    'amountDue': 'Fälliger Betrag',
    'amountPaid': 'Bezahlter Betrag',
    'paymentStatus': 'Zahlungsstatus',
    'paymentConfirmed': 'Zahlung bestätigt',
    'awaitingPayment': 'Warten auf Zahlung',
    'balanceRemaining': 'Verbleibendes Guthaben',
    'authorizedSig': 'Autorisierte Sig',
    'ownerSig': 'Besitzer Sig',
    'generatedBy': 'Erstellt von',
    'informationalOnly': 'Nur zur Information',
    'failed_to_load_owner_data': 'Besitzerdaten konnten nicht geladen werden',
    'sending': 'Senden',
    'payment_reminder_message': 'Zahlungserinnerungsnachricht',
    'reminder_sent_success': 'Erinnerung erfolgreich gesendet',
    'failed_to_send_reminder': 'Erinnerung konnte nicht gesendet werden',
    'owner_has_no_email': 'Der Besitzer hat keine E-Mail',
    'portal_invitation_sent_successfully': 'Portaleinladung erfolgreich gesendet',
    'failed_to_send_portal_invite': 'Portaleinladung konnte nicht gesendet werden',
    'owner_not_found': 'Besitzer nicht gefunden',
    'total_income': 'Gesamteinkommen',
    'residence': 'Wohnsitz',
    'does_not_live_on_property': 'Lebt nicht auf dem Grundstück',
    'outstanding_fees_note': 'Hinweis zu ausstehenden Gebühren',
    'pending_signature': 'Ausstehende Unterschrift',
    'fully_executed': 'Vollständig ausgeführt',
    'error_loading_financials': 'Fehler beim Laden der Finanzdaten',
    'due_soon': 'Bald fällig',
    'owner_updated_successfully': 'Besitzer erfolgreich aktualisiert',
    'invitation_sent': 'Einladung gesendet',
    'invitation_failed': 'Einladung fehlgeschlagen',
    'owner_created_successfully': 'Besitzer erfolgreich erstellt',
    'preferred_language': 'Bevorzugte Sprache',
    'english': 'Englisch',
    'arabic': 'Arabisch',
    'kurdish': 'Kurdisch',
    'drop_here': 'Kommen Sie hier vorbei',
    'failed_to_load_owners_data': 'Besitzerdaten konnten nicht geladen werden',
    'connection_error': 'Verbindungsfehler',
    'failed_to_delete_owner': 'Besitzer konnte nicht gelöscht werden',
    'failed_to_delete_owners': 'Besitzer konnten nicht gelöscht werden',
    'edit_owner': 'Besitzer bearbeiten',
    'delete_owner': 'Besitzer löschen',
    'occupied_lowercase': 'Besetzte Kleinbuchstaben',
    'confirm_bulk_delete_title': 'Bestätigen Sie das Massenlöschen des Titels',
    'refresh_owners': 'Besitzer aktualisieren',
    'delete_selected_owners': 'Ausgewählte Besitzer löschen',
    'export_to_pdf': 'Als PDF exportieren',
    'print_owners': 'Druckbesitzer',
    'min_zero': 'Min. Null',
    'count_formatted': 'Anzahl formatiert',
    'most_popular': 'Am beliebtesten',
    'trial': 'Prozess',
    'past_due': 'Überfällig',
    'canceled': 'Abgesagt',
    'invalid_plan_selected': 'Ungültiger Plan ausgewählt',
    'could_not_start_checkout': 'Der Checkout konnte nicht gestartet werden',
    'checkout_failed': 'Auschecken fehlgeschlagen',
    'could_not_open_portal': 'Das Portal konnte nicht geöffnet werden',
    'failed_to_open_portal': 'Portal konnte nicht geöffnet werden',
    'payment_approved_success': 'Zahlung erfolgreich genehmigt',
    'failed_to_approve_payment': 'Zahlung konnte nicht genehmigt werden',
    'provide_rejection_reason': 'Geben Sie den Ablehnungsgrund an',
    'payment_rejected': 'Zahlung abgelehnt',
    'failed_to_reject_payment': 'Zahlung konnte nicht abgelehnt werden',
    'stripe_connected': 'Stripe verbunden',
    'yr': 'Jahr',
    'mo': 'Mo',
    'expires': 'Läuft ab',
    'renews': 'Erneuert',
    'opening': 'Eröffnung',
    'stripe_portal_title': 'Titel des Stripe-Portals',
    'stripe_portal_desc': 'Streifenportal-Beschreibung',
    'monthly': 'Monatlich',
    'annual': 'Jährlich',
    'redirecting': 'Umleiten',
    'stripe_secure_notice': 'Stripe Secure-Hinweis',
    'failed': 'Fehlgeschlagen',
    'organization': 'Organisation',
    'approve_payment': 'Zahlung genehmigen',
    'reject_payment': 'Zahlung ablehnen',
    'errors.serverError': 'Serverfehler',
    'export_excel': 'Excel exportieren',
    'timePeriods.month': 'Monat',
    'timePeriods.quarter': 'Viertel',
    'timePeriods.year': 'Jahr',
    'common.startDate': 'Startdatum',
    'common.endDate': 'Enddatum',
    'common.type': 'Typ',
    'common.all': 'Alle',
    'common.tenant': 'Mieter',
    'common.searchTenant': 'Mieter suchen',
    'ledgerReport.netBalance': 'Nettosaldo',
    'ledgerReport.entries': 'Einträge',
    'common.noData': 'Keine Daten',
    'common.date': 'Datum',
    'common.building': 'Gebäude',
    'common.apartment': 'Wohnung',
    'common.description': 'Beschreibung',
    'common.amount': 'Betrag',
    'ledgerReport.balanceAfter': 'Balance danach',
    'ledgerReport.createdBy': 'Erstellt von',
    'common.page': 'Seite',
    'metric': 'Metrisch',
    'value': 'Wert',
    'failed_to_export': 'Exportieren fehlgeschlagen',
    'select_date_range': 'Wählen Sie Datumsbereich aus',
    'revenue_deep_dive_restricted': 'Umsatz-Deep-Dive eingeschränkt',
    'showing_building_revenue': 'Gebäudeeinnahmen anzeigen',
    'showing_owner_revenue': 'Eigentümereinnahmen anzeigen',
    'showing_monthly_revenue': 'Zeigt den monatlichen Umsatz an',
    'receiptTitle': 'Titel der Quittung',
    'receiptDate': 'Empfangsdatum',
    'residentName': 'Bewohnername',
    'servicePeriod': 'Servicezeitraum',
    'signature': 'Unterschrift',
    'responsible': 'Verantwortlich',
    'thankYou': 'Vielen Dank',
    'invalid_amount': 'Ungültiger Betrag',
    'payment_generated_successfully': 'Zahlung erfolgreich generiert',
    'failed_to_generate_payment': 'Zahlung konnte nicht generiert werden',
    'no_owner': 'Kein Eigentümer',
    'rented': 'Vermietet',
    'payer': 'Zahler',
    'failed_to_load_service_data': 'Dienstdaten konnten nicht geladen werden',
    'records': 'Aufzeichnungen',
    'no_matching_payments_found': 'Keine passenden Zahlungen gefunden',
    'paid_count': 'Zahl bezahlt',
    'unpaid_count': 'Unbezahlte Zählung',
    'no_data_to_export': 'Keine Daten zum Exportieren',
    'export_successful': 'Export erfolgreich',
    'months_with_data': 'Monate mit Daten',
    'data_refreshed_successfully': 'Daten erfolgreich aktualisiert',
    'payment_marked_as_paid': 'Zahlung erfolgreich als bezahlt markiert',
    'payment_marked_as_unpaid': 'Zahlung erfolgreich als unbezahlt markiert',
    'rented': 'Vermietet',
    'service_charge_deleted': 'Servicegebühr erfolgreich gelöscht',
    'failed_to_delete_service_charge': 'Servicegebühr konnte nicht gelöscht werden',
    'service_payment_note_default': 'Servicezahlung für {{month}} {{year}}',
    'failed_init_stripe': 'Init-Stripe fehlgeschlagen',
    'refresh_status': 'Status aktualisieren',
    'failed_to_load_user_data': 'Benutzerdaten konnten nicht geladen werden',
    'error_updating_profile': 'Fehler beim Aktualisieren des Profils',
    'error_updating_password': 'Fehler beim Aktualisieren des Passworts',
    'failed_to_load_system_data': 'Systemdaten konnten nicht geladen werden',
    'logo_upload_success': 'Logo-Upload erfolgreich',
    'error_from_server': 'Fehler vom Server',
    'error_uploading_logo': 'Fehler beim Hochladen des Logos',
    'error_updating_system_settings': 'Fehler beim Aktualisieren der Systemeinstellungen',
    'contact_email': 'Kontakt-E-Mail',
    'contact_phone': 'Kontakttelefon',
    'office_address': 'Büroadresse',
    'organization_logo': 'Organisationslogo',
    'nameLabel': 'Namensschild',
    'floorPre': 'Bodenvor',
    'aptPre': 'Apt Pre',
    'periodLabel': 'Periodenbeschriftung',
    'officeCommission': 'Bürokommission',
    'invalid_date': 'Ungültiges Datum',
    'tenant_has_no_email': 'Der Mieter hat keine E-Mail',
    'portal_invitation_failed': 'Portaleinladung fehlgeschlagen',
    'lease_extended_success': 'Erweiterter Leasing-Erfolg',
    'failed_to_extend_lease': 'Mietvertrag konnte nicht verlängert werden',
    'lease_renewed_success': 'Erneuter Erfolg beim Leasing',
    'failed_to_renew_lease': 'Mietvertrag konnte nicht verlängert werden',
    'ending_lease': 'Ende des Mietverhältnisses',
    'french': 'Französisch',
    'german': 'Deutsch',
    'italian': 'Italienisch',
    'no_additional_fees': 'Keine zusätzlichen Gebühren',
    'electronic_signature': 'Elektronische Signatur',
    'no_maintenance_requests_message': 'Keine Wartungsanforderungsnachricht',
    'add_first_request': 'Erste Anfrage hinzufügen',
    'extending': 'Erweitern',
    'renewing': 'Erneuerung',
    'tenant_updated_successfully': 'Mieter erfolgreich aktualisiert',
    'tenant_created_successfully': 'Mieter erfolgreich erstellt',
    'no_phone': 'Kein Telefon',
    'not_assigned': 'Nicht zugewiesen',
    'financial_details': 'Finanzielle Details',
    'more_info': 'Weitere Informationen',
    'apartment_specs': 'Wohnungsspezifikationen',
    'user_created_email_failed': 'Vom Benutzer erstellte E-Mail fehlgeschlagen',
    'user_created_email_failed_2': 'Vom Benutzer erstellte E-Mail fehlgeschlagen 2',
    'invitation_email_could_not_be_sent': 'Die Einladungs-E-Mail konnte nicht gesendet werden',
    'user_created_email_failed_3': 'Vom Benutzer erstellte E-Mail fehlgeschlagen 3',
    'manual_onboarding_link': 'Manueller Onboarding-Link',
    'manual_onboarding_desc': 'Manuelle Onboarding-Beschreibung',
    'link_copied_to_clipboard': 'Link in die Zwischenablage kopiert',
    'copy_link': 'Link kopieren',
    'add_another_user': 'Fügen Sie einen weiteren Benutzer hinzu',
    'invitation_only_onboarding_desc': 'Onboarding-Beschreibung nur auf Einladung',
    'hide_inactive_users': 'Inaktive Benutzer ausblenden',
    'show_inactive_users': 'Inaktive Benutzer anzeigen',
    'error_loading_users': 'Fehler beim Laden der Benutzer',
    'no_users_message': 'Keine Benutzernachricht',
    'create_first_user': 'Erstellen Sie den ersten Benutzer',
    'enable_whatsapp_notifications': 'Aktivieren Sie WhatsApp-Benachrichtigungen',
    'whatsapp_enable_desc': 'WhatsApp-Aktivierungsbeschreibung',
    'default_message_language': 'Standard-Nachrichtensprache',
    'spanish': 'Spanisch',
    'rent_reminder': 'Mieterinnerung',
    'enable_rent_reminders': 'Mieterinnerungen aktivieren',
    'rent_reminders_desc': 'Mieterinnerungen Desc',
    'enable_service_fee_reminders': 'Aktivieren Sie Servicegebührenerinnerungen',
    'service_fee_reminders_desc': 'Servicegebühren-Erinnerungen Desc',
    'owner_reminders_desc': 'Besitzererinnerungen Beschr',
    'send_payment_confirmation': 'Zahlungsbestätigung senden',
    'payment_confirmation_desc': 'Zahlungsbestätigungsbeschreibung',
    'sms_sent_to': 'SMS gesendet an',
    'sms_failed': 'SMS fehlgeschlagen',
    'request_failed': 'Anfrage fehlgeschlagen',
    'enable_sms_notifications': 'Aktivieren Sie SMS-Benachrichtigungen',
    'sms_enable_desc': 'SMS aktivieren Beschr',
    'sender': 'Absender',
    'via_twilio': 'Über Twilio',
    'send_test_sms': 'Test-SMS senden',
    'test_sms_desc': 'Test-SMS-Beschreibung',
    'send_test': 'Test senden',
    'recipient_pending': 'Empfänger ausstehend',
    'no_pending_reminders': 'Keine ausstehenden Erinnerungen',
    'no_recipients_match': 'Keine Empfängerübereinstimmung',
    'confirm_send_all': 'Bestätigen Sie „Alle senden“.',
    'failed_load_notification_settings': 'Benachrichtigungseinstellungen für fehlgeschlagenes Laden',
    'settings_save_failed': 'Speichern der Einstellungen fehlgeschlagen',
    'preview_failed': 'Vorschau fehlgeschlagen',
    'reminders_sent': 'Erinnerungen gesendet',
    'on': 'Auf',
    'off': 'Aus',
    'sms_twilio': 'SMS Twilio',
    'notification_settings': 'Benachrichtigungseinstellungen',
    'notification_settings_desc': 'Benachrichtigungseinstellungen Beschr',
    'preview_send': 'Vorschau senden',
    'save_settings': 'Einstellungen speichern',
    'loading_units': 'Ladeeinheiten',
    'listed_rent': 'Gelistete Miete',
    'portfolio_occupancy': 'Belegung des Portfolios',
    'avg_renewal_increase': 'Durchschnittliche Erneuerungserhöhung',
    'title': 'Titel',
    'content': 'Inhalt',
    'marketing_links_desc': 'Marketing-Links Desc',
    'days': 'Tage',
    'download_failed': 'Download fehlgeschlagen',
    'run_report': 'Bericht ausführen',
    'downloading': 'Herunterladen',
    'total_ar': 'Gesamtar',
    'total_balance': 'Gesamtsaldo',
    'no_outstanding_balances_found': 'Keine ausstehenden Beträge gefunden',
    'totals': 'Summen',
    'subject_body_required': 'Betrefftext erforderlich',
    'no_active_tenants': 'Keine aktiven Mieter',
    'confirm_send_bulk': 'Bestätigen Sie „Massenversand“.',
    'message_sent_to_tenants': 'Nachricht an Mieter gesendet',
    'bulk_communications': 'Massenkommunikation',
    'message_sent_successfully': 'Nachricht erfolgreich gesendet',
    'in_app_announcement': 'In der App-Ankündigung',
    'dismiss': 'Entlassen',
    'target_building': 'Zielaufbau',
    'all_buildings_count': 'Alle Gebäude zählen',
    'compose_message': 'Nachricht verfassen',
    'subject': 'Betreff',
    'message_body': 'Nachrichtentext',
    'markdown_hint': 'Markdown-Hinweis',
    'characters': 'Charaktere',
    'delivery_channels': 'Lieferkanäle',
    'email_blast': 'E-Mail-Explosion',
    'send_to_tenants': 'An Mieter senden',
    'bulk_guidelines': 'Bulk-Richtlinien',
    'in_app_announcements': 'In App-Ankündigungen',
    'in_app_desc': 'In der App-Beschreibung',
    'email_blasts': 'E-Mail-Blasts',
    'email_blast_desc': 'E-Mail-Blast-Beschreibung',
    'send_immediate_desc': 'Sofortbeschreibung senden',
    'professional_desc': 'Professionelle Beschreibung',
    'owner_balances': 'Eigentümersalden',
    'deselect_all': 'Alle abwählen',
    'select_all': 'Wählen Sie „Alle“ aus',
    'notes_optional': 'Notizen optional',
    'confirm_bulk_payout_title': 'Massenauszahlung bestätigen',
    'error_loading_churn_data': 'Fehler beim Laden der Abwanderungsdaten',
    'running_scoring': 'Laufwertung',
    'scored_tenants': 'Bewertete Mieter',
    'scoring_failed': 'Wertung fehlgeschlagen',
    'vendor_dashboard_subtitle': 'Untertitel des Anbieter-Dashboards',
    'view_your_work_orders': 'Sehen Sie sich Ihre Arbeitsaufträge an',
    'confirm_replace_content': 'Bestätigen Sie „Inhalt ersetzen“.',
    'applied_template': 'Angewandte Vorlage',
    'templates': 'Vorlagen',
    'editor': 'Herausgeber',
    'desktop': 'Desktop',
    'mobile': 'Mobil',
    'realistic_sample_data': 'Realistische Beispieldaten',
    'template_logic': 'Vorlagenlogik',
    'event_trigger_desc': 'Ereignisauslöser-Beschreibung',
    'admin_only': 'Nur Administrator',
    'click_to_insert': 'Klicken Sie auf „Einfügen“.',
    'body': 'Körper',
    'template_deactivated': 'Vorlage deaktiviert',
    'failed_to_deactivate': 'Deaktivierung fehlgeschlagen',
    'enter_test_email': 'Geben Sie die Test-E-Mail ein',
    'test_email_sent_to': 'Test-E-Mail gesendet an',
    'failed_to_send_test': 'Test konnte nicht gesendet werden',
    'active_templates_count': 'Anzahl der aktiven Vorlagen',
    'send_test_email': 'Test-E-Mail senden',
    'save_failed': 'Speichern fehlgeschlagen',
    'description_required': 'Beschreibung Erforderlich',
    'post_failed': 'Beitrag fehlgeschlagen',
    'code': 'Code',
    'create_account': 'Konto erstellen',
    'apply': 'Bewerben',
    'account': 'Konto',
    'debit': 'Lastschrift',
    'credit': 'Kredit',
    'lines': 'Linien',
    'hide': 'Verstecken',
    'reverse': 'Umgekehrt',
    'run': 'Lauf',
    'total_debits': 'Gesamtbelastungen',
    'total_credits': 'Gesamt-Credits',
    'journal_entry': 'Tagebucheintrag',
    'building_id_label': 'Gebäude-ID-Etikett',
    'units_count': 'Anzahl der Einheiten',
    'enable_in_settings': 'In den Einstellungen aktivieren',
    'unit_label': 'Einheitenbezeichnung',
    'no_messages_yet': 'Noch keine Nachrichten',
    'failed_to_load_notification_log': 'Das Laden des Benachrichtigungsprotokolls ist fehlgeschlagen',
    'no_notifications_found': 'Keine Benachrichtigungen gefunden',
    'channel': 'Kanal',
    'recipient': 'Empfänger',
    'flat_amount': 'Pauschalbetrag',
    'org_settings_desc': 'Org.-Einstellungen Beschr',
    'late_fee_configuration': 'Konfiguration der Verspätungsgebühr',
    'enabled': 'Aktiviert',
    'disabled': 'Deaktiviert',
    'legal_note_late_fees': 'Rechtliche Hinweise zu Verspätungsgebühren',
    'grace_period_days': 'Tage der Schonfrist',
    'fee_type': 'Gebührenart',
    'percent_of_rent': 'Prozent der Miete',
    'late_fee_summary': 'Zusammenfassung der Verspätungsgebühren',
    'applied_after': 'Danach angewendet',
    'discount_rent': 'Rabattmiete',
    'lease_start': 'Mietbeginn',
    'lease_end': 'Ende des Mietverhältnisses',
    'next_bill': 'Nächste Rechnung',
    'no_units_found': 'Keine Einheiten gefunden',
    'csv_download_failed': 'CSV-Download fehlgeschlagen',
    'all_1099_downloaded': 'Alle 1099 heruntergeladen',
    'no_reportable_owners': 'Keine meldepflichtigen Eigentümer',
    'pdf_download_failed': 'PDF-Download fehlgeschlagen',
    'pdf_generation_failed': 'PDF-Generierung fehlgeschlagen',
    'generating_pdfs': 'Generieren von PDFs',
    'download_all_pdfs': 'Laden Sie alle PDFs herunter',
    'important': 'Wichtig',
    'irs_1099_disclaimer': 'Irs 1099 Haftungsausschluss',
    'owner_payment_summary': 'Zahlungsübersicht des Eigentümers',
    'irs_threshold': 'IRS-Schwelle',
    'total_paid': 'Gesamtbezahlt',
    'form': 'Formular',
    'file_form': 'Dateiformular',
    'no_owner_payments_found': 'Keine Eigentümerzahlungen gefunden',
    'no_deposits_found': 'Keine Einzahlungen gefunden',
    'deposit_amount': 'Einzahlungsbetrag',
    'deductions': 'Abzüge',
    'error_loading_showing': 'Fehler beim Laden der Anzeige',
    'required_fields_error': 'Fehler bei den erforderlichen Feldern',
    'showing_updated': 'Aktualisiert angezeigt',
    'showing_scheduled': 'Geplant angezeigt',
    'time_conflict_error': 'Zeitkonfliktfehler',
    'choose_unit': 'Wählen Sie Einheit',
    'agent_name_placeholder': 'Platzhalter für Agentennamen',
    'schedule': 'Zeitplan',
    'error_loading_showings': 'Fehler beim Laden der Vorführungen',
    'marked_as': 'Markiert als',
    'update_failed': 'Aktualisierung fehlgeschlagen',
    'delete_failed': 'Löschen fehlgeschlagen',
    'mark_completed': 'Als abgeschlossen markieren',
    'mark_no_show': 'Als Nichterscheinen markieren',
    'confirm_delete': 'Bestätigen Sie Löschen',
    'confirm_delete_showing': 'Bestätigen Sie „Anzeige löschen“.',
    'error_loading_surveys': 'Fehler beim Laden der Umfragen',
    'from_responses': 'Aus Antworten',
    'no_data_yet': 'Noch keine Daten',
    'utility_type_required': 'Dienstprogrammtyp erforderlich',
    'failed_to_create_account': 'Konto konnte nicht erstellt werden',
    'select_tenant_error': 'Wählen Sie „Mandantenfehler“ aus',
    'please_fix_errors': 'Bitte beheben Sie Fehler',
    'bill_issued_successfully': 'Rechnung erfolgreich ausgestellt',
    'failed_to_issue_bill': 'Rechnung konnte nicht ausgestellt werden',
    'download_csv': 'Csv herunterladen',
    'vendor_1099_disclaimer': 'Haftungsausschluss des Anbieters 1099',
    'vendor': 'Anbieter',
    'first_payment': 'Erste Zahlung',
    'last_payment': 'Letzte Zahlung',
    'no_vendor_payments_recorded': 'Keine Lieferantenzahlungen erfasst',
    'ok_200': 'Okay, 200',
    'failed_load_webhooks': 'Webhooks konnten nicht geladen werden',
    'failed_load_deliveries': 'Fehlgeschlagene Ladungslieferungen',
    'failed_update': 'Fehlgeschlagenes Update',
    'delete_webhook_confirm': 'Webhook löschen Bestätigen',
    'failed_delete': 'Fehler beim Löschen',
    'rotate_secret_confirm': 'Geheime Bestätigung drehen',
    'secret_rotated': 'Geheimnis gedreht',
    'failed_rotate': 'Fehlgeschlagene Drehung',
    'copied_to_clipboard': 'In die Zwischenablage kopiert',
    'add_endpoint': 'Endpunkt hinzufügen',
    'no_webhooks_yet': 'Noch keine Webhooks',
    'no_webhooks_desc': 'Keine Webhooks Beschreibung',
    'failures': 'Misserfolge',
    'disable': 'Deaktivieren',
    'enable': 'Aktivieren',
    'rotate_secret': 'Geheimnis drehen',
    'no_deliveries_yet': 'Noch keine Lieferungen',
    'event': 'Veranstaltung',
    'http': 'HTTP',
    'account_deactivated': 'Konto deaktiviert',
    'server_no_response': 'Server keine Antwort',
    'logging_in': 'Anmelden',
    'company_name_required': 'Firmenname erforderlich',
    'registration_failed': 'Registrierung fehlgeschlagen',
    'enter_company_name': 'Geben Sie den Firmennamen ein',
    'fully_signed_active': 'Vollständig signiert, aktiv',
    'pending_owner_signature': 'Ausstehende Unterschrift des Eigentümers',
    'pending_admin_signature': 'Ausstehende Administratorsignatur',
    'terminated': 'Beendet',
    'back_to_contracts': 'Zurück zu Verträgen',
    'contract_terms': 'Vertragsbedingungen',
    'payment_schedule': 'Zahlungsplan',
    'no_installments_defined': 'Keine Ratenzahlungen definiert',
    'signed_by': 'Signiert von',
    'awaiting_admin_review': 'Warten auf die Überprüfung durch den Administrator',
    'sign_contract': 'Vertrag unterzeichnen',
    'past': 'Vergangenheit',
    'tenant_signin_success': 'Erfolgreiche Mieteranmeldung',

    // Auto-added mass translations from ESLint Codemod
    '10': '10 /',
    '12': '/ 12',
    '16': '−16 %',
    '25': '25 /',
    '50': '50 /',
    '100': '100 /',
    '600': ': 600 $',
    'ai_assistant_pro_only': 'KI-Assistent – nur Pro',
    'ask_questions_about_your_portfolio_in_pl': 'Stellen Sie Fragen zu Ihrem Portfolio in einfachem Englisch. Erhalten Sie sofortige Antworten zu Einnahmen, überfälligen Zahlungen, offenen Stellen und mehr.',
    'upgrade_to_pro': 'Upgrade auf Pro',
    'here_s_what_s_happening_across_your_port': 'Hier erfahren Sie, was heute in Ihrem Portfolio passiert.',
    'portfolio_risk': 'Portfoliorisiko',
    'pro_only': 'Nur Pro',
    'pending_collections': 'Ausstehende Sammlungen',
    'ask_ai_assistant': 'Fragen Sie AI Assistant',
    'unlock_ai_assistant_upgrade_to_pro': 'AI Assistant freischalten – Upgrade auf Pro',
    'download': 'Herunterladen',
    'd': 'd',
    'view_details_1': 'Details anzeigen',
    'export_data': 'Daten exportieren',
    'refresh_data': 'Daten aktualisieren',
    'property_pulse': 'Immobilienimpuls',
    'cash_flow_analysis_for_the_current_fisca': 'Cashflow-Analyse für das laufende Geschäftsjahr',
    'yearly_report': 'Jahresbericht',
    'analytics_pro_required': 'Analytics Pro erforderlich',
    'unlock_deep_financial_insights_and_custo': 'Erhalten Sie umfassende Finanzeinblicke und individuelle Prognoseberichte.',
    'upgrade_now': 'Jetzt upgraden',
    'items_requiring_immediate_follow_up': 'Punkte, die eine sofortige Nachbearbeitung erfordern',
    'activity_log': 'Aktivitätsprotokoll',
    'view_history': 'Verlauf anzeigen',
    'no_recent_logs_found': 'Keine aktuellen Protokolle gefunden',
    'active_issues': 'Aktive Probleme',
    'pro': 'Profi',
    'pro_1': 'Profi',
    'sell_unit': 'Einheit verkaufen',
    'floor_1': 'Boden',
    'size_1': 'Größe',
    'm': 'm²',
    'amenities': 'Ausstattung',
    'last_updated_today': 'Letzte Aktualisierung: Heute',
    'back_to_apartment': 'Zurück zur Wohnung',
    'sell_unit_1': 'Einheit verkaufen',
    'floor_2': 'Boden',
    'select_buyer': 'Wählen Sie Käufer aus',
    'existing_owner': 'Vorhandener Eigentümer',
    'new_buyer': 'Neuer Käufer',
    'no_owners_found_switch_to_new_buyer_to_c': 'Keine Eigentümer gefunden – wechseln Sie zu „Neuer Käufer“, um einen zu erstellen',
    'edit_1': 'Bearbeiten',
    'the_buyer_will_be_created_as_an_owner_an': 'Der Käufer wird als Eigentümer angelegt und automatisch mit diesem Verkauf verknüpft.',
    'sale_terms': 'Verkaufsbedingungen',
    'total_sale_price': 'Gesamtverkaufspreis *',
    'down_payment': 'Anzahlung',
    'annual_interest_rate': 'Jährlicher Zinssatz (%)',
    'term_months': 'Laufzeit (Monate) *',
    'yrs': 'Jahre)',
    'sale_start_date': 'Verkauf/Startdatum *',
    'quick_preview': 'Schnellvorschau',
    'principal': 'Schulleiter',
    'down_payment_1': 'Anzahlung',
    'term': 'Begriff',
    'months_1': 'Monate',
    'amortization_schedule': 'Tilgungsplan',
    'confirm_sale': 'Verkauf bestätigen',
    'buyer': 'Käufer',
    'floor_3': '— Boden',
    'financial_terms': 'Finanzielle Bedingungen',
    'draft_sale_contract': 'Entwurf eines Kaufvertrages',
    'will_be_created_the_apartment_will_be_ma': 'wird erstellt. Die Wohnung wird als gekennzeichnet',
    'sold': 'Verkauft',
    'only_after_both_you_and_the_buyer_digita': 'erst nachdem sowohl Sie als auch der Käufer den Vertrag digital unterzeichnet haben.',
    'sale_finalized': 'Verkauf abgeschlossen!',
    'the_sale_contract_for_unit': 'Der Kaufvertrag für die Einheit',
    'has_been_created_use_the_links_below_to': 'wurde erstellt. Verwenden Sie die folgenden Links, um den Käufer einzubinden.',
    'public_sign_link': 'Link zu öffentlichen Schildern',
    'p_sign_owner': '/p/sign/owner/',
    'portal_invite_link': 'Portal-Einladungslink',
    'portal_setup_password_type_owner_id': '/portal/setup-password?type=owner&id=',
    'email_1': '&email=',
    'token': '&token=',
    'view_owner': 'Eigentümer anzeigen',
    'manage_contract': 'Vertrag verwalten',
    '0_10': '(0–10,',
    'm_1': 'm²',
    'm_2': 'm²',
    'm_3': 'm²',
    'm_4': 'm²',
    'empty_key': '✕',
    'this_apartment_already_has': 'Diese Wohnung hat bereits',
    'active_booking_s_for_these_dates': 'aktive Buchung(en) für diese Daten.',
    'levels': 'Ebenen',
    'cap': 'Kappe',
    'no_inventory_data': 'Keine Bestandsdaten',
    'init_units': 'Init-Einheiten',
    'm_5': 'm²',
    'm_6': 'm²',
    'supports_markdown_placeholders_e_g': 'Unterstützt MarkDown und Platzhalter, z.B.',
    'empty_key_1': '✓',
    'trial_ends_in': 'Der Prozess endet in',
    'days_subscribe': 'Tage - Abonnieren',
    'new_lease_agreement': 'Neuer Mietvertrag',
    'tenant_unit_assignment': 'Mieter- und Einheitenzuweisung',
    'please_select_a_building_first': 'Bitte wählen Sie zunächst ein Gebäude aus',
    'lease_terms_duration': 'Mietbedingungen und -dauer',
    'lease_type': 'Leasingtyp',
    'fixed_term': 'Feste Laufzeit',
    'month_to_month': 'Von Monat zu Monat',
    'end_date_optional': 'Enddatum (optional)',
    'financial_obligations': 'Finanzielle Verpflichtungen',
    'empty_key_2': ') *',
    'notes_special_provisions': 'Hinweise/Sonderbestimmungen',
    'empty_key_3': ': #',
    'send_for_signature': 'Zur Unterschrift senden',
    'copy_sign_link': 'Zeichenlink kopieren',
    'download_contract_pdf': 'Vertrags-PDF herunterladen',
    'contract_summary': 'Vertragszusammenfassung',
    'generated_from_template': 'Aus Vorlage generiert:',
    'digitally_executed': 'Digital ausgeführt',
    'electronic_signatures': 'Elektronische Signaturen',
    'management_office': 'Verwaltungsbüro',
    'authorized_signature': 'Autorisierte Unterschrift',
    'owner_landlord': 'Eigentümer/Vermieter',
    'email_2': 'E-Mail:',
    'signed': 'Unterzeichnet:',
    'ip': 'IP:',
    'reason_for_voiding': 'Grund für die Stornierung',
    'building_agreement_for': 'Bauvertrag für',
    'contract_builder_rules': 'Regeln für Vertragsersteller',
    'select_contract_template': 'Wählen Sie Vertragsvorlage aus',
    'no_template_manual_mode': 'Keine Vorlage (manueller Modus)',
    'template_dynamic_variables': 'Dynamische Vorlagenvariablen',
    'owner_default_commission': 'Standardprovision des Eigentümers:',
    'maintenance_threshold': 'Wartungsschwelle:',
    'unit_1': 'Einheit',
    'sale_unit_purchase': 'Verkauf / Einzelkauf',
    'fixed_maintenance_contract': 'Fester Wartungsvertrag',
    'lease_agreement': 'Mietvertrag',
    'start_date_1': 'Startdatum',
    'auto_generate_quarterly': 'Vierteljährlich automatisch generieren',
    'add_custom_installment': 'Benutzerdefinierte Rate hinzufügen',
    'plan_total': 'Gesamtplan',
    'agreement': 'Vereinbarung',
    'copy_portal_link': 'Portal-Link kopieren',
    'ledger': 'Hauptbuch',
    'empty_key_4': ') â†’',
    'owner_documents': 'Eigentümerdokumente',
    'add_document': 'Dokument hinzufügen',
    'name_1': 'Name *',
    'tax': 'Steuer',
    'file_url': 'Datei-URL *',
    'cancel_1': 'Abbrechen',
    'no_documents_yet': 'Noch keine Dokumente',
    '30_days': '(30 Tage)',
    'view_1': 'Ansicht',
    'future_scheduled_installments': 'zukünftige geplante Raten',
    'unit_2': ', Einheit',
    'no_investment_data_available_add_purchas': 'Keine Investitionsdaten verfügbar. Fügen Sie Kaufpreis und aktuellen Wert zu Wohnungen hinzu, um Kennzahlen anzuzeigen.',
    'click_the_edit_icon_on_any_unit_to_updat': 'Klicken Sie auf das Bearbeitungssymbol einer beliebigen Einheit, um deren aktuellen Marktwert oder Kaufpreis zu aktualisieren.',
    'unit_3': 'Einheit',
    'unit_mo': '/Einheit/Mo',
    'save_16_billed_annually': 'Sparen Sie 16 % · Jährliche Abrechnung',
    'reason_for_rejection': 'Grund für die Ablehnung',
    'of_1': 'von',
    'error_loading_receipt': 'Fehler beim Laden der Quittung',
    'go_back': 'Geh zurück',
    'receipt_not_found': 'Quittung nicht gefunden',
    'the_requested_payment_receipt_could_not': 'Der angeforderte Zahlungsbeleg konnte nicht gefunden werden.',
    'go_back_1': 'Geh zurück',
    'payment_receipt': 'Zahlungsbeleg',
    'issue_date': 'Ausgabedatum:',
    'from_1': 'Von',
    'phone_1': 'Telefon:',
    'to_1': 'Zu',
    'phone_2': 'Telefon:',
    'amount_1': 'Betrag',
    'notes_1': 'Notizen',
    'thank_you_for_your_payment': 'Vielen Dank für Ihre Zahlung!',
    'this_receipt_was_generated_automatically': 'Diese Quittung wurde automatisch generiert.',
    'delete_template': 'Vorlage löschen',
    'cancel_2': 'Abbrechen',
    'delete_1': 'Löschen',
    'description_optional': 'Beschreibung (optional)',
    'report_type': 'Berichtstyp',
    'choosing_a_report_type_shows_the_relevan': 'Wenn Sie einen Berichtstyp auswählen, werden unten die relevanten Filter angezeigt.',
    'saved_filters': 'Gespeicherte Filter',
    'select_a_report_type_above_to_set_saved': 'Wählen Sie oben einen Berichtstyp aus, um gespeicherte Filterwerte für diese Vorlage festzulegen.',
    'cancel_3': 'Abbrechen',
    'saved_filter': 'gespeicherter Filter',
    'saved_1': 'Gespeichert',
    'favourites': 'Favoriten',
    'all_templates': 'Alle Vorlagen',
    'load_template': 'Vorlage laden',
    'favourites_1': 'Favoriten',
    'no_templates_for_this_report_type': 'Keine Vorlagen für diesen Berichtstyp',
    'saved_filter_1': 'gespeicherter Filter',
    'manage_apartment_sales_and_track_sold_un': 'Verwalten Sie Wohnungsverkäufe und verfolgen Sie verkaufte Einheiten',
    'apartments_1': 'Wohnungen',
    'available': 'verfügbar',
    'sold_1': 'verkauft',
    'sold_rate': '%-Verkaufsrate',
    'floor_4': 'Boden',
    'units_1': 'Einheiten',
    'available_1': 'verfügbar',
    'sold_2': 'verkauft',
    'unit_4': 'Einheit',
    'owner_buyer': 'Eigentümer/Käufer',
    'sale_price': 'Verkaufspreis',
    'sale_date': 'Verkaufsdatum',
    'sell_unit_2': 'Einheit verkaufen',
    'view_details_2': 'Details anzeigen',
    'print_1': 'Drucken',
    'apartment_management_system': 'Wohnungsverwaltungssystem',
    'erbil_kurdistan_region_iraq': 'Erbil, Region Kurdistan – Irak',
    'tel_xxx_xxxxxxxx': 'Tel.: +XXX XXXXXXXX',
    'receipt': 'Quittung Nr.:',
    'name_2': 'Name:',
    'phone_3': 'Telefon:',
    'building_1': 'Gebäude:',
    'payment_details_1': 'Zahlungsdetails',
    'amount_2': 'Betrag:',
    'payment_date_1': 'Zahlungsdatum:',
    'period_1': 'Zeitraum:',
    'notes_2': 'Notizen',
    'thank_you_for_your_payment_1': 'Vielen Dank für Ihre Zahlung!',
    'tenant_information_1': 'Mieterinformationen',
    'name_3': 'Name:',
    'phone_4': 'Telefon:',
    'apartment_1': 'Wohnung:',
    'building_2': 'Gebäude:',
    'furnished_1': 'Möbliert:',
    'at_12_00_pm': 'um 12:00 Uhr',
    'monthly_rent_1': 'Monatsmiete:',
    'insurance_1': 'Versicherung:',
    'additional_notes': 'Zusätzliche Hinweise',
    'tenant_signature': 'Unterschrift des Mieters',
    'this_receipt_is_electronically_generated': 'Diese Quittung wird elektronisch erstellt und ist ohne Unterschrift gültig.',
    'apartment_management_system_all_rights_r': 'Wohnungsverwaltungssystem. Alle Rechte vorbehalten.',
    'lease_renewal_risk': 'Risiko der Mietverlängerung',
    'expiring_in_30_days': 'Läuft in 30 Tagen ab',
    'expiring_in_60_days': 'Läuft in 60 Tagen ab',
    'expiring_in_90_days': 'Läuft in 90 Tagen ab',
    'expiring_in_180_days': 'Läuft in 180 Tagen ab',
    'all_risk_levels': 'Alle Risikostufen',
    'no_leases_matching_the_selected_filters': 'Keine Mietverträge, die den ausgewählten Filtern entsprechen.',
    'd_1': 'd',
    'no_documents_uploaded_for_this_tenant': 'Für diesen Mieter wurden keine Dokumente hochgeladen.',
    'empty_key_5': '✓',
    'empty_key_6': '✕',
    'empty_key_7': '($) *',
    'ai_lease_reader': 'AI-Leasingleser',
    'upload_a_lease_pdf_to_auto_fill_the_form': 'Laden Sie ein Mietvertrags-PDF hoch, um das Formular automatisch auszufüllen',
    'empty_key_8': '●',
    'empty_key_9': '✓',
    '10_1': '10 /',
    '25_1': '25 /',
    '50_1': '50 /',
    '100_1': '100 /',
    'register_as_maintenance_provider_service': 'Registrieren Sie sich als Wartungsanbieter (Serviceanbieter)',
    'this_will_automatically_create_a_record': 'Dadurch wird automatisch ein Datensatz im Maintenance Hub erstellt, sodass Sie diesem Benutzer Arbeitsaufträge zuweisen können.',
    'assigned_buildings_portfolio': 'Zugeordnete Gebäude (Portfolio)',
    'select_the_buildings_this_portfolio_mana': 'Wählen Sie die Gebäude aus, auf die dieser Portfoliomanager zugreifen kann. Sie sehen NUR Daten für diese Gebäude.',
    'no_buildings_found_please_create_buildin': 'Keine Gebäude gefunden. Bitte erstellen Sie zuerst Gebäude.',
    'building_3': 'Gebäude',
    'empty_key_10': '☀️',
    '1_315_333_7884': '+1 (315) 333-7884',
    'sent_sid': '✅ Gesendet! SID:',
    'iraq_964_is_blocked_by_default_enable_it': '🌍 Irak (+964) ist standardmäßig blockiert. Aktivieren Sie es:',
    'twilio_messaging_geo_permissions_iraq_on': 'Twilio → Messaging → Geo-Berechtigungen → Irak → EIN → Speichern',
    'trial_accounts_can_only_message': '🔒 Testkonten können nur Nachrichten senden',
    'verified_numbers': 'verifizierte Zahlen',
    'apt_1': '· Apt',
    'mo_1': '/Mo',
    'mo_2': '/Mo',
    'manage_building_amenities_unit_features': 'Verwalten Sie die Annehmlichkeiten des Gebäudes, die Ausstattung der Einheiten und die Parkplätze',
    'all_buildings_1': 'Alle Gebäude',
    'add_amenity': 'Annehmlichkeiten hinzufügen',
    'no_building_amenities_found': 'Keine baulichen Annehmlichkeiten gefunden',
    'all_buildings_2': 'Alle Gebäude',
    'all_units': 'Alle Einheiten',
    'add_unit_amenity': 'Fügen Sie Annehmlichkeiten für die Einheit hinzu',
    'no_unit_amenities_found': 'Keine Annehmlichkeiten der Einheit gefunden',

    'unit_amenities': 'Einheitsausstattung',
    'col_monthly_fee': 'Monatsgebühr',
    'col_available': 'Verfügbar',
    'all_buildings_3': 'Alle Gebäude',
    'available_2': 'Verfügbar',
    'reserved': 'Reserviert',
    'add_space': 'Platz hinzufügen',
    'no_parking_spaces_found': 'Keine Parkplätze gefunden',
    'assign': 'Zuweisen',
    'unassign': 'Zuweisung aufheben',
    'spaces': 'Räume',
    'driveway_area': 'Einfahrtsbereich',
    'cancel_4': 'Abbrechen',
    'complete': 'Komplett',
    'confirm_1': 'Bestätigen',
    'cancel_5': 'Abbrechen',
    'complete_1': 'Komplett',
    'assign_space': 'Platz zuweisen',
    'select_tenant_1': 'Wählen Sie Mieter aus',
    'choose_tenant': '-- Mieter auswählen --',
    'select_owner': 'Wählen Sie Besitzer aus',
    'choose_owner': '-- Eigentümer auswählen --',
    'cancel_6': 'Abbrechen',
    'assign_1': 'Zuweisen',
    'new_amenity_booking': 'Neue Annehmlichkeiten buchen',
    'amenity': 'Ausstattung *',
    'select_amenity': 'Ausstattung auswählen…',
    'tenant_1': 'Mieter *',
    'select_tenant_2': 'Mieter auswählen…',
    'date_1': 'Datum *',
    'notes_3': 'Notizen',
    'cancel_7': 'Abbrechen',
    'deactivated': 'Deaktiviert',
    'max_uses': 'Maximale Nutzung',
    'generate_application_link': 'Anwendungslink generieren',
    'building_4': 'Gebäude *',
    'specific_unit_optional': 'Spezifische Einheit (optional)',
    'any_unit_in_building': 'Jede Einheit im Gebäude',
    'unit_5': 'Einheit',
    'floor_5': '– Boden',
    'label': 'Etikett',
    'expires_at': 'Läuft ab um',
    'max_uses_1': 'Maximale Nutzung',
    'cancel_8': 'Abbrechen',
    'label_unit': 'Etikett / Einheit',
    'token_url': 'Token-URL',
    'uses': 'Verwendungsmöglichkeiten',
    'status_1': 'Status',
    'no_links_yet_click_generate_link_to_crea': 'Noch keine Links. Klicken Sie auf „Link generieren”, um einen zu erstellen.',
    'link_generated': 'Link generiert!',
    'failed_to_generate_link': 'Link-Generierung fehlgeschlagen',
    'failed_to_load_links': 'Links konnten nicht geladen werden',
    'link_deactivated': 'Link deaktiviert',
    'search_label_building_token': 'Nach Bezeichnung, Gebäude oder Token suchen…',
    'links_count': '{{count}} Link(s)',
    'untitled': 'Ohne Titel',
    'open_form': 'Formular öffnen',
    'no_links_match_filters': 'Keine Links entsprechen Ihren Filtern.',
    'unit_6': '· Einheit',
    '1_30': '1–30',
    '31_60': '31–60',
    '61_90': '61–90',
    'building_amenity': 'Gebäudeausstattung',
    'amenity_details': 'Ausstattungsdetails',
    'building_5': 'Gebäude *',
    'name_4': 'Name *',
    'category_1': 'Kategorie',
    'monthly_fee': 'Monatliche Gebühr ($)',
    'operating_hours': 'Betriebszeiten',
    'capacity': 'Kapazität',
    'description_1': 'Beschreibung',
    'notes_4': 'Notizen',
    'available_for_booking': 'Zur Buchung verfügbar',
    'cancel_9': 'Abbrechen',
    'saving_1': 'Sparen…',
    'bulk_tenant_import': 'Massenimport von Mietern',
    'import_tenants_from_a_csv_file_apartment': 'Importieren Sie Mieter aus einer CSV-Datei – Wohnungen werden anhand des Gebäudenamens und der Einheitennummer zugeordnet',
    'download_csv_template': 'Laden Sie die CSV-Vorlage herunter',
    'use_this_template_to_format_your_data_co': 'Verwenden Sie diese Vorlage, um Ihre Daten korrekt zu formatieren',
    'template': 'Vorlage',
    'required_columns': 'Erforderliche Spalten',
    'optional_columns': 'Optionale Spalten',
    'payment_date_2': 'Zahlungsdatum',
    'day_of_month_1_31': '= Tag des Monats (1–31)  ·',
    'contract_start_contract_end': 'Vertragsstart / Vertragsende',
    'yyyy_mm_dd': '= JJJJ-MM-TT  ·',
    'en_ar_fr_de_it_sp': '= en, ar, fr, de, it, sp',
    'parsing_csv': 'CSV wird analysiert…',
    'or_click_to_browse_max_2_mb': 'oder klicken Sie zum Durchsuchen – maximal 2 MB',
    'import_preview': 'Vorschau importieren',
    'rows_found_review_before_importing': 'Gefundene Zeilen – vor dem Import überprüfen',
    'start_over': 'Beginnen Sie von vorne',
    'name_5': 'Name',
    'phone_5': 'Telefon',
    'building_unit': 'Gebäude / Einheit',
    'contract_1': 'Vertrag',
    'status_2': 'Status',
    'empty_key_11': '· #',
    'ready_to_import': 'Bereit zum Import',
    'tenant_2': 'Mieter',
    'row': 'Reihe',
    'with_errors_will_be_skipped': 'mit Fehlern werden übersprungen',
    'no_valid_rows_to_import': 'Keine gültigen Zeilen zum Importieren',
    'fix_the_errors_in_your_csv_and_try_again': 'Beheben Sie die Fehler in Ihrer CSV-Datei und versuchen Sie es erneut',
    'upload_new_file': 'Neue Datei hochladen',
    'import_complete': 'Import abgeschlossen',
    'tenants_successfully_imported': 'Mieter erfolgreich importiert',
    'row_1': 'Reihe',
    'skipped_rows': 'Übersprungene Zeilen',
    'row_2': 'Reihe',
    'import_another_file': 'Importieren Sie eine andere Datei',
    'view_tenants': 'Mieter anzeigen',
    'upload_document': 'Dokument hochladen',
    'tenant_3': 'Mieter *',
    'select_tenant_3': 'Mieter auswählen…',
    'document_name': 'Dokumentname *',
    'category_2': 'Kategorie',
    'file_pdf_image_word_max_5mb': 'Datei * (PDF, Bild, Word – max. 5 MB)',
    'upload_document_1': 'Dokument hochladen',
    'document_management': 'Dokumentenmanagement',
    'document': 'Dokument',
    'across_all_tenants': 'über alle Mieter hinweg',
    'upload': 'Hochladen',
    'all_categories': 'Alle Kategorien',
    'document_1': 'Dokument',
    'tenant_4': 'Mieter',
    'category_3': 'Kategorie',
    'status_3': 'Status',
    'uploaded': 'Hochgeladen',
    'actions_1': 'Aktionen',
    'no_documents_found': 'Keine Dokumente gefunden',
    'of_2': 'von',
    'prev': 'Vorher',
    'next_1': 'Als nächstes',
    'select_tenant_required': 'Mieter auswählen',
    'document_name_required': 'Dokumentname ist erforderlich',
    'select_file_required': 'Bitte wählen Sie eine Datei aus',
    'document_uploaded': 'Dokument hochgeladen',
    'upload_failed': 'Upload fehlgeschlagen',
    'failed_to_load_documents': 'Dokumente konnten nicht geladen werden',
    'document_status_updated': 'Dokumentstatus aktualisiert',
    'failed_to_update_status': 'Status konnte nicht aktualisiert werden',
    'confirm_delete_doc': '"{{name}}" löschen? Dies kann vom Administrator rückgängig gemacht werden.',
    'failed_to_delete_document': 'Löschen fehlgeschlagen',
    'documents_count': '{{count}} Dokument(e)',
    'search_by_tenant_name': 'Nach Mietername suchen…',
    'doc_results_count': '{{count}} Ergebnis(se)',
    'uploaded_from': 'Hochgeladen von',
    'uploaded_to': 'Hochgeladen bis',
    'doc_cat_id': 'Ausweis',
    'doc_cat_contract': 'Vertrag',
    'doc_cat_financial': 'Finanziell',
    'doc_cat_insurance': 'Versicherung',
    'doc_cat_other': 'Sonstiges',
    'approved': 'Genehmigt',
    'file_1': 'Datei',
    'open_eviction_case': 'Offener Räumungsfall',
    'tenant_5': 'Mieter',
    'tenant_6': 'Mieter *',
    'building_apartment_auto_filled_from_tena': 'Gebäude und Wohnung werden automatisch aus dem Mieterdatensatz ausgefüllt',
    'case_details': 'Falldetails',
    'reason': 'Grund *',
    'notice_type': 'Hinweistyp',
    'cancel_10': 'Abbrechen',
    'open_case': 'Offener Fall',
    'eviction_management': 'Räumungsmanagement',
    'track_and_manage_eviction_cases_from_not': 'Verfolgen und verwalten Sie Räumungsfälle von der Bekanntmachung bis zum Abschluss',
    'new_case': 'Neuer Fall',
    'pipeline': 'Pipeline',
    'no_eviction_cases_found': 'Es wurden keine Räumungsfälle gefunden',
    'advance': 'Vorwärts →',
    'eviction_case': 'Räumungsfall Nr.',
    'tenant_7': 'Mieter',
    'unit_7': '· Einheitennummer',
    'reason_1': 'Grund',
    'amount_owed_1': 'Geschuldeter Betrag',
    'pipeline_status': 'Pipeline-Status',
    'notes_5': 'Notizen',
    'expense_details': 'Spesendetails',
    'payment_info': 'Zahlungsinformationen',
    'description_2': 'Beschreibung',
    'no_accounts_posted_yet': 'Noch keine Konten gepostet.',
    'total_1': 'Insgesamt',
    'assets': 'Vermögenswerte',
    'liabilities': 'Verbindlichkeiten',
    'select_a_date_and_click_run_to_generate': 'Wählen Sie ein Datum aus und klicken Sie auf Ausführen, um die Bilanz zu erstellen.',
    'from_2': 'Von',
    'to_2': 'Zu',
    'run_1': 'Lauf',
    'operating_activities': 'Betriebsaktivitäten',
    'net_operating_cash_flow': 'Nettobetriebs-Cashflow',
    'financing_activities': 'Finanzierungsaktivitäten',
    'net_financing_cash_flow': 'Nettofinanzierungs-Cashflow',
    'net_change_in_cash': 'Nettoveränderung der Barmittel',
    'select_a_date_range_and_click_run': 'Wählen Sie einen Datumsbereich aus und klicken Sie auf Ausführen.',
    'balance_sheet': 'Bilanz',
    'cash_flow_statement': 'Cashflow',
    'total_assets': 'Gesamtvermögen',
    'total_liabilities': 'Gesamtverbindlichkeiten',
    'total_equity': 'Gesamteigenkapital',
    'bs_balanced_msg': '✓ Ausgeglichen — Aktiva = Passiva + Eigenkapital',
    'bs_unbalanced_msg': '⚠ Nicht ausgeglichen — Buchungseinträge prüfen',
    'operating_cash_flow': 'Operativer Cashflow',
    'financing_cash_flow': 'Finanzierungs-Cashflow',
    'edit_expense': 'Ausgabe bearbeiten',
    'expense_updated': 'Ausgabe aktualisiert',
    'rated': 'bewertet',
    'property_inspections': 'Immobilieninspektionen',
    'move_in_move_out_periodic_20_item_standa': 'Einzug · Auszug · Periodisch · Standardisierte Checkliste mit 20 Punkten',
    'new_inspection': 'Neue Inspektion',
    'no_inspections_found': 'Keine Inspektionen gefunden.',
    'adjust_the_filters_or_create_a_new_inspe': 'Passen Sie die Filter an oder erstellen Sie eine neue Inspektion.',
    'showing_1': 'Zeigt',
    'of_3': 'von',
    'new_inspection_1': 'Neue Inspektion',
    'apartment_2': 'Wohnung',
    'nothing_found': 'Nichts gefunden.',
    'unit_8': '— Einheit',
    'no_active_tenant_on_this_unit': 'Kein aktiver Mieter für diese Einheit.',
    'tenant_8': 'Mieter',
    'no_tenant_vacant': 'Kein Mieter (leer)',
    'inspection_type': 'Inspektionstyp',
    'overall_condition': 'Gesamtzustand',
    'a_20_item_standardized_checklist_entranc': 'Es wird automatisch eine standardisierte Checkliste mit 20 Punkten (Eingang, Wohnzimmer, Küche, Badezimmer, Schlafzimmer, Allgemein) erstellt.',
    'cancel_11': 'Abbrechen',
    'creating': 'Erstellen…',
    'create_inspection': 'Inspektion erstellen',
    'unit_9': '· Einheit',
    'tenant_9': 'Mieter:',
    'inspector': 'Inspektor:',
    'print_2': 'Drucken',
    'checklist_completion': 'Ausfüllen der Checkliste',
    'overall': 'Insgesamt:',
    'click_a_condition_button_to_rate_each_it': 'Klicken Sie auf eine Bedingungsschaltfläche, um jeden Artikel zu bewerten. Notizen werden beim Verwischen automatisch gespeichert.',
    'general_notes_1': 'Allgemeine Hinweise',
    'close_1': 'Schließen',
    'completing': 'Abschluss…',
    'mark_as_completed': 'Als abgeschlossen markieren',
    'close_2': 'Schließen',
    'signing': 'Unterzeichnung…',
    'sign_inspection': 'Schilderinspektion',
    'signing_is_final_and_cannot_be_undone': 'Die Unterzeichnung ist endgültig und kann nicht rückgängig gemacht werden.',
    'covered_entity': 'Abgedecktes Unternehmen',
    'select': 'Auswählen',
    'policy_details': 'Richtliniendetails',
    'insurer_name': 'Name des Versicherers *',
    'start_date_2': 'Startdatum',
    'notes_6': 'Notizen',
    'cancel_12': 'Abbrechen',
    'manage_tenant_owner_and_building_insuran': 'Verwalten Sie Mieter-, Eigentümer- und Gebäudeversicherungen',
    'empty_key_12': '✓',
    'new_lease_application': 'Neuer Mietantrag',
    'applicant_information': 'Bewerberinformationen',
    'full_name_1': 'Vollständiger Name *',
    'email_3': 'E-Mail',
    'phone_6': 'Telefon',
    'date_of_birth': 'Geburtsdatum',
    'current_address': 'Aktuelle Adresse',
    'employment': 'Beschäftigung',
    'employment_status': 'Beschäftigungsstatus',
    'monthly_income': 'Monatliches Einkommen ($)',
    'employer_name': 'Name des Arbeitgebers',
    'employer_phone': 'Arbeitgeber-Telefon',
    'unit_preferences': 'Einheiteneinstellungen',
    'building_6': 'Gebäude',
    'unit_10': 'Einheit',
    'desired_move_in': 'Gewünschter Einzug',
    'desired_lease_months': 'Gewünschte Mietdauer (Monate)',
    'has_pets': 'Hat Haustiere',
    'pet_details': 'Haustierdetails',
    'notes_7': 'Notizen',
    'cancel_13': 'Abbrechen',
    'submit_application': 'Bewerbung einreichen',
    'review_and_approve_prospective_tenant_ap': 'Prüfen und genehmigen Sie Anträge potenzieller Mieter',
    'all_buildings_4': 'Alle Gebäude',
    'no_applications_found': 'Keine Anwendungen gefunden',
    'showing_2': 'Zeigt',
    'of_4': 'von',
    'prev_1': 'Vorher',
    'next_2': 'Als nächstes',
    'close_3': 'Schließen',
    'unit_11': '· Einheitennummer',
    'monthly_rent_2': 'Monatsmiete *',
    'discount_1': 'Rabatt',
    'contract_start_1': 'Vertragsbeginn *',
    'contract_end_1': 'Vertragsende *',
    'payment_day_of_month': 'Zahlungstag des Monats *',
    'application': 'Bewerbung',
    'rejection_reason': 'Ablehnungsgrund',
    'cancel_14': 'Abbrechen',
    'app_search_placeholder': 'Name, E-Mail, Telefon suchen…',
    'app_status_submitted': 'Eingereicht',
    'app_status_under_review': 'In Prüfung',
    'app_status_approved': 'Genehmigt',
    'app_status_rejected': 'Abgelehnt',
    'app_status_waitlisted': 'Auf Warteliste',
    'app_status_withdrawn': 'Zurückgezogen',
    'app_status_converted': 'Umgewandelt',
    'sort_newest': 'Neueste zuerst',
    'sort_movein_asc': 'Einzug ↑ Früheste',
    'sort_movein_desc': 'Einzug ↓ Späteste',
    'sort_income_asc': 'Einkommen ↑ Niedrigste',
    'sort_income_desc': 'Einkommen ↓ Höchste',
    'all_employment': 'Alle Beschäftigungsarten',
    'emp_other': 'Sonstige',
    'move_in_from': 'Einzug von',
    'move_in_to': 'Einzug bis',
    'application_results_count': '{{count}} Bewerbung(en)',
    'failed_to_load_lease_applications': 'Mietanträge konnten nicht geladen werden',
    'status_updated_to': 'Status aktualisiert zu {{status}}',
    'rent_dates_payment_required': 'Miete, Start-, Enddatum und Zahlungstag sind erforderlich',
    'converted_to_tenant_success': 'In Mieter umgewandelt',
    'conversion_failed': 'Umwandlung fehlgeschlagen',
    'lease_duration_months_label': 'Mietdauer',
    'lease_duration_months': '{{n}} Monate',
    'details_not_provided': 'keine Details angegeben',
    'reviewed_by': 'Geprüft von',
    'reviewed_at': 'Geprüft am',
    'converting': 'Wird umgewandelt…',
    'applicant_name_required': 'Name des Bewerbers ist erforderlich',
    'failed_to_submit_application': 'Bewerbung konnte nicht eingereicht werden',
    'submitting': 'Wird eingereicht…',
    'update_failed': 'Aktualisierung fehlgeschlagen',
    'nightly_scan_flags_leases_expiring_in_90': 'Der nächtliche Scan zeigt Mietverträge an, die in 90 Tagen ablaufen – Angebotsentwürfe werden automatisch erstellt und können mit einem Klick gesendet werden',
    'send_all_drafts': 'Alle Entwürfe senden (',
    'expiring_within_90_days': 'Ablauf innerhalb von 90 Tagen',
    'without_an_offer_yet': 'noch kein Angebot',
    'd_2': 'd',
    'offer_sent': 'Angebot gesendet',
    'no_offer': 'kein Angebot',
    'all_statuses_1': 'Alle Status',
    'no_renewals_found': 'Keine Verlängerungen gefunden',
    'd_left': 'Ich bin gegangen',
    'convert_lease': 'Mietvertrag umwandeln',
    'counter_offer': 'Gegenangebot',
    'tenant_10': 'Mieter:',
    'counter_rent_amount': 'Höhe der Gegenmiete *',
    'cancel_15': 'Abbrechen',
    'send_counter': 'Zähler senden',
    'error_loading_renewals': 'Verlängerungen konnten nicht geladen werden',
    'offer_sent_2': 'Angebot gesendet',
    'error_sending_offer': 'Angebot konnte nicht gesendet werden',
    'renewal_accepted': 'Verlängerung akzeptiert',
    'error_accepting_renewal': 'Verlängerung konnte nicht akzeptiert werden',
    'decline_renewal_title': 'Verlängerung ablehnen',
    'decline_renewal_msg': 'Möchten Sie dieses Verlängerungsangebot wirklich ablehnen?',
    'renewal_declined': 'Verlängerung abgelehnt',
    'error_declining_renewal': 'Verlängerung konnte nicht abgelehnt werden',
    'lease_converted_msg': 'Mietvertrag umgewandelt — Mieterdatensatz aktualisiert!',
    'error_converting_renewal': 'Verlängerung konnte nicht umgewandelt werden',
    'drafts_created': '{{count}} Entwurfsangebot(e) erstellt!',
    'no_new_drafts_needed': 'Keine neuen Entwürfe erforderlich — alle auslaufenden Mietverträge haben bereits Angebote.',
    'error_generating_drafts': 'Entwürfe konnten nicht generiert werden',
    'no_draft_renewals_to_send': 'Keine Verlängerungsentwürfe zum Senden',
    'send_all_draft_offers_title': 'Alle Entwurfsangebote senden',
    'send_all_draft_offers_msg': 'Verlängerungsangebote an alle {{count}} Entwurfsmieter senden (E-Mail + WhatsApp)?',
    'offers_sent': '{{count}} Angebot(e) gesendet!{{failed}}',
    'error_sending_offers': 'Angebote konnten nicht gesendet werden',
    'counter_offer_sent': 'Gegenangebot gesendet',
    'error_sending_counter': 'Gegenangebot konnte nicht gesendet werden',
    'search_tenant_unit_building': 'Mieter, Einheit, Gebäude suchen…',
    'all_risk': 'Alle Risiken',
    'risk_low': 'Niedriges Risiko',
    'risk_medium': 'Mittleres Risiko',
    'risk_high': 'Hohes Risiko',
    'renewals_count': '{{count}} Verlängerung(en)',
    'leases_expiring_90d': '{{count}} Mietvertrag(-verträge) laufen innerhalb von 90 Tagen ab',
    'viewed_1': 'Angesehen',
    'accepted_1': 'Akzeptiert',
    'counter_offered': 'Gegenangebot',
    'declined_1': 'Abgelehnt',
    'full_lease_lifecycle_create_renew_termin': 'Vollständiger Mietlebenszyklus – Erstellen, Erneuern, Beenden, Verlauf',
    'new_lease': 'Neuer Mietvertrag',
    'all_status_1': 'Alle Status',
    'active_1': 'Aktiv',
    'expired_1': 'Abgelaufen',
    'renewed': 'Erneuert',
    'all_buildings_5': 'Alle Gebäude',
    'no_leases_found': 'Keine Mietverträge gefunden',
    'expired_2': 'Abgelaufen',
    'd_left_1': 'Ich bin gegangen',
    'd_left_2': 'Ich bin gegangen',
    'd_3': 'd',
    'renew': 'Erneuern',
    'terminate': 'Beenden',
    'terminate_lease': 'Mietvertrag kündigen',
    'this_action_cannot_be_undone_the_lease_w': 'Diese Aktion kann nicht rückgängig gemacht werden. Der Mietvertrag wird endgültig gekündigt.',
    'cancel_16': 'Abbrechen',
    'empty_key_13': '— #',
    'new_start_date': 'Neues Startdatum *',
    'monthly_rent_3': 'Monatsmiete ($) *',
    'lease_type_1': 'Leasingtyp',
    'fixed_term_1': 'Feste Laufzeit',
    'month_to_month_1': 'Von Monat zu Monat',
    'annual_1': 'Jährlich',
    'renew_lease_1': 'Mietvertrag verlängern',
    'cancel_17': 'Abbrechen',
    'expiry_days': '{{days}} T.',
    'leases_expiring_within_60d': '{{count}} Mietvertrag/Mietverträge läuft/laufen innerhalb von 60 Tagen ab',
    'sort_default': 'Sortierung: Standard',
    'sort_expiry_asc': 'Ablauf ↑ Früheste',
    'sort_expiry_desc': 'Ablauf ↓ Späteste',
    'sort_rent_asc': 'Miete ↑ Niedrigste',
    'sort_rent_desc': 'Miete ↓ Höchste',
    'sort_name_asc': 'Mieter A → Z',
    'expiring_within': 'Ablauf innerhalb von',
    'any_expiry': 'Beliebiges Ablaufdatum',
    'days_lte': '≤ {{n}} Tage',
    'create_tenant_for_lease': 'Fügen Sie einen Mieter hinzu, um automatisch einen Mietvertragsdatensatz zu erstellen.',
    'terminating': 'Wird beendet…',
    'enter_termination_reason': 'Kündigungsgrund eingeben…',
    'failed_to_load_leases': 'Mietverträge konnten nicht geladen werden',
    'renewal_failed': 'Verlängerung fehlgeschlagen',
    'terminate_failed': 'Kündigung fehlgeschlagen',
    'start_date_and_rent_required': 'Startdatum und monatliche Miete sind erforderlich',
    'lease_results_count': '{{count}} Mietvertrag/Mietverträge',
    'description_3': 'Beschreibung',
    'tenant_11': 'Mieter',
    'close_4': 'Schließen',
    'new_maintenance_schedule': 'Neuer Wartungsplan',
    'schedule_details': 'Zeitplandetails',
    'building_7': 'Gebäude',
    'all_buildings_6': 'Alle Gebäude',
    'frequency': 'Häufigkeit *',
    'first_due_date': 'Erstes Fälligkeitsdatum *',
    'description_4': 'Beschreibung',
    'cancel_18': 'Abbrechen',
    'create_schedule': 'Zeitplan erstellen',
    'maintenance_schedules': 'Wartungspläne',
    'preventive_maintenance_tracking': 'Vorbeugende Wartungsverfolgung',
    'new_schedule': 'Neuer Zeitplan',
    'overdue_work_orders_will_be_auto_created': 'überfällig – Arbeitsaufträge werden heute Abend automatisch erstellt',
    'no_schedules_found': 'Keine Zeitpläne gefunden',
    'history': 'Geschichte —',
    'no_history_yet': 'Noch keine Geschichte',
    'wo': 'WO #',
    'empty_key_14': '✓',
    'owner_ledger': 'Eigentümerbuch',
    'immutable_financial_history': '– unveränderliche Finanzgeschichte',
    'refresh_1': 'Aktualisieren',
    'add_entry': 'Eintrag hinzufügen',
    'payouts': 'Auszahlungen',
    'add_manual_ledger_entry': 'Fügen Sie einen manuellen Hauptbucheintrag hinzu',
    'amount_3': 'Betrag *',
    'description_5': 'Beschreibung *',
    'cancel_19': 'Abbrechen',
    'showing_3': 'Zeigt',
    'of_5': 'von',
    'prev_2': 'Vorher',
    'next_3': 'Als nächstes',
    'new_parking_space': 'Neuer Parkplatz',
    'creation_mode': 'Erstellungsmodus',
    'single_space': 'Einzelraum',
    'bulk_generation': 'Massengenerierung',
    'building_8': 'Gebäude *',
    'select_building_1': 'Gebäude auswählen…',
    'prefix': 'Präfix',
    'start_number': 'Startnummer *',
    'end_number': 'Endnummer *',
    'pad_with_zeros_e_g_01_02': 'Mit Nullen auffüllen? (z. B. 01, 02)',
    'space_number': 'Platznummer *',
    'level': 'Ebene',
    'type_1': 'Typ',
    'monthly_fee_1': 'Monatliche Gebühr ($)',
    'notes_8': 'Notizen',
    'cancel_20': 'Abbrechen',
    'saving_2': 'Sparen…',
    'create_space': 'Platz schaffen',
    'tenant_screening': 'Mieter-Screening',
    'identity_verification_background_checks': 'Identitätsüberprüfung und Hintergrundüberprüfungen',
    'unit_12': 'Einheit',
    'select_a_tenant_to_view_or_start_their_s': 'Wählen Sie einen Mieter aus, um ihn anzuzeigen oder mit der Überprüfung zu beginnen',
    'final_decision': 'Endgültige Entscheidung',
    'set_on': 'Einschalten',
    'identity_verification': 'Identitätsprüfung',
    'document_2': 'Dokument:',
    'name_6': 'Name:',
    'start_identity_verification': 'Starten Sie die Identitätsprüfung',
    'link_was_shared_with_the_tenant_waiting': 'Der Link wurde mit dem Mieter geteilt und wartete darauf, dass er ihn vervollständigte.',
    'background_check_checkr': 'Hintergrundüberprüfung (Checkr)',
    'adjudication': 'Jurierung:',
    'checks': 'Kontrollen:',
    'start_background_check': 'Starten Sie die Hintergrundüberprüfung',
    'united_states': 'Vereinigte Staaten',
    'canada': 'Kanada',
    'fcra_consent_required': 'FCRA-Zustimmung erforderlich',
    'under_the_fair_credit_reporting_act_fcra': 'Gemäß dem Fair Credit Reporting Act (FCRA) müssen Sie die schriftliche Zustimmung des Antragstellers einholen, bevor Sie eine Hintergrundüberprüfung durchführen. Der Mieter erhält eine E-Mail von Checkr, um den Vorgang abzuschließen.',
    'i_confirm_the_applicant_has_provided_wri': 'Ich bestätige, dass der Antragsteller dieser Hintergrundüberprüfung schriftlich zugestimmt hat',
    'cancel_21': 'Abbrechen',
    'invitation_sent_waiting_for_the_applican': 'Einladung gesendet – wartet auf den Abschluss des Antrags durch den Antragsteller. Checkr aktualisiert dies automatisch.',
    'set_final_decision': 'Legen Sie die endgültige Entscheidung fest',
    'final_screening_decision': 'Endgültige Screening-Entscheidung',
    'manual_review': 'Manuelle Überprüfung',
    'cancel_22': 'Abbrechen',
    'no_screening_started_for_this_tenant_yet': 'Für diesen Mieter wurde noch kein Screening gestartet.',
    'empty_key_15': '($) *',
    'prospect_information': 'Informationen zu Interessenten',
    'showing_details': 'Details anzeigen',
    'empty_key_16': '· #',
    'empty_key_17': '· #',
    'add_unit_amenity_1': 'Fügen Sie Annehmlichkeiten für die Einheit hinzu',
    'bulk_addition_mode': 'Massenadditionsmodus',
    'add_this_amenity_to_multiple_units_at_on': 'Fügen Sie diese Annehmlichkeit zu mehreren Einheiten gleichzeitig hinzu',
    'amenity_details_1': 'Ausstattungsdetails',
    'clear_all': 'Alles löschen',
    'nothing_found_1': 'Nichts gefunden.',
    'amenity_name': 'Name der Einrichtung *',
    'category_4': 'Kategorie',
    'condition': 'Zustand',
    'notes_9': 'Notizen',
    'cancel_23': 'Abbrechen',
    'saving_3': 'Sparen…',
    'add_amenity_1': 'Annehmlichkeiten hinzufügen',
    'n_more': '+{{n}} weitere',
    'board_view': 'Board-Ansicht',
    'main_level': 'Hauptebene',
    'unassigned_1': 'Nicht zugewiesen',
    'unit_cat_appliance': 'Gerät',
    'unit_cat_climate': 'Klima',
    'unit_cat_view': 'Aussicht',
    'unit_cat_layout': 'Grundriss',
    'unit_cat_finish': 'Ausstattung',
    'unit_cat_storage': 'Lager',
    'unit_cat_connectivity': 'Konnektivität',
    'unit_cat_safety': 'Sicherheit',
    'unit_cat_other': 'Sonstige',
    'bld_cat_general': 'Allgemein',
    'bld_cat_fitness': 'Fitness',
    'bld_cat_pool': 'Pool',
    'bld_cat_common_area': 'Gemeinschaftsbereich',
    'bld_cat_outdoor': 'Außenbereich',
    'bld_cat_security': 'Sicherheit',
    'bld_cat_business': 'Business',
    'bld_cat_parking': 'Parkplatz',
    'bld_cat_pet': 'Haustiere',
    'bld_cat_laundry': 'Waschraum',
    'bld_cat_storage': 'Lager',
    'all_fields_required': 'Alle Felder sind erforderlich',
    'booking_failed': 'Buchung fehlgeschlagen',
    'failed_to_load_amenity': 'Ausstattung konnte nicht geladen werden',
    'name_required': 'Name ist erforderlich',
    'amenity_updated': 'Ausstattung aktualisiert',
    'amenity_added': 'Ausstattung hinzugefügt',
    'open_time': 'Öffnen',
    'close_time': 'Schließen',
    'max_occupancy': 'Max. Belegung',
    'edit_building_amenity': 'Gebäudeausstattung bearbeiten',
    'new_building_amenity': 'Neue Gebäudeausstattung',
    'unit_required': 'Einheit ist erforderlich',
    'at_least_one_unit_required': 'Mindestens eine Einheit ist erforderlich',
    'unit_amenity_updated': 'Einheitenausstattung aktualisiert',
    'amenity_bulk_added': 'Ausstattung zu {{count}} Einheiten hinzugefügt',
    'selected_units_label': 'Ausgewählte Einheiten *',
    'unit_searchable_label': 'Einheit * (durchsuchbar)',
    'search_add_multiple_units': 'Mehrere Einheiten suchen & hinzufügen...',
    'search_unit_by_num': 'Einheit nach Nr. oder Gebäude suchen...',
    'cond_new': 'Neu',
    'cond_excellent': 'Ausgezeichnet',
    'cond_good': 'Gut',
    'cond_fair': 'Ausreichend',
    'cond_needs_repair': 'Reparaturbedarf',
    'meter_accounts_rubs_billing_and_per_tena': 'Zählerkonten, RUBS-Abrechnung und Versorgungsgebühren pro Mieter',
    'option_a_metered': 'Option A – Gemessen:',
    'add_account_record_reading_generate_bill': 'Konto hinzufügen → Ablesung aufzeichnen → Rechnungen erstellen → zum Hauptbuch belasten',
    'option_c_rubs': 'Option B – RUBS:',
    'building_level_meter_split_equally_acros': 'Der Zähler auf Gebäudeebene wird gleichmäßig auf alle aktiven Mieter aufgeteilt',
    'reading_recorded_for': 'Lesung aufgezeichnet für',
    'no_utility_accounts_yet_add_one_to_start': 'Noch keine Versorgungskonten – fügen Sie eines hinzu, um mit der zählerbasierten Abrechnung zu beginnen.',
    'no_bills_yet_generate_from_meter_readings': 'Noch keine Rechnungen — fügen Sie Zählerkonten hinzu, erfassen Sie Ablesungen und generieren Sie dann Rechnungen.',
    'no_readings': 'Keine Lesungen',
    'shared': 'Geteilt',
    'reading': 'Lesen',
    'all_statuses_2': 'Alle Status',
    'accounts': 'Konten',
    'bills': 'Rechnungen',
    'benchmarking': 'Benchmarking',
    'total_bills': 'Gesamtrechnungen',
    'total_billed': 'Gesamtabgerechnet',
    'charge': 'Aufladen',
    'unit_13': 'Einheit',
    'notes_10': 'Notizen',
    'cancel_24': 'Abbrechen',
    'loading_1': 'Laden…',
    'accounts_tracked': 'Konten verfolgt',
    'monthly_consumption_last_6_months': 'Monatlicher Verbrauch – letzte 6 Monate',
    'monthly_cost': 'Monatliche Kosten ($)',
    'no_readings_recorded_yet_for': 'Es wurden noch keine Messwerte aufgezeichnet',
    'valuation_details': 'Bewertungsdetails',
    'building_9': 'Gebäude *',
    'market_value': 'Marktwert ($) *',
    'valuation_method': 'Bewertungsmethode',
    'notes_11': 'Notizen',
    'cancel_25': 'Abbrechen',
    'portal': 'Portal ✓',
    'invite_as_system_user_full_portal_access': 'Als Systembenutzer einladen (vollständiger Portalzugriff)',
    'this_will_create_a_staff_account_with_th': 'Dadurch wird ein Mitarbeiterkonto mit der Rolle „Anbieter“ erstellt. Sie erhalten eine E-Mail-Einladung, um ihr Passwort festzulegen.',
    'record_violation': 'Rekordverstoß',
    'tenant_unit': 'Mieter und Einheit',
    'tenant_12': 'Mieter *',
    'unit_14': '— Einheit',
    'apartment_id': 'Wohnungs-ID',
    'auto_filled': 'automatisch ausgefüllt',
    'violation_details': 'Details zum Verstoß',
    'title_1': 'Titel *',
    'type_2': 'Typ *',
    'severity': 'Schweregrad *',
    'incident_date': 'Datum des Vorfalls *',
    'fine_amount_optional': 'Bußgeldbetrag (optional)',
    'description_6': 'Beschreibung *',
    'if_a_fine_amount_is_entered_it_will_be_a': 'Wird ein Bußgeldbetrag erfasst, wird dieser automatisch dem Mieterkonto belastet.',
    'cancel_26': 'Abbrechen',
    'record_violation_1': 'Rekordverstoß',
    'violations_notices': 'Verstöße und Hinweise',
    'track_lease_violations_and_issue_formal': 'Verfolgen Sie Mietverstöße und geben Sie formelle rechtliche Hinweise heraus',
    'new_violation': 'Neuer Verstoß',
    'how_it_works_1': 'Wie es funktioniert',
    'all_statuses_3': 'Alle Status',
    'notice': 'Hinweis',
    'resolve': 'Lösen',
    'issue_legal_notice': 'Geben Sie einen rechtlichen Hinweis heraus',
    'cancel_27': 'Abbrechen',
    'add_webhook_endpoint': 'Webhook-Endpunkt hinzufügen',
    'push_events_to_your_external_systems': 'Pushen Sie Ereignisse an Ihre externen Systeme',
    'successfully_created': 'Erfolgreich erstellt!',
    'save_your_signing_secret_now_it_won_t_be': 'Speichern Sie jetzt Ihr Signaturgeheimnis – es wird nicht mehr angezeigt.',
    'copy_secret': 'Geheimnis kopieren',
    'done_return': 'Fertig und zurück',
    'connection_details': 'Verbindungsdetails',
    'payload_url': 'Payload-URL',
    'description_7': 'Beschreibung',
    'event_subscriptions': 'Veranstaltungsabonnements',
    'you_can_always_add_more_events_later': 'Sie können später jederzeit weitere Ereignisse hinzufügen.',
    'register_endpoint': 'Endpunkt registrieren',
    'cancel_28': 'Abbrechen',
    'assign_a_new_task_to_a_maintenance_provi': 'Weisen Sie einem Wartungsdienstleister eine neue Aufgabe zu',
    'work_order_details': 'Details zum Arbeitsauftrag',
    'work_order_title': 'Titel des Arbeitsauftrags',
    'task_description': 'Aufgabenbeschreibung',
    'scheduling_reference': 'Terminplanung und Referenz',
    'maintenance_request_id': 'Wartungsanforderungs-ID',
    'assignment': 'Aufgabe',
    'select_a_maintenance_provider': 'Wählen Sie einen Wartungsanbieter',
    'priority_level_level': 'Prioritätsstufe',
    'dispatch_work_order': 'Arbeitsauftrag versenden',
    'discard_changes': 'Änderungen verwerfen',
    'pro_tip': 'Profi-Tipp',
    'dispatching_a_work_order_will_immediatel': 'Durch das Versenden eines Arbeitsauftrags wird der Anbieter sofort über sein Portal und per E-Mail benachrichtigt, sofern aktiviert.',
    'update_work_order': 'Arbeitsauftrag aktualisieren',
    'status_priority': 'Status und Priorität',
    'status_4': 'Status',
    'completed_date': 'Fertigstellungsdatum',
    'invoice': 'Rechnung',
    'invoice_amount': 'Rechnungsbetrag',
    'invoice_status': 'Rechnungsstatus',
    'cancel_29': 'Abbrechen',
    'vendor_work_order_management': 'Verwaltung von Lieferanten-Arbeitsaufträgen',
    'refresh_2': 'Aktualisieren',
    'new_work_order': 'Neuer Arbeitsauftrag',
    'all_statuses_4': 'Alle Status',
    'no_work_orders_found': 'Keine Arbeitsaufträge gefunden',
    'mr': 'HERR:',
    'work_order': 'Arbeitsauftrag Nr.',
    'priority_1': 'Priorität',
    'description_8': 'Beschreibung',
    'linked_maintenance_request': 'Verknüpfte Wartungsanfrage',
    'unit_15': 'Einheit',
    'invoice_1': 'Rechnung',
    'view_invoice_document': 'Rechnungsbeleg ansehen',
    'review_approve_invoice': 'Rechnung prüfen und genehmigen',
    'edit_work_order': 'Arbeitsauftrag bearbeiten',
    'approve_invoice': 'Rechnung genehmigen',
    'you_are_approving_a_vendor_invoice_of': 'Sie genehmigen eine Lieferantenrechnung von',
    'for': 'für',
    'charge_to_tenant_ledger': 'Belastung des Mieterbuchs',
    'the_cost_will_be_automatically_added_as': 'Die Kosten werden dem Mieter automatisch als Lastschrift zur Zahlung gutgeschrieben.',
    'organization_absorbs_cost': 'Organisation absorbiert Kosten',
    'the_tenant_will_not_be_charged_this_crea': 'Dem Mieter werden keine Kosten berechnet. Dadurch wird ein Kreditorenbuchhaltungseintrag für die Organisation erstellt.',
    'cancel_30': 'Abbrechen',
    'loading_2': 'Laden…',
    'page_not_found': 'Seite nicht gefunden',
    'the_page_you_re_looking_for_doesn_t_exis': 'Die gesuchte Seite existiert nicht.',
    'go_to_dashboard': 'Gehen Sie zum Dashboard',
    'clear_signature': 'Klare Signatur',
    'i_consent_to_use_electronic_signatures_a': 'Ich stimme der Verwendung elektronischer Signaturen zu und bin damit einverstanden, dass meine elektronische Signatur',
    'cancel_31': 'ist das rechtliche Äquivalent meiner manuellen Unterschrift unter diesem Vertrag. Ich verstehe',
    'sign_contract_1': 'dass ich das Recht habe, eine Papierkopie dieses Dokuments zu erhalten.',
    'by_signing_this_document_electronically': 'Abbrechen',
    'subscription_locked': 'Vertrag unterzeichnen',
    'your_subscription_status_is': 'Durch die elektronische Unterzeichnung dieses Dokuments erkennen Sie an, dass Ihre elektronische Signatur vorliegt',
    'please_renew_your_subscription_to_contin': 'ist rechtsverbindlich und hat die gleiche Wirkung wie eine handschriftliche Unterschrift. Ihre IP-Adresse',
    'payment_options': 'und Zeitstempel werden zu Überprüfungszwecken aufgezeichnet.',
    'please_contact_the_administrator_to_proc': 'Abonnement gesperrt',
    'contact_admin_to_renew': 'Ihr Abonnementstatus ist',
    'request_sent_pending_approval': '.',
    'need_help_contact_support_at_support_qua': 'Bitte erneuern Sie Ihr Abonnement, um Ihre Immobilien weiterhin verwalten zu können.',
    'requires_the': 'Zahlungsoptionen',
    'pro_plan': 'Bitte wenden Sie sich an den Administrator, um Ihre Zahlung zu bearbeiten und Ihr Abonnement erneut zu aktivieren.',
    'is_a_pro_feature': 'Wenden Sie sich zur Verlängerung an den Administrator',
    'upgrade_to_pro_to_unlock_ai_powered_inte': 'Anfrage gesendet! Ausstehende Genehmigung.',
    'upgrade_to_pro_1': 'Brauchen Sie Hilfe? Kontaktieren Sie den Support unter support@quadcores.com',
    'starting_at_3_20_unit_month_no_minimum_u': 'erfordert die',
    'our_narrative': 'Pro-Plan',
    'reimagined': 'ist eine Pro-Funktion',
    'quadcores_properties_is_an_elite_operati': 'Führen Sie ein Upgrade auf Pro durch, um KI-gestützte Intelligenz für Ihr gesamtes Portfolio freizuschalten.',
    'core_capabilities': 'Upgrade auf Pro',
    'our_approach_to': 'Ab 3,20 $/Einheit/Monat · Keine Mindesteinheiten erforderlich',
    'operations': 'Unsere Erzählung',
    'we_believe_property_management_should_be': 'neu gedacht.',
    'whether_you_manage_10_units_or_10_000_qu': 'Quadcores Properties ist eine erstklassige operative Ebene für das moderne Immobilienportfolio.',
    'complete_platform': 'Maßgeschneidert, auf Präzision ausgelegt und für diejenigen entwickelt, die es ernst meinen.',
    'all_features': 'Alle Funktionen',
    '35_powerful_features_organized_into_7_co': '35 leistungsstarke Funktionen, organisiert in 7 umfassende Kategorien.',
    'link_unavailable': 'Link nicht verfügbar',
    'application_submitted': 'Bewerbung eingereicht!',
    'your_application_has_been_received_our_t': 'Ihre Bewerbung ist eingegangen. Unser Team wird es überprüfen und sich bald bei Ihnen melden.',
    'your_application_id': 'Ihre Anwendungs-ID',
    'successfully_registered': 'Erfolgreich registriert',
    'track_application_status': 'Verfolgen Sie den Bewerbungsstatus',
    'rental_application': 'Mietantrag',
    'unit_16': 'Einheit',
    'applying_for': 'Bewerben',
    'full_name_2': 'Vollständiger Name *',
    'email_address': 'E-Mail-Adresse *',
    'national_id_passport': 'Personalausweis/Reisepass',
    'date_of_birth_1': 'Geburtsdatum',
    'current_address_1': 'Aktuelle Adresse',
    'employment_income': 'Beschäftigung und Einkommen',
    'employment_status_1': 'Beschäftigungsstatus',
    'employed': 'Angestellt',
    'self_employed': 'Selbstständig',
    'retired': 'Im Ruhestand',
    'student': 'Student',
    'unemployed': 'Arbeitslos',
    'monthly_income_1': 'Monatliches Einkommen',
    'employer_name_1': 'Name des Arbeitgebers',
    'employer_phone_1': 'Arbeitgeber-Telefon',
    'lease_preferences': 'Mietpräferenzen',
    'desired_move_in_date': 'Gewünschtes Einzugsdatum',
    'lease_duration_months': 'Mietdauer (Monate)',
    'months_2': 'Monate',
    'i_have_pets': 'Ich habe Haustiere',
    'emergency_contact': 'Notfallkontakt',
    'name_7': 'Name',
    'phone_7': 'Telefon',
    'relation': 'Beziehung',
    'additional_notes_1': 'Zusätzliche Hinweise',
    'your_information_is_kept_private_and_use': 'Ihre Daten werden vertraulich behandelt und nur zur Mietbewertung verwendet.',
    'track_application': 'Bewerbung verfolgen',
    'ref_id': 'Ref-ID: #',
    'verification_email': 'Bestätigungs-E-Mail',
    'review': 'Rezension',
    'approval': 'Zustimmung',
    'notice_from_the_team': 'Hinweis vom Team',
    'applicant': 'Bewerber',
    'property_1': 'Eigentum',
    'submitted_1': 'Eingereicht',
    'approved_for_lease': 'Zur Vermietung zugelassen',
    'next_steps_sign_lease': 'Nächste Schritte: Mietvertrag unterzeichnen',
    'questions_contact': 'Fragen? Kontakt',
    'support': 'Unterstützung',
    'or_call_our_leasing_office': 'oder rufen Sie unser Leasingbüro an.',
    'verification_code': 'Bestätigungscode',
    'verify_code': 'Code überprüfen',
    'resend_code': 'Code erneut senden',
    'back_to_login': 'Zurück zum Anmelden',
    'invalid_link': 'Ungültiger Link',
    'go_to_login': 'Gehen Sie zu Anmelden',
    'welcome_aboard': 'Willkommen an Bord!',
    'secure_onboarding': 'Sicheres Onboarding',
    'welcome_to_the_quadcores_property_manage': 'Willkommen im Quadcores Property Management-Portal. Lassen Sie uns die Einrichtung Ihres internen Kontos abschließen.',
    'account_role': 'Kontorolle',
    'email_address_1': 'E-Mail-Adresse',
    'set_your_password': 'Legen Sie Ihr Passwort fest',
    'please_choose_a_secure_password_for_your': 'Bitte wählen Sie ein sicheres Passwort für Ihr Konto.',
    'show_password': 'Passwort anzeigen',
    'complete_account_setup': 'Schließen Sie die Kontoeinrichtung ab',
    'password_requirement_minimum_8_character': 'Passwortanforderung: Mindestens 8 Zeichen. Für maximale Sicherheit empfehlen wir die Verwendung einer Mischung aus Buchstaben, Zahlen und Symbolen.',
    'thank_you_for_your_subscription_your_acc': 'Vielen Dank für Ihr Abonnement. Ihr Konto wurde aktualisiert.',
    'go_to_dashboard_1': 'Gehen Sie zum Dashboard',
    'back_to_home': 'Zurück nach Hause',
    'pricing_plans': 'Preise + Pläne',
    'pay_for_what': 'Bezahlen Sie wofür',
    'you_actually_use': 'die du tatsächlich verwendest.',
    'annual_2': 'Jährlich',
    '16_1': '−16 %',
    'per_unit_pricing_no_minimum_portfolio_si': 'Preis pro Einheit. Keine Mindestportfoliogröße. Jederzeit kündbar.',
    'current_1': 'Aktuell',
    'unit_17': '/ Einheit',
    'from_3': 'von',
    'mo_3': '/Mo',
    'minimum': 'Minimum',
    '2_months_free_annual_billing': '2 Monate kostenlos · Jährliche Abrechnung',
    'includes': 'Inklusive',
    'enterprise_custom_contract': 'Unternehmens-/kundenspezifischer Vertrag',
    '10_000_units_custom_sla_dedicated_suppor': 'Über 10.000 Einheiten, individuelles SLA, dedizierter Support, Vor-Ort-Option.',
    'talk_to_sales': 'Sprechen Sie mit dem Vertrieb →',
    'feature_matrix': 'Funktionsmatrix',
    'full_capability': 'Volle Leistungsfähigkeit',
    'breakdown': 'Zusammenbruch.',
    'starter': 'Anlasser',
    'growth': 'Wachstum',
    'pro_2': 'Profi',
    'no_minimum_units_no_setup_fees_enterpris': 'Keine Mindesteinheiten. Keine Einrichtungsgebühren. Sicherheit auf Unternehmensniveau in jedem Plan.',
    'legal': 'Legal',
    'privacy': 'Privatsphäre',
    'policy': 'Politik.',
    'we_are_committed_to_protecting_your_prof': 'Wir verpflichten uns, Ihre beruflichen und persönlichen Daten mit der gleichen Sorgfalt zu schützen, die wir auch bei Immobiliengeschäften anwenden.',
    'principles': 'Transparenz ist unser Fundament.',
    'section_0': 'Prinzipien',
    'legal_and_compliance': 'ABSCHNITT 0',
    'inquiries': 'Recht und Compliance',
    'if_you_have_questions_about_how_we_handl': 'Anfragen.',
    'info_quadcores_com': 'Wenn Sie Fragen dazu haben, wie wir mit Ihren Daten umgehen, oder wenn Sie Ihre Datenschutzrechte ausüben müssen, wenden Sie sich bitte an unser Compliance-Team.',
    'please_review_the_full_contract_terms_be': 'Wir sind hier, um Ihren Seelenfrieden zu gewährleisten.',
    'link_expired_or_invalid': 'info@quadcores.com',
    'we_couldn_t_find_the_contract_associated': 'Bitte lesen Sie die vollständigen Vertragsbedingungen unten.',
    'your_signature_has_been_recorded_a_copy': 'Link abgelaufen oder ungültig',
    'setup_your_portal': 'Wir konnten den mit diesem Link verknüpften Vertrag nicht finden. Für einen neuen Signaturlink wenden Sie sich bitte an die Hausverwaltung.',
    'access_your_payments_installments_and_do': 'Ihre Unterschrift wurde aufgezeichnet. Eine Kopie des unterzeichneten Vertrags wird Ihnen in Kürze per E-Mail zugesandt.',
    'activate_my_account': 'Richten Sie Ihr Portal ein',
    'go_to_dashboard_2': 'Greifen Sie jederzeit auf Ihre Zahlungen, Raten und Dokumente zu, indem Sie Ihr Portalkonto einrichten.',
    'id_1': 'Aktivieren Sie Mein Konto',
    'contract_signature_portal': 'Gehen Sie zum Dashboard',
    'review_sign': 'ID: #',
    'hello': 'Vertragsunterzeichnungsportal',
    'please_review_your_contract_details_for': 'Überprüfen und unterschreiben',
    'property_2': 'Hallo',
    'contract_value': 'Bitte überprüfen Sie unten Ihre Vertragsdetails für die Immobilie.',
    'timeline': 'Eigentum',
    'to_3': 'Vertragswert',
    'legal_terms': 'Rechtliche Bestimmungen',
    'en_ar': 'EN/AR',
    'legal_disclaimer': 'Haftungsausschluss',
    'electronic_signatures_are_legally_equiva': 'Elektronische Signaturen sind handschriftlichen rechtlich gleichgestellt.',
    'your_ip_address_and_device_information_w': 'Ihre IP-Adresse und Geräteinformationen werden aus Sicherheitsgründen protokolliert.',
    'you_can_download_the_pdf_anytime_after_c': 'Sie können das PDF jederzeit nach Fertigstellung herunterladen.',
    'ready_to_complete': 'Bereit zum Abschluss?',
    'continue_to_plans': 'Weiter zu Pläne',
    'next_step': 'Nächster Schritt...',
    'complete_registration': 'Registrierung abschließen',
    'verify_phone_number': 'Ihre Telefonnummer bestätigen',
    'verification_code_sent_to_phone': 'Bestätigungscode wurde an Ihr Telefon gesendet. Bitte geben Sie ihn unten ein.',
    'popular': 'Beliebt',
    'mo_4': '/Mo',
    'up_to': 'Bis zu',
    'units_2': 'Einheiten',
    'back_to_info': 'Zurück zur Info',
    'verification_code_1': 'Bestätigungscode',
    'please_enter_the_6_digit_code_sent_to': 'Bitte geben Sie den 6-stelligen Code ein, der an gesendet wurde',
    'verify_phone': 'Telefon bestätigen',
    'guidelines': 'Richtlinien',
    'terms_of': 'Bedingungen von',
    'use': 'Benutzen.',
    'our_terms_are_designed_to_ensure_a_secur': 'Unsere Bedingungen sind darauf ausgelegt, ein sicheres, zuverlässiges und faires Umfeld für Eigentümer, Mieter und Immobilienverwalter gleichermaßen zu gewährleisten.',
    'conditions': 'Bedingungen',
    'clause_0': 'Klausel 0',
    'agreement_to': 'Zustimmung zu',
    'arbitration': 'Schlichtung.',
    'by_using_the_platform_you_agree_that_any': 'Durch die Nutzung der Plattform erklären Sie sich damit einverstanden, dass etwaige Streitigkeiten durch professionelle Mediation oder verbindliche Schlichtung beigelegt werden, um eine effiziente Lösung betrieblicher Konflikte zu gewährleisten.',
    'last_updated_march_2026': 'Wir sind bestrebt, eine kooperative Beziehung mit allen unseren Benutzern aufrechtzuerhalten.',
    'system_architecture': 'Letzte Aktualisierung: März 2026',
    'refined': 'Systemarchitektur',
    'operations_1': 'Raffiniert',
    'a_masterclass_in_property_management_we': 'Operationen.',
    'complete_platform_1': 'Komplette Plattform',
    'everything_you_need_to_manage': 'Alles, was Sie zum Verwalten benötigen',
    'your_properties': 'Ihre Immobilien.',
    'a_comprehensive_property_management_syst': 'Ein umfassendes Immobilienverwaltungssystem, das auf Effizienz, Automatisierung und Skalierbarkeit ausgelegt ist.',
    'view_all_24_features': 'Alle 24 Funktionen anzeigen',
    'get_started': 'Fangen Sie an',
    'take_control_of': 'Übernehmen Sie die Kontrolle',
    'your_entire_portfolio': 'Ihr gesamtes Portfolio.',
    'hundreds_of_property_managers_have_alrea': 'Hunderte von Immobilienverwaltern haben ihre Geschäftstätigkeit bereits auf QuadProperties verlagert.',
    'start_free_trial': 'Starten Sie Ihre kostenlose Testversion – keine Kreditkarte erforderlich.',
    'already_have_an_account': 'Kostenlose Testversion starten',
    'quadcores_properties': 'Sie haben bereits ein Konto?',
    'the_apartment_management_platform_built': 'Quadcores-Eigenschaften',
    'quadcores': 'Die Wohnungsverwaltungsplattform für den ernsthaften Betrieb.',
    'quadcores_properties_1': 'Quadcores',
    'every_property': 'Quadcores-Eigenschaften',
    'under_control': 'Jede Immobilie.',
    'one_platform_for_leases_rent_collection': 'Unter Kontrolle.',
    'start_free_trial_1': 'Eine Plattform für Mietverträge, Mieteinzug, Wartung und Mieter –',
    'view_dashboard': 'Gebaut für Immobilienverwalter, die es ernst meinen.',
    'scroll': 'Kostenlose Testversion starten',
    'quadcores_properties_2': 'Dashboard anzeigen',
    'tenant_login': 'Scrollen',
    'owner_login': 'Quadcores-Eigenschaften',
    'sign_in': 'Mieter-Login',
    'get_started_1': 'Besitzer-Login',
    'sign_in_1': 'Melden Sie sich an',
    'menu': 'Fangen Sie an →',
    'get_started_2': 'Melden Sie sich an',
    'tenant_13': 'Menü',
    'owner_1': 'Besitzer',
    'nav_features': 'Funktionen',
    'nav_pricing': 'Preise',
    'nav_about': 'Über uns',
    'our_tiers': 'Unsere Stufen',
    'choose_the_right': 'Wählen Sie das Richtige',
    'plan_for_you': 'für Sie planen.',
    'monthly_1': 'Monatlich',
    'annual_3': 'Jährlich',
    'mo_5': '/ Mo',
    '20_off_annual_billing': '-20 % Rabatt auf die Jahresrechnung',
    'quadcores_properties_3': 'Quadcores-Eigenschaften',
    'the_apartment_management_platform_built_1': 'Die Wohnungsverwaltungsplattform für den ernsthaften Betrieb.',
    'quadcores_1': 'Quadcores',
    'solutions': 'Lösungen',
    'built_for_every_property_professional': 'Gebaut für jeden Immobilienprofi.',
    'empty_key_18': '✦',
    'set_up_your_password': 'Richten Sie Ihr Passwort ein',
    'create_a_strong_password_for': 'Erstellen Sie ein sicheres Passwort für',
    'email_address_2': 'E-Mail-Adresse',
    'new_password_1': 'Neues Passwort',
    'confirm_password_1': 'Passwort bestätigen',
    'back_to_login_1': 'Zurück zum Anmelden',
    'view_all_announcements': 'Alle Ankündigungen anzeigen →',
    'session_expiring_soon': 'Sitzung läuft bald ab',
    'you_will_be_logged_out_automatically': 'Sie werden automatisch abgemeldet',
    'log_out': 'Abmelden',
    'stay_logged_in': 'Bleiben Sie eingeloggt',
    'id_2': 'ID: #',
    'to_4': 'zu',
    'ip_1': 'IP:',
    'ip_2': 'IP:',
    'contract_already_signed': 'Vertrag bereits unterzeichnet',
    'you_have_already_signed_this_contract': 'Sie haben diesen Vertrag bereits unterzeichnet.',
    'review_sign_contract': 'Überprüfen und unterzeichnen Sie den Vertrag',
    'awaiting_your_signature': 'Warten auf Ihre Unterschrift',
    'contract_summary_1': 'Vertragszusammenfassung',
    'property_3': 'Eigentum',
    'start_date_3': 'Startdatum',
    'end_date_1': 'Enddatum',
    'terms_and_conditions': 'Allgemeine Geschäftsbedingungen',
    'important_information': 'Wichtige Informationen',
    'by_signing_you_agree_to_all_terms_and_co': '• Mit Ihrer Unterschrift stimmen Sie allen oben genannten Bedingungen zu',
    'your_electronic_signature_is_legally_bin': '• Ihre elektronische Signatur ist rechtsverbindlich',
    'you_will_receive_a_signed_copy_via_email': '• Sie erhalten ein signiertes Exemplar per E-Mail',
    'you_can_download_the_signed_contract_any': '• Sie können den unterzeichneten Vertrag jederzeit von Ihrem Portal herunterladen',
    'cancel_32': 'Abbrechen',
    'sign_contract_2': 'Vertrag unterzeichnen',
    'units_3': 'Einheiten',
    'unit_18': 'Einheit',
    'tenant_14': 'Mieter:',
    'empty_key_19': '· $',
    'mo_6': '/Mo',
    'no_properties_found_in_your_portfolio': 'In Ihrem Portfolio wurden keine Immobilien gefunden.',
    'my_ledger': 'Mein Hauptbuch',
    'complete_history_of_your_financial_trans': 'Komplette Historie Ihrer Finanztransaktionen',
    'current_balance_1': 'Aktueller Kontostand',
    'no_ledger_entries_yet_1': 'Noch keine Bucheinträge',
    'transactions_will_appear_here_once_recor': 'Transaktionen werden hier angezeigt, sobald sie erfasst wurden.',
    'unit_19': 'Einheit',
    'bal': 'Bal',
    'professional_access': 'Professioneller Zugang',
    'owner_2': 'Besitzer',
    'secure_identify_for_property_executives': 'Sichere Identität für Immobilienmanager und -management.',
    'email_or_phone_number': 'E-Mail oder Telefonnummer',
    'secure_password': 'Sicheres Passwort',
    'switch_to_resident_login': 'Wechseln Sie zum Resident-Login',
    'institutional_oversight': 'Institutionelle Aufsicht.',
    'portfolio_suite': 'Portfolio-Suite',
    'full_control_over_your': 'Volle Kontrolle über Ihr',
    'property_assets': 'Immobilienvermögen.',
    'audited_secure_compliant': 'Geprüft. Sicher. Konform.',
    'empty_key_20': ': $',
    'per_unit_p_l_last_12_months': 'Gewinn und Verlust pro Einheit – letzte 12 Monate',
    'loading_report': 'Bericht wird geladen…',
    'no_properties_found': 'Keine Eigenschaften gefunden',
    'unit_20': '· Einheitennummer',
    'mo_lease_ends': '/mo · Mietvertrag endet',
    '12_mo_noi': '12 Monate NOI',
    'empty_key_21': '▾',
    'monthly_collections_last_6_months': 'Monatliche Sammlungen (letzte 6 Monate)',
    'tax_documents': 'Steuerdokumente',
    'annual_payment_summary_for_tax_reporting': 'Jährliche Zahlungszusammenfassung für Steuerberichte (1099-NEC)',
    'total_paid_1': 'Gesamtbezahlt',
    'this_is_your_personal_payment_summary_fo': 'Dies ist Ihre persönliche Zahlungsübersicht. Für das offizielle 1099-NEC-Formular wenden Sie sich bitte an Ihren Hausverwalter. Nur Zahlungen von 600 $ oder mehr in einem Kalenderjahr sind dem IRS meldepflichtig.',
    'unit_21': 'Einheit',
    'no_payments_recorded_for': 'Es wurden keine Zahlungen erfasst',
    'select_a_different_year_to_view_your_pay': 'Wählen Sie ein anderes Jahr aus, um Ihren Zahlungsverlauf anzuzeigen.',
    'browse_facilities_and_book_time_slots': 'Durchsuchen Sie Einrichtungen und buchen Sie Zeitfenster',
    'no_amenities_available_in_your_building': 'In Ihrem Gebäude sind keine Annehmlichkeiten verfügbar',
    'mo_7': '/Mo',
    'capacity_1': 'Kapazität:',
    'book_time_slot': 'Zeitfenster buchen',
    'book_an_amenity': 'Buchen Sie eine Annehmlichkeit',
    'amenity_1': 'Ausstattung *',
    'select_amenity_1': 'Ausstattung auswählen',
    'date_2': 'Datum *',
    'start_time_1': 'Startzeit *',
    'end_time_1': 'Endzeit *',
    'notes_optional_1': 'Notizen (optional)',
    'cancel_33': 'Abbrechen',
    'no_upcoming_bookings': 'Keine bevorstehenden Buchungen',
    'browse_amenities': 'Durchsuchen Sie die Annehmlichkeiten',
    'cancel_34': 'Abbrechen',
    'history_1': 'Geschichte',
    'property_assistant': 'Immobilienassistent',
    'ask_about_your_account': 'Fragen Sie nach Ihrem Konto',
    'lease_history': 'Miethistorie',
    'your_current_and_past_lease_agreements': 'Ihre aktuellen und vergangenen Mietverträge',
    'active_lease': 'Aktiver Mietvertrag',
    'unit_22': 'Einheit',
    'building_10': 'Gebäude',
    'monthly_rent_4': 'Monatsmiete',
    'expires_1': 'Läuft ab',
    'open_ended': 'Offenes Ende',
    'start_date_4': 'Startdatum',
    'security_deposit_1': 'Kaution',
    'type_3': 'Typ',
    'no_active_lease_on_file': 'Kein aktiver Mietvertrag hinterlegt',
    'history_2': 'Geschichte',
    'mo_8': '/Mo',
    'no_lease_records_found': 'Keine Mieteinträge gefunden',
    'secure_access': 'Sicherer Zugriff',
    'hello_1': 'Hallo',
    'again': 'Schon wieder.',
    'enter_your_details_to_manage_your_home_a': 'Geben Sie Ihre Daten ein, um Ihr Zuhause und Ihre Zahlungen zu verwalten.',
    'your_email': 'Ihre E-Mail',
    'your_password': 'Ihr Passwort',
    'switch_to_owner_login': 'Wechseln Sie zur Eigentümeranmeldung',
    'everything_in_one_place': 'Alles an einem Ort.',
    'tools_for_you': 'Werkzeuge für Sie',
    'everything_you_need': 'Alles was Sie brauchen',
    'to_manage_your_home': 'um Ihr Zuhause zu verwalten.',
    'safe_private_reliable': 'Sicher. Privat. Zuverlässig.',
    'we_use_professional_grade_encryption_to': 'Wir verwenden professionelle Verschlüsselung, um sicherzustellen, dass Ihre Daten und Zahlungen stets geschützt sind.',
    'empty_key_22': ': #',
    'auto_pay_is_on': 'Auto-Pay ist aktiviert',
    'your_rent_is_charged_automatically_on_th': '· Ihre Miete wird am Fälligkeitstag automatisch abgebucht.',
    'enable_auto_pay': 'Aktivieren Sie die automatische Bezahlung',
    'save_a_card_or_bank_account_and_never_mi': 'Speichern Sie eine Karte oder ein Bankkonto und verpassen Sie nie wieder eine Mietzahlung.',

    'autopay_enabled_toast': 'Auto-Zahlung aktiviert! Ihre Miete wird automatisch am Faelligkeitsdatum abgebucht.',
    'autopay_setup_canceled': 'Auto-Zahlung-Einrichtung wurde abgebrochen.',
    'autopay_setup_failed': 'Auto-Zahlung-Einrichtung konnte nicht gestartet werden.',
    'autopay_start_failed': 'Fehler beim Starten der Auto-Zahlung-Einrichtung.',
    'confirm_disable_autopay': 'Moechten Sie die Auto-Zahlung wirklich deaktivieren? Ihre gespeicherte Zahlungsmethode wird entfernt.',
    'autopay_disabled_success': 'Auto-Zahlung wurde deaktiviert.',
    'autopay_disable_failed': 'Fehler beim Deaktivieren der Auto-Zahlung.',
    'card_ending_label': '{{brand}} endet auf ••••{{last4}}',
    'payment_method_saved': 'Zahlungsmethode gespeichert',
    'disable_auto_pay': 'Auto-Zahlung deaktivieren',
    'set_up_auto_pay': 'Auto-Zahlung einrichten',
    'due_colon': 'Faellig:',
    'disabling': 'Wird deaktiviert…',
    'renewal_offers': 'Verlängerungsangebote',
    'review_and_respond_to_lease_renewal_offe': 'Überprüfen Sie die Mietverlängerungsangebote Ihres Vermieters und reagieren Sie darauf',
    'no_renewal_offers_yet': 'Noch keine Verlängerungsangebote',
    'your_property_manager_will_send_a_renewa': 'Ihr Hausverwalter sendet Ihnen hier ein Verlängerungsangebot, wenn sich Ihr Mietvertrag dem Ablaufdatum nähert.',
    'unit_23': 'Einheit',
    'offer_sent_1': 'Angebot gesendet',
    'per_month': 'pro Monat',
    'offered_rent': 'Angebotene Miete',
    'per_month_1': 'pro Monat',
    'new_term': 'Neuer Begriff:',
    'note_from_management': 'Hinweis des Managements',
    'decline': 'Ablehnen',
    'past_offers': 'Vergangene Angebote',
    'unit_24': 'Einheit',
    'mo_9': '/Mo',
    'responded': 'Geantwortet',
    'share_feedback': 'Feedback teilen',
    'your_opinion_helps_us_improve': 'Ihre Meinung hilft uns, uns zu verbessern',
    'thank_you': 'Vielen Dank!',
    'your_feedback_has_been_submitted': 'Ihr Feedback wurde übermittelt.',
    'submit_another': 'Senden Sie einen anderen',
    'category_5': 'Kategorie',
    'your_rating': 'Ihre Bewertung',
    'comment_optional': 'Kommentar (optional)',
    'your_past_feedback': 'Ihr bisheriges Feedback',

    'general': 'Allgemein',
    'submit_feedback': 'Bewertung absenden',
    'please_select_rating': 'Bitte wählen Sie eine Sternebewertung',
    'submission_failed': 'Übermittlung fehlgeschlagen',
    'tell_us_placeholder': 'Sagen Sie uns, was Sie denken…',
    'rating_very_poor': 'Sehr schlecht',
    'rating_poor': 'Schlecht',
    'rating_okay': 'In Ordnung',
    'rating_good': 'Gut',
    'rating_excellent': 'Ausgezeichnet',
    'utility_bills_1': 'Stromrechnungen',
    'electricity_water_gas_and_other_utility': 'Strom-, Wasser-, Gas- und andere Nebenkosten',
    'paid_on_time': 'Pünktlich bezahlt',
    'monthly_utility_spend': 'Monatliche Nebenkosten',
    'no_utility_bills_yet': 'Noch keine Stromrechnungen',
    'bills_will_appear_here_once_issued_by_ma': 'Rechnungen werden hier angezeigt, sobald sie vom Management ausgestellt wurden.',
    'due_now': 'Jetzt fällig (',
    'history_3': 'Geschichte (',
    'due_1': 'Fällig',
    'violations_notices_1': 'Verstöße und Hinweise',
    'view_violations_and_official_notices_iss': 'Sehen Sie sich Verstöße und offizielle Mitteilungen an, die Ihnen zugestellt wurden',
    'no_violations_on_record': 'Keine Verstöße aktenkundig',
    'you_have_a_clean_record_keep_it_up': 'Sie haben eine saubere Bilanz – machen Sie weiter so!',
    'fine': 'Gut:',
    'resolution': 'Auflösung',
    'unit_25': 'Einheit',
    'no_notices': 'Keine Hinweise',
    'no_official_notices_have_been_issued_to': 'Ihnen wurden keine offiziellen Bescheide zugestellt.',
    'here_s_an_overview_of_your_operations_to': 'Hier finden Sie einen Überblick über Ihren heutigen Betrieb.',
    'system_live': 'System Live',
    'active_operations': 'Aktive Operationen',
    'priority_task_queue': 'Prioritätsaufgabenwarteschlange',
    'no_active_tasks_in_your_queue': 'Keine aktiven Aufgaben in Ihrer Warteschlange.',
    'compliance_alert': 'Compliance-Warnung',
    'insurance_expires_in_12_days_please_uplo': 'Die Versicherung läuft in 12 Tagen ab. Bitte laden Sie aktualisierte Dokumente hoch.',
    'upgrade_1': 'Upgrade',
    'service_score': 'Service-Score',
    'detailed_analysis': 'Detaillierte Analyse',
    'system_activity': 'Systemaktivität',
    'profile_load_error': 'Fehler beim Laden des Profils',
    'the_registry_could_not_verify_your_ident': 'Die Registrierung konnte Ihre Identität nicht überprüfen. Wenden Sie sich an die Systemadministratoren.',
    'operator': 'Betreiber',
    'tier_platinum': 'Stufe: Platin',
    'identity_matrix': 'Identitätsmatrix',
    'logistical_data': 'Logistische Daten',
    'verified_credentials': 'Verifizierte Anmeldeinformationen',
    'profile_modifications_are_managed_by_ins': 'Profiländerungen werden durch institutionelle Sicherheitsprotokolle verwaltet. Fordern Sie Aktualisierungen über die Leitstelle für Netzintegrität an.',
    'invalid_or_expired_link': 'Ungültiger oder abgelaufener Link',
    'security_established': 'Sicherheit etabliert',
    'your_portal_access_key_has_been_successf': 'Ihr Portal-Zugangsschlüssel wurde erfolgreich erstellt.',
    'proceed_to_login': 'Fahren Sie mit der Anmeldung fort',
    'access_setup': 'Greifen Sie auf „Setup“ zu',
    'finalize_your_credentials_for': 'Finalisieren Sie Ihre Anmeldeinformationen für',
    'new_access_key': 'Neuer Zugriffsschlüssel',
    'confirm_authorization': 'Bestätigen Sie die Autorisierung',
    'finalize_connection': 'Verbindung abschließen',
    'w_9_tax_form': 'W-9-Steuerformular',
    'request_for_taxpayer_identification_numb': 'Antrag auf Steueridentifikationsnummer – erforderlich für die 1099-NEC-Einreichung',
    'w_9_on_file': 'W-9 in den Akten',
    'certified_on': 'Zertifiziert am',
    'you_can_update_and_re_certify_at_any_tim': '. Sie können jederzeit aktualisieren und erneut zertifizieren.',
    'this_form_is_required_by_the_irs_if_you': 'Dieses Formular wird vom IRS benötigt. Wenn Sie in einem Kalenderjahr 600 US-Dollar oder mehr erhalten, wird anhand dieser Informationen ein 1099-NEC ausgestellt. Ihre vollständige SSN wird niemals gespeichert – nur die letzten 4 Ziffern, sofern angegeben.',
    '1_legal_name_as_shown_on_income_tax_retu': '1. Firmenname (wie in der Einkommensteuererklärung angegeben) *',
    '3_federal_tax_classification': '3. Bundessteuerklassifizierung *',
    'employer_id_number_ein': 'Arbeitgeber-ID-Nummer (EIN)',
    'ssn_last_4_digits_only': 'SSN – nur die letzten 4 Ziffern',
    'we_only_store_the_last_4_for_your_privac': 'Aus Datenschutzgründen speichern wir nur die letzten 4',
    '5_address': '5. Adresse',
    'city': 'Stadt',
    'state': 'Staat',
    'certification': 'Zertifizierung',
    'under_penalties_of_perjury_i_certify_tha': 'Unter Strafe des Meineids bestätige ich, dass: (1) die angegebene Nummer meine korrekte Steueridentifikationsnummer ist; (2) Ich bin nicht der Sicherungseinbehaltung unterworfen; (3) Ich bin ein US-amerikanischer Staatsbürger oder eine andere US-Person; (4) Ich bin von der FATCA-Meldepflicht befreit (falls zutreffend).',
    'by_clicking': 'Durch Klicken',
    'save_certify': 'Speichern und zertifizieren',
    'you_are_electronically_signing_this_w_9': 'Sie unterschreiben dieses W-9 elektronisch. Dabei werden Ihre IP-Adresse und Ihr Zeitstempel erfasst.',
    'core_operations': 'Kernoperationen',
    'work_orders_1': 'Arbeitsaufträge',
    'execute_your_assignments_with_efficiency': 'Führen Sie Ihre Aufgaben effizient und präzise aus.',
    'all_assignments': 'Alle Aufgaben',
    'assigned_tasks': 'Zugewiesene Aufgaben',
    'currently_active': 'Derzeit aktiv',
    'completed_history': 'Abgeschlossene Geschichte',
    'no_assignments_found': 'Keine Aufgaben gefunden',
    'your_current_view_filters_haven_t_matche': 'Ihre aktuellen Ansichtsfilter stimmen mit keinem Datensatz überein.',
    'unit_26': 'Einheit',
    'task_description_1': 'Aufgabenbeschreibung',
    'completion_evidence': 'Abschlussnachweis',
    'logistics_control': 'Logistiksteuerung',
    'start_mission': 'Mission starten',
    'mark_finished': 'Als fertig markieren',
    'submit_invoice': 'Rechnung einreichen',
    'view_brief': 'Kurzbeschreibung anzeigen',
    'notice_1': 'Hinweis',
    'safety_protocols_are_active_wear_authori': 'Sicherheitsprotokolle sind aktiv. Tragen Sie stets zugelassene PSA.',
    'page_1': 'Seite',
    'of_6': 'von',
    'next_4': 'Als nächstes',
    'submit_settlement': 'Abrechnung einreichen',
    'claim_amount_for': 'Anspruchsbetrag für',
    'cancel_35': 'Abbrechen',
    'live': 'Lebe',
    'sign_out_1': 'Abmelden',
    'sign_out_2': 'Abmelden',

    // Missing translations added
    'BULK_ADD': 'Sammelhinzufügung',
    'QTY_PER_FLOOR': 'Anz. / Etage',
    'SELECT_FLOORS': 'Etagen auswählen',
    'SIZE': 'Größe',
    'bill_charged': 'Rechnung dem Mieter-Konto belastet',
    'billing_day': 'Abrechnungstag im Monat',
    'building_meter_hint': 'Gebäudezähler — RUBS-Methode zur Kostenaufteilung auf alle Mieter verwenden',
    'calculating': 'Berechnung läuft…',
    'charge_all': 'Alle belasten',
    'charging': 'Wird belastet…',
    'custom': 'Benutzerdefiniert',
    'date': 'Datum',
    'deleted': 'Gelöscht',
    'done': 'Fertig',
    'ent_f1': 'Unbegrenzte Einheiten & Admins',
    'ent_f10': 'API- & Webhook-Zugriff',
    'ent_f11': '2FA via WhatsApp OTP',
    'ent_f2': 'Mieter- & Eigentümerportale',
    'ent_f3': 'Sicherer bidirektionaler Nachrichtenaustausch',
    'ent_f4': 'Stripe E2E-Mietzahlungen',
    'ent_f5': 'Automatisiertes E-Mail-System',
    'ent_f6': 'Digitale Vertragsunterzeichnung',
    'ent_f7': 'Unterstützung mehrerer Organisationen',
    'ent_f8': 'Benutzerdefinierte Berichtsvorlagen',
    'ent_f9': 'Erweiterte Aktivitätsprotokolle',
    'enterprise_desc': 'Institutionelle Kontrolle mit vollständigen Self-Service-Portalen.',
    'generate_bills': 'Rechnungen erstellen',
    'generate_bills_now': 'Rechnungen jetzt erstellen',
    'individual_meter_hint': 'Einzelzähler — Rechnung für diese Einheit erstellen',
    'pro_desc': 'Für professionelle Unternehmen mit automatisierten Verwaltungsabläufen.',
    'pro_f1': 'Bis zu 150 Einheiten',
    'pro_f10': 'Standard-Prioritätssupport',
    'pro_f2': '5 Admin-Plätze',
    'pro_f3': 'Globaler Wartungs-Hub',
    'pro_f4': 'Kautions-Compliance',
    'pro_f5': 'Automatisierte Monatsabrechnungen',
    'pro_f6': 'WhatsApp-Erinnerungen',
    'pro_f7': 'Eigentümerverwaltung & Arbeitsaufträge',
    'pro_f8': 'Belegungsanalyse',
    'pro_f9': 'Buchung, Warteliste & Transfers',
    'run_rubs_btn': 'RUBS-Aufteilung durchführen',
    'save_20_annual': '20 % sparen · ${{amount}}/Jahr bei Jahreszahlung',
    'starter_desc': 'Für unabhängige Vermieter, die interne Aufzeichnungen führen.',
    'starter_f1': 'Bis zu 100 Einheiten',
    'starter_f2': '2 Admin-Plätze',
    'starter_f3': 'Gebäude- & Einheitenverwaltung',
    'starter_f4': 'Doppeltes Buchführungs-Ledger',
    'starter_f5': 'Manuelle Mietverfolgung',
    'starter_f6': 'Grundlegende Finanzberichte',
    'starter_f7': 'E-Mail-Benachrichtigungen',
    'starter_plan': 'Starter',
    'unknown': 'Unbekannt',
    'utility_step1': 'Versorgungskonto hinzufügen (Strom, Wasser, Gas…)',
    'utility_step2': 'Zählerstand erfassen',
    'utility_step3': 'Rechnungen aus Ablesungen erstellen',
    'utility_step4': 'Rechnungen direkt dem Mieter-Konto belasten',
    'view_application': 'Antrag ansehen',

    'confirm_charge_bill': 'Diese Versorgungsrechnung dem Mieter-Konto belasten?',

    'all_tenants_compliant_desc': 'Alle Mieter sind derzeit compliant',
    'audit_compliance': 'Compliance-Prüfung',
    'compliant': 'Compliant',
    'confirm_delete_policy': 'Diese Police löschen?',
    'entity_name': 'Name der Einheit',
    'error_loading_insurance': 'Versicherungspolicen konnten nicht geladen werden',
    'expiration': 'Ablaufdatum',
    'no_insurance_records': 'Keine Versicherungseinträge gefunden',
    'non_compliant': 'Nicht konform',
    'policy_added': 'Police hinzugefügt',
    'policy_updated': 'Police aktualisiert',
    'send_notice': 'Mitteilung senden',
    'view_policy': 'Police ansehen',

    'generate_drafts': 'Entwürfe jetzt erstellen',

    // Evictions
    'ev_initiated': 'Eingeleitet',
    'ev_notice_served': 'Kündigung zugestellt',
    'ev_court_filed': 'Klage eingereicht',
    'ev_court_ruling': 'Gerichtsurteil',
    'ev_completed': 'Abgeschlossen',
    'ev_dismissed': 'Abgewiesen',
    'ev_notice_pay_or_quit': 'Zahlen oder ausziehen',
    'ev_notice_cure_or_quit': 'Beheben oder ausziehen',
    'ev_notice_unconditional': 'Bedingungslose Räumung',
    'ev_active_cases': 'Aktive Fälle',
    'ev_total_owed': 'Ausstehender Betrag',
    'ev_notice_type': 'Kündigungsart',
    'ev_amount_owed': 'Ausstehender Betrag',
    'ev_status_updated': 'Status aktualisiert',
    'ev_dismiss_case': 'Fall ablehnen',
    'ev_dismiss_confirm': 'Sind Sie sicher, dass Sie diesen Räumungsfall ablehnen möchten? Dies kann nicht rückgängig gemacht werden.',
    'ev_case_dismissed': 'Räumungsfall abgelehnt',
    'ev_dismiss_failed': 'Fall konnte nicht abgelehnt werden',
    'ev_case_timeline': 'Fall-Zeitplan',
    'ev_notice_served_date': 'Zustellung des Bescheids',
    'ev_court_filing_date': 'Gerichtseinreichung',
    'ev_court_date': 'Verhandlungstermin',
    'ev_ruling': 'Urteil',
    'ev_ruling_date': 'Urteilsdatum',
    'ev_vacate_date': 'Räumungsfrist',
    'ev_edit_notes': 'Notizen bearbeiten',
    'ev_save_notes': 'Notizen speichern',
    'ev_add_notes': 'Notiz hinzufügen',
    'ev_notes_saved': 'Notizen gespeichert',
    'ev_save_failed': 'Speichern fehlgeschlagen',
    'filed': 'Eingereicht',

    // Inspections
    'insp_move_in': 'Einzug',
    'insp_move_out': 'Auszug',
    'insp_periodic': 'Periodisch',
    'insp_maintenance': 'Wartung',
    'all_types': 'Alle Typen',
    'all_status': 'Alle Status',
    'unit_building': 'Einheit / Gebäude',
    'checklist_progress': 'Checklisten-Fortschritt',
    'condition_1': 'Zustand',

    // Violations
    'tenant_unit': 'Mieter / Einheit',
    'severity': 'Schweregrad',
    'fine': 'Geldstrafe',

    // Leases
    'start': 'Beginn',
    'end': 'Ende',
    'expiry': 'Ablauf',
    'rent_mo': 'Miete/Monat',
    'open_ended': 'Unbefristet',

    // Renewals
    'offered_rent': 'Angebotene Miete',
    'risk': 'Risiko',
    'offer_expires': 'Angebot läuft ab',

    // Lease Applications
    'applicant': 'Bewerber',
    'employment': 'Beschäftigung',

    // Application Links
    'total_links': 'Gesamtlinks',
    'active_links': 'Aktive Links',
    'total_uses': 'Gesamtnutzungen',
    'generating': 'Wird erstellt...',
    'generate_link': 'Link generieren',
    'deactivate_link': 'Link deaktivieren',
    'deactivate_link_confirm': 'Link „{{label}}" deaktivieren? Er nimmt keine Bewerbungen mehr an.',
    'deactivate': 'Deaktivieren',

    // Sales Wizard
    'sw_step_buyer': 'Käufer',
    'sw_step_terms': 'Konditionen',
    'sw_step_schedule': 'Zahlungsplan',
    'sw_step_confirm': 'Bestätigen',
    'back': 'Zurück',
    'creating': 'Wird erstellt...',
    'create_sale_contract': 'Kaufvertrag erstellen',
    'hash': '#',
    'due_date': 'Fälligkeitsdatum',
    'principal': 'Kapital',
    'interest': 'Zinsen',
    'monthly_payment': 'Monatliche Rate',
    'total_interest': 'Gesamtzinsen',
    'total_cost': 'Gesamtkosten',
    'down_payment': 'Anzahlung',
    'sale_price': 'Verkaufspreis',
    'financed_amount': 'Finanzierter Betrag',
    'interest_rate': 'Zinssatz',
    'term': 'Laufzeit',

    // Validation errors
    'val_first_name_min': 'Vorname muss mindestens 2 Zeichen lang sein',
    'val_first_name_max': 'Vorname darf maximal 50 Zeichen lang sein',
    'val_last_name_min': 'Nachname muss mindestens 2 Zeichen lang sein',
    'val_last_name_max': 'Nachname darf maximal 50 Zeichen lang sein',
    'val_username_min': 'Benutzername muss mindestens 3 Zeichen lang sein',
    'val_username_max': 'Benutzername darf maximal 30 Zeichen lang sein',
    'val_username_no_spaces': 'Benutzername darf keine Leerzeichen enthalten',
    'val_email_invalid': 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
    'val_company_name_min': 'Firmenname muss mindestens 2 Zeichen lang sein',
    'val_password_min': 'Passwort muss mindestens 8 Zeichen lang sein',
    'val_password_max': 'Passwort darf maximal 128 Zeichen lang sein',
    'val_name_max_100': 'Name darf maximal 100 Zeichen lang sein',
    'val_close_time_required': 'Bitte Schließzeit angeben',
    'val_open_time_required': 'Bitte Öffnungszeit angeben',
    'val_close_after_open': 'Schließzeit muss nach der Öffnungszeit liegen',
    'val_title_max_200': 'Titel darf maximal 200 Zeichen lang sein',
    'val_description_max_2000': 'Beschreibung darf maximal 2000 Zeichen lang sein',
    'val_fine_non_negative': 'Bußgeldbetrag muss null oder positiv sein',
    'val_prospect_name_max': 'Interessentenname darf maximal 200 Zeichen lang sein',
    'val_end_after_start': 'Endzeit muss nach der Startzeit liegen',
    'val_notes_max_2000': 'Notizen dürfen maximal 2000 Zeichen lang sein',
    'val_expiry_after_start': 'Ablaufdatum muss nach dem Startdatum liegen',
    'val_url_invalid': 'URL muss mit http:// oder https:// beginnen',
    'val_notes_max_1000': 'Notizen dürfen maximal 1000 Zeichen lang sein',
    'val_webhook_url_https': 'Webhook-URL muss mit https:// beginnen',

    'error_loading_violations': 'Fehler beim Laden der Verstöße',
    'marked_as_resolved': 'Als gelöst markiert',
    'error_updating_violation': 'Fehler beim Aktualisieren des Verstoßes',
    'title_and_notice_body_required': 'Titel und Benachrichtigungsinhalt sind erforderlich',
    'notice_issued': 'Benachrichtigung ausgestellt',
    'error_issuing_notice': 'Fehler beim Ausstellen der Benachrichtigung',
    'search_violations': 'Nach Mieter, Titel oder Beschreibung suchen...',
    'loading_violations': 'Verstöße werden geladen...',
    'no_violations_recorded': 'Keine Verstöße erfasst',
    'no_status_violations': 'Keine {{status}}-Verstöße',
    'notice_type_required': 'Benachrichtigungsart *',
    'delivery_method_required': 'Zustellungsmethode *',
    'notice_title_required': 'Benachrichtigungstitel *',
    'notice_deadline_optional': 'Compliance-Frist (optional)',
    'notice_body_required': 'Benachrichtigungstext *',
    'issuing': 'Wird ausgestellt...',
    'issue_notice_btn': 'Benachrichtigung ausstellen',
    'violations_count': '{{count}} Verstöße',
    'open_tickets': 'Offene Tickets',
    'has_balance': 'Hat Saldo',
    'perfect_payments': 'Perfekte Zahlungen',
    'risk_score': 'Risikowert',
    'failed_to_load_evictions': 'Fehler beim Laden der Räumungen',
    'failed_to_update_status': 'Fehler beim Aktualisieren des Status',
    'please_select_a_tenant': 'Bitte einen Mieter auswählen',
    'tenant_must_have_apartment': 'Der ausgewählte Mieter muss eine zugewiesene Wohnung und ein Gebäude haben, um geräumt zu werden.',
    'reason_is_required': 'Grund ist erforderlich',
    'eviction_case_opened': 'Räumungsfall eröffnet',
    'failed_to_create_eviction': 'Fehler beim Erstellen der Räumung',

    'wo_stat_total': 'Gesamt',
    'wo_stat_assigned': 'Zugewiesen',
    'wo_stat_in_progress': 'In Bearbeitung',
    'wo_stat_completed': 'Abgeschlossen',
    'wo_col_title': 'Titel',
    'wo_col_vendor': 'Lieferant',
    'wo_col_priority': 'Priorität',
    'wo_col_status': 'Status',
    'wo_col_scheduled': 'Geplant',
    'wo_col_invoice': 'Rechnung',
    'wo_col_assigned_by': 'Zugewiesen von',
    'wo_detail_scheduled': 'Geplant',
    'wo_detail_completed': 'Abgeschlossen',
    'wo_detail_created': 'Erstellt',
    'wo_failed_to_load': 'Arbeitsaufträge konnten nicht geladen werden',
    'wo_invoice_approved': 'Rechnung erfolgreich genehmigt!',
    'wo_confirm_approval': 'Genehmigung bestätigen',
    'wo_status_assigned': 'Zugewiesen',
    'wo_status_in_progress': 'In Bearbeitung',
    'wo_status_on_hold': 'Zurückgestellt',
    'inv_status_received': 'Erhalten',
    'view_detail': 'Details anzeigen',
    'wo_failed_approve': 'Rechnung konnte nicht genehmigt werden',
    'wo_failed_load_vendors': 'Lieferantenliste konnte nicht geladen werden',
    'wo_vendor_required': 'Lieferant ist erforderlich',
    'wo_title_required': 'Titel ist erforderlich',
    'wo_created': 'Arbeitsauftrag erfolgreich erstellt',
    'wo_failed_to_create': 'Arbeitsauftrag konnte nicht erstellt werden',
    'wo_title_placeholder': 'z.B. Reparatur eines undichten Rohrs in Gebäude A Einheit 302',
    'wo_description_placeholder': 'Detaillierte Anweisungen für den Lieferanten...',
    'wo_linked_id_placeholder': 'Optionale verknüpfte ID',
    'wo_nothing_to_update': 'Nichts zu aktualisieren',
    'wo_updated': 'Arbeitsauftrag aktualisiert',
    'wo_update_failed': 'Aktualisierung fehlgeschlagen',
    'sch_col_title': 'Titel',
    'sch_col_building': 'Gebäude',
    'sch_col_frequency': 'Häufigkeit',
    'sch_col_next_due': 'Nächste Fälligkeit',
    'sch_col_est_cost': 'Gesch. Kosten',
    'sch_col_status': 'Status',
    'sch_col_actions': 'Aktionen',
    'sch_error_loading': 'Fehler beim Laden der Zeitpläne',
    'sch_mark_complete_success': 'Als abgeschlossen markiert, nächstes Datum vorgerückt',
    'sch_error_complete': 'Fehler beim Abschließen des Zeitplans',
    'sch_confirm_remove': 'Diesen Zeitplan entfernen?',
    'sch_removed': 'Zeitplan entfernt',
    'sch_error_remove': 'Fehler beim Entfernen des Zeitplans',
    'sch_error_history': 'Fehler beim Laden des Verlaufs',
    'sch_search_placeholder': 'Zeitpläne durchsuchen...',
    'sch_status_active': 'Aktiv',
    'sch_status_inactive': 'Inaktiv',
    'sch_edit_success': 'Zeitplan aktualisiert',
    'sch_error_edit': 'Fehler beim Aktualisieren des Zeitplans',
    'sch_edit_schedule': 'Zeitplan bearbeiten',
    'sch_title_freq_due_required': 'Titel, Häufigkeit und erstes Fälligkeitsdatum sind erforderlich',
    'schedule_created': 'Zeitplan erstellt',
    'sch_failed_to_create': 'Zeitplan konnte nicht erstellt werden',
    'sch_history_title': 'Verlauf',
    'sch_remove_title': 'Entfernen',
    'describe_task_placeholder': 'Wartungsaufgabe beschreiben...',
    'vendor_instructions_placeholder': 'Spezifische Anweisungen für den Anbieter...',
    'freq_daily': 'Täglich',
    'freq_weekly': 'Wöchentlich',
    'freq_biweekly': 'Zweiwöchentlich',
    'freq_monthly': 'Monatlich',
    'freq_quarterly': 'Vierteljährlich',
    'freq_semiannual': 'Halbjährlich',
    'freq_biannual': 'Halbjährlich',
    'freq_annual': 'Jährlich',

    'search_conversations': 'Gespräche suchen...',
    'load_more': 'Mehr laden',
    'no_results': 'Keine Ergebnisse gefunden',
    'BULK_ADD': 'Massenhaftes Hinzufügen',
    'QTY_PER_FLOOR': 'Menge / Etage',
    'SELECT_FLOORS': 'Etagen auswählen',
    'SIZE': 'Größe',
    'bill_charged': 'Rechnung dem Mieterkonto belastet',
    'billing_day': 'Abrechnungstag des Monats',
    'building_meter_hint': 'Gebäudezähler — RUBS verwenden, um Kosten auf alle Mieter aufzuteilen',
    'calculating': 'Berechnung…',
    'charge_all': 'Alle berechnen',
    'charging': 'Wird berechnet…',
    'custom': 'Benutzerdefiniert',
    'date': 'Datum',
    'deleted': 'Gelöscht',
    'done': 'Fertig',
    'ent_f1': 'Unbegrenzte Einheiten & Administratoren',
    'ent_f10': 'API & Webhook-Zugriff',
    'ent_f11': '2FA via WhatsApp OTP',
    'ent_f2': 'Mieter- & Eigentümerportale',
    'ent_f3': 'Bidirektionale sichere Nachrichten',
    'ent_f4': 'Stripe E2E-Mietzahlungen',
    'ent_f5': 'Automatisches E-Mail-System',
    'ent_f6': 'Digitale Vertragsunterzeichnung',
    'ent_f7': 'Unterstützung mehrerer Organisationen',
    'ent_f8': 'Benutzerdefinierte Berichtsvorlagen',
    'ent_f9': 'Erweiterte Aktivitätsprotokolle',
    'enterprise_desc': 'Institutionelle Kontrolle mit vollständigen Self-Service-Portalen.',
    'generate_bills': 'Rechnungen erstellen',
    'generate_bills_now': 'Jetzt Rechnungen erstellen',
    'individual_meter_hint': 'Einzelzähler — Rechnung für diese Einheit erstellen',
    'pro_desc': 'Für professionelle Unternehmen mit automatisierten Verwaltungsabläufen.',
    'pro_f1': 'Bis zu 150 Einheiten',
    'pro_f10': 'Standard-Prioritätssupport',
    'pro_f2': '5 Administrator-Plätze',
    'pro_f3': 'Globales Wartungs-Hub',
    'pro_f4': 'Konformität bei Sicherheitsleistungen',
    'pro_f5': 'Automatisierte monatliche Abrechnungen',
    'pro_f6': 'WhatsApp-Erinnerungen',
    'pro_f7': 'Eigentümerverwaltung & Arbeitsaufträge',
    'pro_f8': 'Belegungsanalyse',
    'pro_f9': 'Buchung, Warteliste & Transfers',
    'run_rubs_btn': 'RUBS-Aufteilung ausführen',
    'save_20_annual': '20% sparen · ${{amount}}/Jahr jährlich abgerechnet',
    'starter_desc': 'Für unabhängige Vermieter, die interne Aufzeichnungen führen.',
    'starter_f1': 'Bis zu 100 Einheiten',
    'starter_f2': '2 Administrator-Plätze',
    'starter_f3': 'Gebäude- & Einheitenverwaltung',
    'starter_f4': 'Doppeltes Buchführungs-Hauptbuch',
    'starter_f5': 'Manuelle Mietverfolgung',
    'starter_f6': 'Grundlegende Finanzberichte',
    'starter_f7': 'E-Mail-Benachrichtigungen',
    'starter_plan': 'Starter',
    'unknown': 'Unbekannt',
    'utility_step1': 'Versorgungskonto hinzufügen (Strom, Wasser, Gas…)',
    'utility_step2': 'Zählerstand erfassen',
    'utility_step3': 'Rechnungen aus Ablesungen erstellen',
    'utility_step4': 'Rechnungen direkt dem Mieterkonto belasten',
    'view_application': 'Bewerbung anzeigen',
    'failed_to_update_document_status': 'Status des Dokuments konnte nicht aktualisiert werden',
    'buyer_name_placeholder': 'z.B. Ahmed Al-Rashidi',
    'col_amenity': 'Ausstattung',
    'col_space': 'Raum',
    'delete_document': 'Dokument löschen',
    'delete_draft_confirm': 'Möchten Sie diese Entwurfsinspektion wirklich löschen?',
    'delete_draft_inspection': 'Entwurfsinspektion löschen',
    'document_added': 'Dokument hinzugefügt',
    'document_name_placeholder': 'Dokumentname',
    'edit_unit_amenity': 'Einheitsausstattung bearbeiten',
    'failed_create_inspection': 'Inspektion konnte nicht erstellt werden',
    'failed_delete_inspection': 'Nur Entwurfsinspektionen können gelöscht werden',
    'failed_generate_invite_link': 'Einladungslink konnte nicht generiert werden',
    'failed_load_bookings': 'Buchungen konnten nicht geladen werden',
    'failed_load_inspections': 'Inspektionen konnten nicht geladen werden',
    'failed_save_checklist': 'Checkliste konnte nicht gespeichert werden',
    'failed_sign_inspection': 'Inspektion konnte nicht unterzeichnet werden',
    'failed_update_condition': 'Zustand konnte nicht aktualisiert werden',
    'fair': 'Mäßig',
    'inspection_completed': 'Inspektion als abgeschlossen markiert',
    'inspection_created': 'Inspektion erstellt',
    'inspection_deleted': 'Inspektion gelöscht',
    'inspection_notes_placeholder': 'Erste Beobachtungen oder Notizen…',
    'inspection_signed': 'Inspektion unterzeichnet',
    'investment': 'Investition',
    'item_notes_placeholder': 'Notizen für diesen Artikel hinzufügen…',
    'name_and_url_required': 'Name und URL sind erforderlich',
    'poor': 'Schlecht',
    'portal_link_copied': 'Portal-Einrichtungslink in die Zwischenablage kopiert',
    'prospect_email_placeholder': 'john@example.com',
    'prospect_name_placeholder': 'z.B. Max Mustermann',
    'prospect_phone_placeholder': '+964 770 000 0000',
    'sale_notes_placeholder': 'Optionale Notizen...',
    'search_apartment_placeholder': 'Wohnung suchen...',
    'search_inspections_placeholder': 'Nach Einheit, Gebäude oder Mieter suchen…',
    'search_owners_placeholder': 'Eigentümer nach Name, Telefon oder E-Mail suchen...',
    'search_unit_or_buyer': 'Einheit oder Käufer suchen...',
    'sign_inspection_message': 'Diese Inspektion als unterzeichnet markieren? Diese Aktion ist endgültig und kann nicht rückgängig gemacht werden.',
    'stat_available_to_sell': 'Zum Verkauf verfügbar',
    'stat_sold_units': 'Verkaufte Einheiten',
    'status_all': 'Alle',
    'status_available': 'Verfügbar',
    'status_sold': 'Verkauft',
    'uploaded_by': 'Hochgeladen von',

    'hw_record_violation': '1. Verstoß aufzeichnen',
    'hw_record_violation_desc': 'Protokollieren Sie einen Verstoß mit Typ, Schweregrad und optionaler Geldstrafe. Geldstrafe wird automatisch dem Mieter-Konto belastet.',
    'hw_issue_notice': '2. Formelle Benachrichtigung ausstellen',
    'hw_issue_notice_desc': 'Rechtliche Benachrichtigung anhängen und per E-Mail oder WhatsApp senden.',
    'hw_track_resolution': '3. Lösung verfolgen',
    'hw_track_resolution_desc': 'Status aktualisieren: bestätigt → eskaliert → gelöst. Vollständiger Prüfpfad wird geführt.',
    'hw_escalate': '4. Bei Bedarf eskalieren',
    'hw_escalate_desc': 'Eskalierte Verstöße können in den Ablauf für Zwangsräumungsanträge einfließen.',
    'notice_title_placeholder': 'z.B. Zahlen-oder-Räumen-Benachrichtigung — Miete fällig',
    'notice_body_placeholder': 'Geben Sie den vollständigen Text der rechtlichen Benachrichtigung ein...',
    'failed_to_load_tenants': 'Mieter konnten nicht geladen werden. Bitte überprüfen Sie Ihre Verbindung.',
    'please_select_tenant': 'Bitte wählen Sie zuerst einen Mieter aus',
    'title_is_required': 'Titel ist erforderlich',
    'violation_recorded_notice_sent': 'Verstoß aufgezeichnet — Benachrichtigung automatisch an Mieter gesendet',
    'violation_recorded': 'Verstoß aufgezeichnet',
    'error_creating_violation': 'Fehler beim Erstellen des Verstoßes',
    'select_tenant_placeholder': 'Mieter auswählen...',
    'violation_title_placeholder': 'z.B. Lärmbeschwerde — laute Musik nach Mitternacht',
    'violation_desc_placeholder': 'Beschreiben Sie den Verstoß im Detail...',
    'saving_ellipsis': 'Speichern...',
    'violation_status_open': 'Offen',
    'violation_status_acknowledged': 'Bestätigt',
    'violation_status_resolved': 'Gelöst',
    'violation_status_escalated': 'Eskaliert',
    'violation_status_closed': 'Geschlossen',
    'violation_type_noise': 'Lärm',
    'violation_type_pets': 'Haustiere',
    'violation_type_damage': 'Schaden',
    'violation_type_unauthorized_occupant': 'Unbefugter Bewohner',
    'violation_type_parking': 'Parken',
    'violation_type_smoking': 'Rauchen',
    'violation_type_cleanliness': 'Sauberkeit',
    'violation_type_lease_breach': 'Vertragsbruch',
    'violation_type_late_payment': 'Verspätete Zahlung',
    'violation_type_general': 'Allgemein',
    'violation_severity_warning': 'Warnung',
    'violation_severity_minor': 'Geringfügig',
    'violation_severity_major': 'Erheblich',
    'violation_severity_critical': 'Kritisch',
    'notice_type_pay_or_quit': 'Zahlen oder Räumen',
    'notice_type_cure_or_quit': 'Beheben oder Räumen',
    'notice_type_unconditional_quit': 'Bedingungsloses Räumen',
    'notice_type_entry_notice': 'Zutrittsbenachrichtigung',
    'notice_type_non_renewal': 'Keine Verlängerung',
    'notice_type_eviction_filing': 'Zwangsräumungsantrag',
    'notice_type_lease_termination': 'Mietvertragskündigung',
    'notice_type_rent_increase': 'Mieterhöhung',
    'notice_type_general': 'Allgemein',
    'delivery_method_email': 'E-Mail',
    'delivery_method_whatsapp': 'WhatsApp',
    'delivery_method_hand_delivered': 'Persönlich übergeben',
    'delivery_method_certified_mail': 'Einschreiben',
    'delivery_method_posted_on_door': 'An der Tür angebracht',
    'delivery_method_sms': 'SMS',
    'ev_reason_placeholder': 'Nicht-Zahlung der Miete, Vertragsverletzung, usw.',
    'select_placeholder': 'Auswählen...',
    'opening_ellipsis': 'Öffnen...',
    'err_loading_tenants': 'Fehler beim Laden der Mieter',
    'identity_link_opened': 'Link zur Identitätsverifizierung geöffnet — mit dem Mieter teilen',
    'failed_identity_verification': 'Identitätsverifizierung konnte nicht gestartet werden',
    'fcra_consent_required_toast': 'Sie müssen die FCRA-Zustimmung bestätigen, bevor Sie eine Hintergrundprüfung durchführen',
    'bg_invitation_sent': 'Einladung zur Hintergrundprüfung an die E-Mail des Mieters gesendet',
    'failed_bg_check': 'Hintergrundprüfung konnte nicht gestartet werden',
    'screening_decision_set': 'Screening-Entscheidung gesetzt auf: ',
    'failed_to_save_decision': 'Entscheidung konnte nicht gespeichert werden',
    'search_tenants_placeholder': 'Mieter suchen...',
    'loading_ellipsis': 'Laden...',
    'loading_screening_data': 'Screening-Daten werden geladen...',
    'dob_optional': 'Geburtsdatum (optional)',
    'zipcode_optional': 'Postleitzahl (optional)',
    'state_optional': 'Bundesland (optional)',
    'country_label': 'Land',
    'sending_ellipsis': 'Senden...',
    'send_to_tenant': 'An Mieter senden',
    'decision_label': 'Entscheidung',
    'add_notes_decision_placeholder': 'Fügen Sie Notizen zu dieser Entscheidung hinzu...',
    'save_decision': 'Entscheidung speichern',
    'badge_not_started': 'Nicht begonnen',
    'badge_verified': 'Verifiziert',
    'badge_action_needed': 'Aktion erforderlich',
    'badge_canceled': 'Abgebrochen',
    'badge_clear': 'Klar',
    'badge_consider': 'Zu bedenken',
    'badge_dispute': 'Streitig',
    'badge_suspended': 'Ausgesetzt',
    'badge_approved': 'Genehmigt',
    'badge_rejected': 'Abgelehnt',
    'badge_manual_review': 'Manuelle Prüfung',
}
};
